/* =========================================================
   LOOPSDIRECT UNDER CABINET LIGHTING PROJECT BUILDER
   MULTI-ZONE + NAMED ZONES + ACCESSORIES
   + FINAL REVIEW + PROJECT HELP + SHOPIFY CART
   + UNIQUE CART PROJECT IDs
   + EDIT EXISTING CART PROJECT
   + SENSOR PRODUCT IMAGES
   + STYLE PAGE LINKS FROM STYLE SELECTION
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  const builders =
    document.querySelectorAll('[data-ld-builder-section]');
  if (!builders.length) {
    return;
  }
  builders.forEach(function (root) {
    initialiseBuilder(root);
  });
  function initialiseBuilder(root) {
    const modal =
      root.querySelector('[data-ld-modal]');
    const overlay =
      root.querySelector('[data-ld-overlay]');
    const openButton =
      root.querySelector('[data-ld-open-builder]');
    const closeButton =
      root.querySelector('[data-ld-close-builder]');
    if (
      !modal ||
      !overlay ||
      !openButton ||
      !closeButton
    ) {
      return;
    }
    document.body.appendChild(overlay);
    document.body.appendChild(modal);
    /* =====================================================
       SCREENS
       ===================================================== */
    const screens = {
      zones:
        modal.querySelector(
          '[data-ld-screen="zones"]'
        ),
      zoneStart:
        modal.querySelector(
          '[data-ld-screen="zone-start"]'
        ),
      style:
        modal.querySelector(
          '[data-ld-screen="style"]'
        ),
      finish:
        modal.querySelector(
          '[data-ld-screen="finish"]'
        ),
      colour:
        modal.querySelector(
          '[data-ld-screen="colour"]'
        ),
      quantity:
        modal.querySelector(
          '[data-ld-screen="quantity"]'
        ),
      driver:
        modal.querySelector(
          '[data-ld-screen="driver"]'
        ),
      sensor:
        modal.querySelector(
          '[data-ld-screen="sensor"]'
        ),
      review:
        modal.querySelector(
          '[data-ld-screen="review"]'
        ),
      zoneMore:
        modal.querySelector(
          '[data-ld-screen="zone-more"]'
        ),
      accessories:
        modal.querySelector(
          '[data-ld-screen="accessories"]'
        ),
      projectReview:
        modal.querySelector(
          '[data-ld-screen="project-review"]'
        )
    };
    /* =====================================================
       STEP CONFIG
       ===================================================== */
    const STEP_ORDER = [
      {
        key: 'style',
        label: 'Style',
        screen: 'style'
      },
      {
        key: 'finish',
        label: 'Finish',
        screen: 'finish'
      },
      {
        key: 'colour',
        label: 'Colour',
        screen: 'colour'
      },
      {
        key: 'quantity',
        label: 'Quantity',
        screen: 'quantity'
      },
      {
        key: 'driver',
        label: 'Driver',
        screen: 'driver'
      },
      {
        key: 'sensor',
        label: 'Control',
        screen: 'sensor'
      },
      {
        key: 'accessories',
        label: 'Accessories',
        screen: 'accessories'
      },
      {
        key: 'review',
        label: 'Review',
        screen: 'review'
      }
    ];
    const STEP_SCREENS =
      STEP_ORDER
        .map(function (step) {
          return screens[step.screen];
        })
        .filter(Boolean);
    const ZONE_NAV_SCREENS =
      [screens.zoneStart]
        .concat(STEP_SCREENS)
        .concat([
          screens.zoneMore,
          screens.projectReview
        ])
        .filter(Boolean);
    /* =====================================================
       CREATE ZONE SHORTCUTS
       ===================================================== */
    function createZoneShortcutBars() {
      ZONE_NAV_SCREENS.forEach(function (screen) {
        if (
          screen.querySelector(
            '[data-ld-zone-shortcuts]'
          )
        ) {
          return;
        }
        const progress =
          screen.querySelector(
            '.ld-progress-wrap'
          );
        const nav =
          document.createElement('div');
        nav.className =
          'ld-zone-shortcuts';
        nav.setAttribute(
          'data-ld-zone-shortcuts',
          ''
        );
        nav.innerHTML =
          '<div class="ld-zone-shortcuts-top">' +
            '<div class="ld-zone-shortcuts-heading">' +
              '<span class="ld-zone-shortcuts-title">' +
                'Your Project' +
              '</span>' +
            '</div>' +
            '<div class="ld-project-identity-fields">' +
              '<label class="ld-project-identity-field">' +
                '<span>Project name <small>Optional</small></span>' +
                '<input type="text" maxlength="80" placeholder="e.g. Smith Kitchen / Plot 14" data-ld-top-project-name autocomplete="off">' +
              '</label>' +
              '<label class="ld-project-identity-field">' +
                '<span data-ld-top-zone-name-label>Zone 1 name <small>Optional</small></span>' +
                '<input type="text" maxlength="60" placeholder="e.g. Kitchen / Island" data-ld-top-zone-name autocomplete="off">' +
              '</label>' +
            '</div>' +
          '</div>' +
          '<div class="ld-zone-shortcuts-list" data-ld-zone-shortcuts-list></div>';
        const topProjectName =
          nav.querySelector(
            '[data-ld-top-project-name]'
          );
        if (topProjectName) {
          topProjectName.addEventListener(
            'input',
            function () {
              projectName =
                String(
                  topProjectName.value || ''
                )
                  .slice(
                    0,
                    80
                  );
              sessionStorage.setItem(
                PROJECT_NAME_KEY,
                projectName
              );
              updateProjectNameDisplay();
              updateProjectIdentityFields(topProjectName);
              if (screens.projectReview.classList.contains('is-active')) renderProjectReview();
            }
          );
          topProjectName.addEventListener(
            'blur',
            function () {
              projectName =
                cleanProjectName(
                  topProjectName.value
                );
              saveProjectName();
              updateProjectNameDisplay();
              updateProjectIdentityFields();
            }
          );
        }
        const topZoneName =
          nav.querySelector(
            '[data-ld-top-zone-name]'
          );
        if (topZoneName) {
          topZoneName.addEventListener(
            'input',
            function () {
              state.name =
                String(
                  topZoneName.value || ''
                )
                  .slice(
                    0,
                    60
                  );
              saveProject();
              updateProjectIdentityFields(
                topZoneName
              );
              updateReview();
            }
          );
          topZoneName.addEventListener(
            'blur',
            function () {
              state.name =
                String(
                  topZoneName.value || ''
                )
                  .replace(
                    /\s+/g,
                    ' '
                  )
                  .trim()
                  .slice(
                    0,
                    60
                  );
              saveProject();
              updateProjectIdentityFields();
              updateReview();
              if (
                screens.zoneMore &&
                screens.zoneMore.classList.contains(
                  'is-active'
                )
              ) {
                renderZoneMore();
              }
              if (
                screens.projectReview &&
                screens.projectReview.classList.contains(
                  'is-active'
                )
              ) {
                renderProjectReview();
              }
            }
          );
        }
        if (progress) {
          screen.insertBefore(
            nav,
            progress
          );
        } else {
          screen.insertBefore(
            nav,
            screen.firstChild
          );
        }
      });
    }
    /* =====================================================
       CREATE STEP NAVIGATION
       ===================================================== */
    function createStepNavigationBars() {
      STEP_SCREENS.forEach(function (screen) {
        if (
          screen.querySelector(
            '[data-ld-step-navigation]'
          )
        ) {
          return;
        }
        const progress =
          screen.querySelector(
            '.ld-progress-wrap'
          );
        if (!progress) {
          return;
        }
        const nav =
          document.createElement('div');
        nav.className =
          'ld-step-navigation';
        nav.setAttribute(
          'data-ld-step-navigation',
          ''
        );
        nav.innerHTML =
          '<div class="ld-step-navigation-top">' +
            '<span class="ld-step-navigation-title" data-ld-step-navigation-title>' +
              'Zone progress' +
            '</span>' +
            '<span class="ld-step-navigation-help">' +
              'Jump to any available step' +
            '</span>' +
          '</div>' +
          '<div class="ld-step-navigation-list" data-ld-step-navigation-list></div>';
        screen.insertBefore(
          nav,
          progress
        );
        progress.classList.add(
          'is-replaced'
        );
      });
    }
    createZoneShortcutBars();
    createStepNavigationBars();
    /* =====================================================
       STORAGE
       ===================================================== */
    const PROJECT_KEY =
      'ldLightingProjectZonesV4';
    const LEGACY_PROJECT_KEYS = [
      'ldLightingProjectZonesV3',
      'ldLightingProjectZonesV2'
    ];
    const CURRENT_ZONE_KEY =
      'ldLightingCurrentZoneV4';
    const LEGACY_CURRENT_ZONE_KEYS = [
      'ldLightingCurrentZoneV3',
      'ldLightingCurrentZoneV2'
    ];
    const HIGHEST_ZONE_KEY =
      'ldLightingHighestZoneV4';
    const LEGACY_HIGHEST_ZONE_KEYS = [
      'ldLightingHighestZoneV3',
      'ldLightingHighestZoneV2'
    ];
    const ACCESSORY_KEY =
      'ldLightingAccessoriesV2';
    const PROJECT_NAME_KEY =
      'ldLightingProjectNameV1';
    const SAVED_CART_PROJECTS_KEY =
      'ldLightingSavedCartProjectsV1';
    const EDIT_REQUEST_KEY =
      'ldLightingEditProjectRequestV1';
    function detectStartingStyle() {
      const path =
        String(
          window.location.pathname || ''
        ).toLowerCase();
      const pageStyles = {
        'round-recessed-under-cabinet-lighting': 'round-recessed',
        'round-surface-under-cabinet-lighting': 'round-surface',
        'round-slim-surface-under-cabinet-lighting': 'round-slim-surface',
        'triangle-under-cabinet-lighting': 'triangle',
        'square-under-cabinet-lighting': 'square',
        'rectangle-under-cabinet-lighting': 'rectangle',
        'long-rectangle-1-under-cabinet-lighting': 'long-rectangle-1',
        'long-rectangle-2-under-cabinet-lighting': 'long-rectangle-2'
      };
      const matchedHandle =
        Object.keys(pageStyles)
          .find(function (handle) {
            return path.replace(/\/$/, '').split('/').pop() === handle;
          });
      if (matchedHandle) {
        return pageStyles[matchedHandle];
      }
      return (
        root.dataset.startingStyle ||
        'round-recessed'
      );
    }
    const startingStyle =
      detectStartingStyle();
    /* =====================================================
       PRODUCT DATA
       ===================================================== */
    const styleCatalog = {
      'round-recessed': {
        name: 'Eclipse — Recessed Round',
        description: 'Flush, discreet recessed finish',
        mounting: 'Recessed',
        dimensions: 'Ø65 × 14mm · Cut-out Ø58mm',
        cableLength: '2m',
        pageUrl: '/products/round-recessed-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2426al_main.jpg?v=1789662723'
      },
      'round-surface': {
        name: 'Aurelia — Surface Round',
        description: 'Classic surface-mounted round light',
        mounting: 'Surface Mounted',
        dimensions: 'Ø65 × 16mm',
        cableLength: '2m',
        pageUrl: '/products/round-surface-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2434al_main.png'
      },
      'round-slim-surface': {
        name: 'Vela — Slim Surface Round',
        description: 'Ultra-slim, low-profile round design',
        mounting: 'Surface Mounted',
        dimensions: 'Ø75 × 6.5mm',
        cableLength: '2m',
        pageUrl: '/products/round-slim-surface-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2431_main.png'
      },
      'triangle': {
        name: 'Prism — Triangle',
        description: 'Angled profile for cabinet edges and corners',
        mounting: 'Surface Mounted',
        dimensions: '170 × 140 × 26mm',
        cableLength: '2m',
        pageUrl: '/products/triangle-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2435al_main.png'
      },
      'square': {
        name: 'Elara — Square',
        description: 'Clean, contemporary square design',
        mounting: 'Surface Mounted',
        dimensions: '100 × 100 × 8.5mm',
        cableLength: '2m',
        pageUrl: '/products/square-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2407ww_main.png'
      },
      'rectangle': {
        name: 'Linea Compact — Rectangle',
        description: 'Compact linear under-cabinet design',
        mounting: 'Surface Mounted',
        dimensions: '175 × 50 × 6.8mm',
        cableLength: '2m',
        pageUrl: '/products/rectangle-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2428al_main_9cd01065-07dd-473b-aad3-a898cbeb5b72.jpg?v=1789662741'
      },
      'long-rectangle-1': {
        name: 'Linea Select — CCT Linear',
        description: 'Slim 200mm linear CCT cabinet light',
        mounting: 'Surface Mounted',
        dimensions: '200 × 40 × 6.8mm',
        cableLength: '2m',
        pageUrl: '/products/long-rectangle-1-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2429al_main.png'
      },
      'long-rectangle-2': {
        name: 'Linea Pure — Fixed White Linear',
        description: 'Long linear fixed-colour light',
        mounting: 'Surface Mounted',
        dimensions: '200 × 40 × 6.5mm',
        cableLength: '2m',
        pageUrl: '/products/long-rectangle-2-under-cabinet-lighting',
        image: 'https://cdn.shopify.com/s/files/1/0532/8689/5812/files/sy2408ww_main.png'
      }
    };

    /* =====================================================
       VERIFIED PLANNING GUIDANCE
       Only add figures here when they have been approved for
       that exact light style. Never reuse Aurelia spacing
       figures for another range without verification.
       ===================================================== */
    const universalPlanningGuidance = {
      position: '30–50mm',
      beam: '120°'
    };

    const planningGuidance = {
      'round-surface': {
        spacing: '250–300mm',
        spacingNote: 'between light centres',
        spacingCopy:
          'Start at 250–300mm centres and keep the row of lights consistently positioned towards the front of the cabinet. Move them closer together for a stronger, more continuous task-light effect.'
      }
    };

    const lightProducts = {
      'round-recessed': {
        aluminium: {
          cct: {
            sku: 'wb0001',
            price: 13.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-recessed-under-cabinet-light-aluminium-cct-white-wb0001'
          },
          warm: {
            sku: 'wb0018',
            price: 5.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-recessed-under-cabinet-light-aluminium-warm-white-wb0018'
          },
          natural: {
            sku: 'wb0019',
            price: 5.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-recessed-under-cabinet-light-aluminium-natural-white-wb0019'
          },
          cool: {
            sku: 'wb0020',
            price: 5.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-recessed-under-cabinet-light-aluminium-cool-white-wb0020'
          }
        },
        black: {
          cct: {
            sku: 'wb0002',
            price: 13.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-recessed-under-cabinet-light-black-cct-white-wb0002'
          }
        },
        brass: {
          cct: {
            sku: 'wb0003',
            price: 17.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-recessed-under-cabinet-light-brass-cct-white-wb0003'
          }
        }
      },
      'round-surface': {
        aluminium: {
          cct: {
            sku: 'wb0004',
            price: 15.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-surface-under-cabinet-light-aluminium-cct-white-wb0004'
          },
          warm: {
            sku: 'wb0021',
            price: 7.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-surface-under-cabinet-light-aluminium-warm-white-wb0021'
          },
          natural: {
            sku: 'wb0022',
            price: 7.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-surface-under-cabinet-light-aluminium-natural-white-wb0022'
          },
          cool: {
            sku: 'wb0023',
            price: 7.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-surface-under-cabinet-light-aluminium-cool-white-wb0023'
          }
        },
        black: {
          cct: {
            sku: 'wb0005',
            price: 15.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-surface-under-cabinet-light-black-cct-white-wb0005'
          }
        },
        brass: {
          cct: {
            sku: 'wb0006',
            price: 19.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-round-surface-under-cabinet-light-brass-cct-white-wb0006'
          }
        }
      },
      'round-slim-surface': {
        aluminium: {
          cct: {
            sku: 'wb0016',
            price: 10.49,
            watts: 1.8,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-aluminium-cct-white-wb0016'
          },
          warm: {
            sku: 'wb0036',
            price: 6.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-aluminium-warm-white-wb0036'
          },
          natural: {
            sku: 'wb0037',
            price: 6.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-aluminium-natural-white-wb0037'
          },
          cool: {
            sku: 'wb0038',
            price: 6.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-aluminium-cool-white-wb0038'
          }
        },
        black: {
          cct: {
            sku: 'wb0017',
            price: 10.49,
            watts: 1.8,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-black-cct-white-wb0017'
          },
          warm: {
            sku: 'wb0039',
            price: 8.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-black-warm-white-wb0039'
          },
          natural: {
            sku: 'wb0040',
            price: 8.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-black-natural-white-wb0040'
          },
          cool: {
            sku: 'wb0041',
            price: 8.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-black-cool-white-wb0041'
          }
        },
        white: {
          warm: {
            sku: 'wb0042',
            price: 8.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-white-warm-white-wb0042'
          },
          natural: {
            sku: 'wb0043',
            price: 8.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-white-natural-white-wb0043'
          },
          cool: {
            sku: 'wb0044',
            price: 8.49,
            watts: 2,
            dimmable: true,
            handle:
              '24v-round-slim-surface-under-cabinet-light-white-cool-white-wb0044'
          }
        }
      },
      'triangle': {
        aluminium: {
          cct: {
            sku: 'wb0007',
            price: 19.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-triangle-under-cabinet-light-aluminium-cct-white-wb0007'
          },
          warm: {
            sku: 'wb0024',
            price: 8.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-triangle-under-cabinet-light-aluminium-warm-white-wb0024'
          },
          natural: {
            sku: 'wb0025',
            price: 8.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-triangle-under-cabinet-light-aluminium-natural-white-wb0025'
          },
          cool: {
            sku: 'wb0026',
            price: 8.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-triangle-under-cabinet-light-aluminium-cool-white-wb0026'
          }
        },
        black: {
          cct: {
            sku: 'wb0008',
            price: 22.99,
            watts: 2.3,
            dimmable: true,
            handle:
              '24v-triangle-under-cabinet-light-black-cct-white-wb0008'
          }
        }
      },
      'square': {
        aluminium: {
          cct: {
            sku: 'wb0014',
            price: 10.49,
            watts: 3,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-aluminium-cct-white-wb0014'
          },
          warm: {
            sku: 'wb0027',
            price: 9.99,
            watts: 3.5,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-aluminium-warm-white-wb0027'
          },
          natural: {
            sku: 'wb0028',
            price: 9.99,
            watts: 3.5,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-aluminium-natural-white-wb0028'
          },
          cool: {
            sku: 'wb0029',
            price: 9.99,
            watts: 3.5,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-aluminium-cool-white-wb0029'
          }
        },
        black: {
          cct: {
            sku: 'wb0015',
            price: 10.49,
            watts: 3,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-black-cct-white-wb0015'
          },
          warm: {
            sku: 'wb0030',
            price: 11.49,
            watts: 3.5,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-black-warm-white-wb0030'
          },
          natural: {
            sku: 'wb0031',
            price: 11.49,
            watts: 3.5,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-black-natural-white-wb0031'
          },
          cool: {
            sku: 'wb0032',
            price: 11.49,
            watts: 3.5,
            dimmable: true,
            handle:
              '24v-square-under-cabinet-light-black-cool-white-wb0032'
          }
        }
      },
      'rectangle': {
        aluminium: {
          cct: {
            sku: 'wb0009',
            price: 16.49,
            watts: 4,
            dimmable: false,
            handle:
              '24v-rectangle-under-cabinet-light-aluminium-cct-white-wb0009'
          }
        },
        black: {
          cct: {
            sku: 'wb0010',
            price: 16.49,
            watts: 4,
            dimmable: false,
            handle:
              '24v-rectangle-under-cabinet-light-black-cct-white-wb0010'
          }
        },
        brass: {
          cct: {
            sku: 'wb0011',
            price: 16.49,
            watts: 4,
            dimmable: false,
            handle:
              '24v-rectangle-under-cabinet-light-brass-cct-white-wb0011'
          }
        }
      },
      'long-rectangle-1': {
        aluminium: {
          cct: {
            sku: 'wb0012',
            price: 18.49,
            watts: 4,
            dimmable: false,
            handle:
              '24v-long-rectangle-1-under-cabinet-light-aluminium-cct-white-wb0012'
          }
        },
        black: {
          cct: {
            sku: 'wb0013',
            price: 18.49,
            watts: 4,
            dimmable: false,
            handle:
              '24v-long-rectangle-1-under-cabinet-light-black-cct-white-wb0013'
          }
        }
      },
      'long-rectangle-2': {
        aluminium: {
          warm: {
            sku: 'wb0033',
            price: 14.99,
            watts: 4,
            dimmable: false,
            handle:
              '24v-long-rectangle-2-under-cabinet-light-aluminium-warm-white-wb0033'
          },
          natural: {
            sku: 'wb0034',
            price: 14.99,
            watts: 4,
            dimmable: false,
            handle:
              '24v-long-rectangle-2-under-cabinet-light-aluminium-natural-white-wb0034'
          },
          cool: {
            sku: 'wb0035',
            price: 14.99,
            watts: 4,
            dimmable: false,
            handle:
              '24v-long-rectangle-2-under-cabinet-light-aluminium-cool-white-wb0035'
          }
        }
      }
    };
    function wattageNumberLabel(value) {
      const number =
        Number(
          value
        );
      if (
        !Number.isFinite(
          number
        )
      ) {
        return '';
      }
      return Number.isInteger(
        number
      )
        ? String(
            number
          )
        : String(
            number
          )
            .replace(
              /0+$/,
              ''
            )
            .replace(
              /\.$/,
              ''
            );
    }
    function styleWattageSummary(
      styleKey
    ) {
      const styleProducts =
        lightProducts[
          styleKey
        ];
      if (!styleProducts) {
        return '';
      }
      const wattages =
        [];
      Object.keys(
        styleProducts
      )
        .forEach(function (
          finishKey
        ) {
          const finishProducts =
            styleProducts[
              finishKey
            ] || {};
          Object.keys(
            finishProducts
          )
            .forEach(function (
              colourKey
            ) {
              const product =
                finishProducts[
                  colourKey
                ];
              const watts =
                product
                  ? Number(
                      product.watts
                    )
                  : NaN;
              if (
                Number.isFinite(
                  watts
                ) &&
                wattages.indexOf(
                  watts
                ) === -1
              ) {
                wattages.push(
                  watts
                );
              }
            });
        });
      wattages.sort(function (
        a,
        b
      ) {
        return a - b;
      });
      if (!wattages.length) {
        return '';
      }
      if (
        wattages.length === 1
      ) {
        return (
          wattageNumberLabel(
            wattages[0]
          ) +
          'W per light'
        );
      }
      return (
        wattageNumberLabel(
          wattages[0]
        ) +
        '–' +
        wattageNumberLabel(
          wattages[
            wattages.length - 1
          ]
        ) +
        'W per light · varies by colour temperature'
      );
    }
    function finishesForStyle(
      styleKey
    ) {
      if (
        !styleKey ||
        !lightProducts[
          styleKey
        ]
      ) {
        return [];
      }
      return Object.keys(
        lightProducts[
          styleKey
        ]
      );
    }
    function styleFinishSwatchesMarkup(
      styleKey
    ) {
      const finishes =
        finishesForStyle(
          styleKey
        );
      if (!finishes.length) {
        return '';
      }
      return (
        '<span class="ld-style-finish-swatches" data-ld-style-finish-swatches>' +
          '<span class="ld-style-finish-swatches-label">Finishes</span>' +
          finishes
            .map(function (
              finishKey
            ) {
              const name =
                finishName(
                  finishKey
                );
              return (
                '<span ' +
                  'class="ld-style-finish-swatch is-' +
                    escapeHtml(
                      finishKey
                    ) +
                  '" ' +
                  'data-ld-style-finish-preview="' +
                    escapeHtml(
                      finishKey
                    ) +
                  '" ' +
                  'title="Preview ' +
                    escapeHtml(
                      name
                    ) +
                  '" ' +
                  'aria-label="Preview ' +
                    escapeHtml(
                      name
                    ) +
                  ' finish"' +
                '></span>'
              );
            })
            .join(
              ''
            ) +
        '</span>'
      );
    }
    const drivers = [
      {
        watts: 8,
        ports: 4,
        price: 24.99,
        sku: 'wb0045',
        handle:
          '24v-led-driver-8w-4-port-wb0045'
      },
      {
        watts: 15,
        ports: 6,
        price: 29.99,
        sku: 'wb0046',
        handle:
          '24v-led-driver-15w-6-port-wb0046'
      },
      {
        watts: 30,
        ports: 6,
        price: 39.99,
        sku: 'wb0047',
        handle:
          '24v-led-driver-30w-6-port-wb0047'
      },
      {
        watts: 60,
        ports: 6,
        price: 49.99,
        sku: 'wb0048',
        handle:
          '24v-led-driver-60w-6-port-wb0048'
      },
      {
        watts: 100,
        ports: 6,
        price: 69.99,
        sku: 'wb0049',
        handle:
          '24v-led-driver-100w-6-port-wb0049'
      },
      {
        watts: 150,
        ports: 6,
        price: 79.99,
        sku: 'wb0050',
        handle:
          '24v-led-driver-150w-6-port-wb0050'
      }
    ];
    const distributionBlock = {
      sku: 'wb0058',
      handle:
        '24v-6-way-driver-distribution-block-wb0058',
      price: 2.49
    };
    const ukPlugCable = {
      sku: 'wb0057',
      handle:
        '2m-uk-plug-power-cable-upgrade-for-24v-led-driver-wb0057',
      price: 3.99
    };
    const sensors = {
      touch: {
        sku: 'wb0053',
        handle:
          '24v-touch-dimmer-sensor-wb0053',
        name:
          'Touch On/Off & Dimmer Sensor',
        price: 14.99
      },
      pir: {
        sku: 'wb0054',
        handle:
          '24v-pir-sensor-wb0054',
        name:
          'PIR Sensor',
        price: 17.49
      },
      'single-door': {
        sku: 'wb0055',
        handle:
          '24v-single-door-sensor-wb0055',
        name:
          'Single Door Sensor',
        price: 14.99
      },
      'double-door': {
        sku: 'wb0056',
        handle:
          '24v-double-door-sensor-wb0056',
        name:
          'Double Door Sensor',
        price: 19.99
      },
      none: {
        sku: '',
        handle: '',
        name:
          'No Sensor',
        price: 0
      }
    };
    const accessoryProducts = {
      extension2: {
        sku: 'wb0051',
        handle:
          '24v-light-to-driver-extension-cable-2m-wb0051',
        price: 1.49,
        name:
          '2m Extension Lead'
      },
      extension5: {
        sku: 'wb0052',
        handle:
          '24v-light-to-driver-extension-cable-5m-wb0052',
        price: 2.49,
        name:
          '5m Extension Lead'
      },
      wago2: {
        sku: 'wb0059',
        handle:
          '2-way-wago-connector-wb0059',
        price: 0.79,
        name:
          '2 Way WAGO Connector'
      },
      wago3: {
        sku: 'wb0060',
        handle:
          '3-way-wago-connector-wb0060',
        price: 0.89,
        name:
          '3 Way WAGO Connector'
      }
    };
    const sensorHelp = {
      touch: {
        title:
          'Touch On/Off & Dimmer',
        bestFor:
          'Best for everyday kitchen lighting',
        intro:
          'Tap to switch the entire zone on or off, then touch and hold to adjust brightness. The sensor remembers your last brightness level when the lights are switched back on.',
        facts: [
          'On / off + dimming',
          'Brightness memory',
          'Whole-zone control',
          '2m fitted cable'
        ],
        installation:
          'Includes a surface-mount adapter. The sensor head can also be recessed using a 12mm cut-out.'
      },
      pir: {
        title:
          'PIR Occupancy Sensor',
        bestFor:
          'Best for hands-free lighting',
        intro:
          'Walk into the detection area and the whole zone comes on automatically. The lights stay on while movement continues, then switch off around 30 seconds after movement stops.',
        facts: [
          '1–3m detection range',
          '90° detection angle',
          '30s hold',
          '2m fitted cable'
        ],
        installation:
          'Includes a surface-mount adapter. The sensor head can also be recessed using a 12mm cut-out.'
      },
      'single-door': {
        title:
          'Single Door Sensor',
        bestFor:
          'Best for single-door cupboards',
        intro:
          'Open the cabinet door and the whole lighting zone switches on automatically. Close the door and the lights switch off again.',
        facts: [
          '1–3cm sensing range',
          'Automatic operation',
          'Whole-zone control',
          '2m fitted cable'
        ],
        installation:
          'Includes a surface-mount adapter. Position the sensor so the closed door sits within the 1–3cm sensing range.'
      },
      'double-door': {
        title:
          'Double Door Sensor',
        bestFor:
          'Best for double-door cupboards',
        intro:
          'Either of two independently opening doors can operate the same lighting zone, so opening either door can bring the lights on.',
        facts: [
          '1–3cm sensing range',
          'Either door activates',
          'Whole-zone control',
          '2m fitted cable'
        ],
        installation:
          'Includes a surface-mount adapter. Designed for two independently opening doors controlled through one driver.'
      },
      none: {
        title:
          'No Sensor',
        bestFor:
          'Best for conventional switching',
        intro:
          'No separate 24V sensor is required when you simply want on/off control from your chosen mains switching method. The supplied driver must not be connected to a mains wall dimmer.',
        facts: [
          'No extra sensor',
          'No extra cost',
          'Whole-zone switching',
          'Simple setup'
        ],
        installation:
          ''
      }
    };
    /* =====================================================
       GENERAL HELPERS
       ===================================================== */
    function money(value) {
      return (
        '£' +
        Number(
          value || 0
        ).toFixed(2)
      );
    }
    function tidyWatts(value) {
      return (
        Number(
          value || 0
        )
          .toFixed(1)
          .replace('.0', '') +
        'W'
      );
    }
    function styleName(value) {
      return (
        styleCatalog[value]
          ? styleCatalog[value].name
          : ''
      );
    }
    function finishName(value) {
      if (!value) {
        return '';
      }
      return (
        value
          .charAt(0)
          .toUpperCase() +
        value.slice(1)
      );
    }
    function colourName(value) {
      const names = {
        cct:
          'Colour Changing White (CCT)',
        warm:
          'Warm White',
        natural:
          'Natural White',
        cool:
          'Cool White'
      };
      return (
        names[value] || ''
      );
    }

    function fittedCableMetresFor(styleKey, colourKey) {
      if (
        styleKey === 'square' &&
        colourKey &&
        colourKey !== 'cct'
      ) {
        return 1.5;
      }
      const details =
        styleCatalog[styleKey] || {};
      return Math.max(
        0,
        parseFloat(
          details.cableLength ||
          '2'
        ) || 2
      );
    }
    function fittedCableLabelFor(styleKey, colourKey) {
      const metres =
        fittedCableMetresFor(
          styleKey,
          colourKey
        );
      return (
        Number.isInteger(metres)
          ? String(metres)
          : String(
              Math.round(
                metres * 10
              ) / 10
            )
      ) + 'm';
    }
    function styleCableSummaryFor(styleKey) {
      if (styleKey === 'square') {
        return '2m CCT · 1.5m fixed-white';
      }
      const details =
        styleCatalog[styleKey] || {};
      return details.cableLength || '2m';
    }
    function updateStyleSpecificColourCopy() {
      const isElara =
        state.style === 'square';
      const isLineaCompact =
        state.style === 'rectangle';
      const isLineaSelect =
        state.style === 'long-rectangle-1';
      const isLineaPure =
        state.style === 'long-rectangle-2';

      const elara = {
        cct: {
          kelvin: '3000K · 4000K · 6000K',
          description: '3W · 250–260lm · 2m cable. Choose 3000K, 4000K or 6000K using the selector beneath the removable magnetic bezel. The setting remains accessible after installation.'
        },
        warm: {
          kelvin: '3000K fixed white',
          description: '3.5W · 290lm · 1.5m cable. A softer, warmer white for a comfortable and inviting feel.'
        },
        natural: {
          kelvin: '4000K fixed white',
          description: '3.5W · 295lm · 1.5m cable. A balanced neutral white that keeps colours looking natural.'
        },
        cool: {
          kelvin: '6000K fixed white',
          description: '3.5W · 300lm · 1.5m cable. A cooler, crisper white appearance for a clean and modern look.'
        }
      };

      const lineaCompact = {
        cct: {
          kelvin: '2700K · 4000K · 6000K',
          description: '4W · 224–255lm · 2m cable. Choose 2700K, 4000K or 6000K using the CCT button on the face of the fitting. The setting remains accessible after installation without removing the light.'
        }
      };

      const lineaSelect = {
        cct: {
          kelvin: '2700K · 4000K · 6000K',
          description: '4W · 230–270lm · 2m cable. Choose 2700K, 4000K or 6000K using the CCT button on the face of the fitting. The setting remains accessible after installation without removing the light.'
        }
      };

      const lineaPure = {
        warm: {
          kelvin: '3000K fixed white',
          description: '4W · 290lm · 2m cable. Fixed Warm White for a softer, warmer appearance.'
        },
        natural: {
          kelvin: '4000K fixed white',
          description: '4W · 295lm · 2m cable. Fixed Natural White for a clean, balanced everyday light.'
        },
        cool: {
          kelvin: '6000K fixed white',
          description: '4W · 300lm · 2m cable. Fixed Cool White for a crisp, contemporary appearance.'
        }
      };

      modal
        .querySelectorAll(
          '.ld-colour-card'
        )
        .forEach(function (card) {
          const key =
            card.dataset.colour;
          const kelvin =
            card.querySelector(
              '.ld-colour-kelvin'
            );
          const description =
            card.querySelector(
              '.ld-colour-card-description'
            );

          if (kelvin) {
            if (
              typeof kelvin.dataset.ldDefaultText ===
              'undefined'
            ) {
              kelvin.dataset.ldDefaultText =
                kelvin.textContent || '';
            }
            if (isElara && elara[key]) {
              kelvin.textContent =
                elara[key].kelvin;
            } else if (
              isLineaCompact &&
              lineaCompact[key]
            ) {
              kelvin.textContent =
                lineaCompact[key].kelvin;
            } else if (
              isLineaSelect &&
              lineaSelect[key]
            ) {
              kelvin.textContent =
                lineaSelect[key].kelvin;
            } else if (
              isLineaPure &&
              lineaPure[key]
            ) {
              kelvin.textContent =
                lineaPure[key].kelvin;
            } else {
              kelvin.textContent =
                kelvin.dataset.ldDefaultText;
            }
          }

          if (description) {
            if (
              typeof description.dataset.ldDefaultText ===
              'undefined'
            ) {
              description.dataset.ldDefaultText =
                description.textContent || '';
            }
            if (isElara && elara[key]) {
              description.textContent =
                elara[key].description;
            } else if (
              isLineaCompact &&
              lineaCompact[key]
            ) {
              description.textContent =
                lineaCompact[key].description;
            } else if (
              isLineaSelect &&
              lineaSelect[key]
            ) {
              description.textContent =
                lineaSelect[key].description;
            } else if (
              isLineaPure &&
              lineaPure[key]
            ) {
              description.textContent =
                lineaPure[key].description;
            } else {
              description.textContent =
                description.dataset.ldDefaultText;
            }
          }
        });

      const guide =
        modal.querySelector(
          '[data-ld-colour-help-panel]'
        );
      if (!guide) {
        return;
      }
      const choices =
        guide.querySelectorAll(
          '.ld-colour-help-choice'
        );
      if (choices.length >= 4) {
        // Linea Compact and Linea Select are CCT-only, so their guides hide
        // the separate fixed-white product examples. Linea Pure is fixed-white
        // only, so its guide does the opposite: hide CCT and show Warm/Natural/Cool.
        choices[0].hidden = isLineaPure;
        if (isLineaPure) {
          choices[0].setAttribute('aria-hidden', 'true');
        } else {
          choices[0].removeAttribute('aria-hidden');
        }

        [choices[1], choices[2], choices[3]].forEach(function (choice) {
          if (!choice) {
            return;
          }
          choice.hidden = isLineaCompact || isLineaSelect;
          if (isLineaCompact || isLineaSelect) {
            choice.setAttribute('aria-hidden', 'true');
          } else {
            choice.removeAttribute('aria-hidden');
          }
        });

        const cctSmall =
          choices[0].querySelector('small');
        const cctParagraph =
          choices[0].querySelector('p');
        const warmSmall =
          choices[1].querySelector('small');
        const warmParagraph =
          choices[1].querySelector('p');
        const naturalSmall =
          choices[2].querySelector('small');
        const naturalParagraph =
          choices[2].querySelector('p');
        const coolSmall =
          choices[3].querySelector('small');
        const coolParagraph =
          choices[3].querySelector('p');
        const elements = [
          cctSmall,
          cctParagraph,
          warmSmall,
          warmParagraph,
          naturalSmall,
          naturalParagraph,
          coolSmall,
          coolParagraph
        ];

        elements.forEach(function (element) {
          if (
            element &&
            typeof element.dataset.ldDefaultText ===
              'undefined'
          ) {
            element.dataset.ldDefaultText =
              element.textContent || '';
          }
        });

        if (cctSmall) {
          if (isElara) {
            cctSmall.textContent =
              '3000K · 4000K · 6000K';
          } else if (isLineaCompact || isLineaSelect) {
            cctSmall.textContent =
              '2700K · 4000K · 6000K';
          } else {
            cctSmall.textContent =
              cctSmall.dataset.ldDefaultText;
          }
        }
        if (warmSmall) {
          if (isElara) {
            warmSmall.textContent =
              '3000K fixed white';
          } else if (isLineaCompact || isLineaSelect) {
            warmSmall.textContent =
              '2700K · Warm setting';
          } else if (isLineaPure) {
            warmSmall.textContent =
              '3000K fixed white';
          } else {
            warmSmall.textContent =
              warmSmall.dataset.ldDefaultText;
          }
        }
        if (warmParagraph) {
          if (isLineaCompact) {
            warmParagraph.textContent =
              'The warmest setting within the same Linea Compact CCT fitting. Ideal for warmer finishes and a softer atmosphere.';
          } else if (isLineaSelect) {
            warmParagraph.textContent =
              'The warmest setting within the same Linea Select CCT fitting. Ideal for warmer finishes and a softer atmosphere.';
          } else if (isLineaPure) {
            warmParagraph.textContent =
              'Warm White is a separate fixed-white Linea Pure product: 3000K, 4W and 290lm. Choose it before ordering for a softer, warmer appearance.';
          } else {
            warmParagraph.textContent =
              warmParagraph.dataset.ldDefaultText;
          }
        }
        if (naturalSmall) {
          if (isElara) {
            naturalSmall.textContent =
              '4000K fixed white';
          } else if (isLineaCompact || isLineaSelect) {
            naturalSmall.textContent =
              '4000K · Natural setting';
          } else if (isLineaPure) {
            naturalSmall.textContent =
              '4000K fixed white';
          } else {
            naturalSmall.textContent =
              naturalSmall.dataset.ldDefaultText;
          }
        }
        if (naturalParagraph) {
          if (isLineaCompact) {
            naturalParagraph.textContent =
              'The balanced 4000K setting within the same Linea Compact CCT fitting. A strong everyday choice for kitchen task lighting.';
          } else if (isLineaSelect) {
            naturalParagraph.textContent =
              'The balanced 4000K setting within the same Linea Select CCT fitting. A strong everyday choice for kitchen task lighting.';
          } else if (isLineaPure) {
            naturalParagraph.textContent =
              'Natural White is a separate fixed-white Linea Pure product: 4000K, 4W and 295lm. A balanced everyday choice for kitchen task lighting.';
          } else {
            naturalParagraph.textContent =
              naturalParagraph.dataset.ldDefaultText;
          }
        }
        if (coolSmall) {
          if (isElara) {
            coolSmall.textContent =
              '6000K fixed white';
          } else if (isLineaCompact || isLineaSelect) {
            coolSmall.textContent =
              '6000K · Cool setting';
          } else if (isLineaPure) {
            coolSmall.textContent =
              '6000K fixed white';
          } else {
            coolSmall.textContent =
              coolSmall.dataset.ldDefaultText;
          }
        }
        if (coolParagraph) {
          if (isLineaCompact) {
            coolParagraph.textContent =
              'The coolest 6000K setting within the same Linea Compact CCT fitting. Choose it for a crisp, contemporary appearance.';
          } else if (isLineaSelect) {
            coolParagraph.textContent =
              'The coolest 6000K setting within the same Linea Select CCT fitting. Choose it for a crisp, contemporary appearance.';
          } else if (isLineaPure) {
            coolParagraph.textContent =
              'Cool White is a separate fixed-white Linea Pure product: 6000K, 4W and 300lm. Choose it for a crisp, contemporary appearance.';
          } else {
            coolParagraph.textContent =
              coolParagraph.dataset.ldDefaultText;
          }
        }
        if (cctParagraph) {
          if (isElara) {
            cctParagraph.textContent =
              'Choose 3000K, 4000K or 6000K using the selector beneath the removable magnetic bezel. The setting remains accessible after installation.';
          } else if (isLineaCompact) {
            cctParagraph.textContent =
              'Choose 2700K, 4000K or 6000K using the CCT button on the face of the Linea Compact fitting. The setting remains accessible after installation without removing the light.';
          } else if (isLineaSelect) {
            cctParagraph.textContent =
              'Choose 2700K, 4000K or 6000K using the CCT button on the face of the Linea Select fitting. The setting remains accessible after installation without removing the light.';
          } else if (isLineaPure) {
            cctParagraph.textContent =
              'Linea Pure is fixed-white only and does not use a CCT selector. Choose Warm White 3000K, Natural White 4000K or Cool White 6000K before ordering.';
          } else {
            cctParagraph.textContent =
              cctParagraph.dataset.ldDefaultText;
          }
        }
      }

      const recommendation =
        guide.querySelector(
          '.ld-colour-help-recommendation'
        );
      if (recommendation) {
        if (
          typeof recommendation.dataset.ldDefaultHtml ===
            'undefined'
        ) {
          recommendation.dataset.ldDefaultHtml =
            recommendation.innerHTML || '';
        }
        if (isElara) {
          recommendation.innerHTML =
            '<strong>Still unsure?</strong> Choose <strong>Colour Changing White (CCT)</strong> if you want flexibility. For Elara, choose 3000K, 4000K or 6000K using the selector beneath the removable magnetic bezel. The setting remains accessible after installation; it is not changed by a remote or wall control.';
        } else if (isLineaCompact) {
          recommendation.innerHTML =
            '<strong>Linea Compact includes all three whites in every fitting.</strong> Choose 2700K, 4000K or 6000K using the CCT button on the face of each light. You can change the setting after installation without removing or unclipping the fitting.';
        } else if (isLineaSelect) {
          recommendation.innerHTML =
            '<strong>Linea Select includes all three whites in every fitting.</strong> Choose 2700K, 4000K or 6000K using the CCT button on the face of each light. You can change the setting after installation without removing or unclipping the fitting.';
        } else if (isLineaPure) {
          recommendation.innerHTML =
            '<strong>Linea Pure is fixed-white only.</strong> Choose Warm White 3000K, Natural White 4000K or Cool White 6000K before ordering. There is no CCT selector and the colour temperature does not change after installation.';
        } else {
          recommendation.innerHTML =
            recommendation.dataset.ldDefaultHtml;
        }
      }

      guide
        .querySelectorAll(
          'p, span, small'
        )
        .forEach(function (element) {
          if (
            typeof element.dataset.ldDefaultText ===
            'undefined'
          ) {
            element.dataset.ldDefaultText =
              element.textContent || '';
          }
          const original =
            element.dataset.ldDefaultText || '';
          if (
            isElara &&
            (
              /unclip the light/i.test(original) ||
              /switch (?:is )?on the back/i.test(original) ||
              /rear selector/i.test(original)
            )
          ) {
            element.textContent =
              'Choose 3000K, 4000K or 6000K using the selector beneath the removable magnetic bezel. The setting remains accessible after installation.';
          } else if (
            isLineaCompact &&
            (
              /unclip the light/i.test(original) ||
              /switch (?:is )?on the back/i.test(original) ||
              /rear selector/i.test(original)
            )
          ) {
            element.textContent =
              'Choose 2700K, 4000K or 6000K using the CCT button on the face of the Linea Compact fitting. The setting remains accessible after installation without removing the light.';
          } else if (
            isLineaSelect &&
            (
              /unclip the light/i.test(original) ||
              /switch (?:is )?on the back/i.test(original) ||
              /rear selector/i.test(original)
            )
          ) {
            element.textContent =
              'Choose 2700K, 4000K or 6000K using the CCT button on the face of the Linea Select fitting. The setting remains accessible after installation without removing the light.';
          } else if (
            isLineaPure &&
            (
              /unclip the light/i.test(original) ||
              /switch (?:is )?on the back/i.test(original) ||
              /rear selector/i.test(original) ||
              /change it later/i.test(original)
            )
          ) {
            element.textContent =
              'Linea Pure is fixed-white only. Choose Warm White 3000K, Natural White 4000K or Cool White 6000K before ordering; there is no colour-temperature selector on the fitting.';
          } else if (!isElara && !isLineaCompact && !isLineaSelect && !isLineaPure) {
            element.textContent =
              original;
          }
        });

      const technicalGuide =
        guide.querySelector('.ld-colour-help-technical span');
      if (technicalGuide) {
        if (
          typeof technicalGuide.dataset.ldDefaultText === 'undefined'
        ) {
          technicalGuide.dataset.ldDefaultText =
            technicalGuide.textContent || '';
        }
        if (isLineaPure) {
          technicalGuide.textContent =
            'Kelvin (K) describes the tone of white light. Linea Pure is fixed-white only, so choose 3000K Warm White, 4000K Natural White or 6000K Cool White before ordering.';
        } else if (!isElara && !isLineaCompact && !isLineaSelect) {
          technicalGuide.textContent =
            technicalGuide.dataset.ldDefaultText;
        }
      }
    }
    function sensorName(value) {
      if (
        !value ||
        !sensors[value]
      ) {
        return '';
      }
      return (
        sensors[value].name
      );
    }
    function escapeHtml(value) {
      return String(
        value || ''
      )
        .replace(
          /&/g,
          '&amp;'
        )
        .replace(
          /</g,
          '&lt;'
        )
        .replace(
          />/g,
          '&gt;'
        )
        .replace(
          /"/g,
          '&quot;'
        )
        .replace(
          /'/g,
          '&#039;'
        );
    }
    function deepClone(value) {
      try {
        return JSON.parse(
          JSON.stringify(
            value
          )
        );
      } catch (error) {
        return {};
      }
    }
    function parseStoredObject(key) {
      try {
        const value =
          JSON.parse(
            sessionStorage.getItem(
              key
            ) || '{}'
          );
        if (
          value &&
          typeof value ===
          'object'
        ) {
          return value;
        }
      } catch (error) {
        // Ignore invalid storage.
      }
      return {};
    }
    function firstStoredValue(keys) {
      for (
        let i = 0;
        i < keys.length;
        i++
      ) {
        const value =
          sessionStorage.getItem(
            keys[i]
          );
        if (
          value !== null &&
          value !== ''
        ) {
          return value;
        }
      }
      return '';
    }
    function shopRoot() {
      let routeRoot =
        '/';
      if (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) {
        routeRoot =
          window.Shopify.routes.root;
      }
      if (
        routeRoot.slice(-1) !==
        '/'
      ) {
        routeRoot +=
          '/';
      }
      return routeRoot;
    }
    function readSavedCartProjects() {
      try {
        const projects =
          JSON.parse(
            sessionStorage.getItem(
              SAVED_CART_PROJECTS_KEY
            ) || '{}'
          );
        if (
          projects &&
          typeof projects ===
          'object'
        ) {
          return projects;
        }
      } catch (error) {
        // Ignore invalid saved projects.
      }
      return {};
    }
    function getRequestedEditProjectId() {
      try {
        const params =
          new URLSearchParams(
            window.location.search
          );
        const fromUrl =
          params.get(
            'ld_edit_project'
          );
        if (fromUrl) {
          return fromUrl;
        }
      } catch (error) {
        // Ignore URL parsing issue.
      }
      try {
        const request =
          JSON.parse(
            sessionStorage.getItem(
              EDIT_REQUEST_KEY
            ) || '{}'
          );
        if (
          request &&
          request.projectId
        ) {
          return request.projectId;
        }
      } catch (error) {
        // Ignore invalid request.
      }
      return '';
    }
    function cleanCurrentSourceUrl() {
      try {
        const url =
          new URL(
            window.location.href
          );
        url.searchParams.delete(
          'ld_edit_project'
        );
        return url.toString();
      } catch (error) {
        return window.location.href;
      }
    }
    function cleanCurrentSourcePath() {
      try {
        const url =
          new URL(
            window.location.href
          );
        url.searchParams.delete(
          'ld_edit_project'
        );
        return (
          url.pathname +
          url.search
        );
      } catch (error) {
        return window.location.pathname;
      }
    }
    /* =====================================================
       SENSOR PRODUCT IMAGES
       ===================================================== */
    const sensorImageCache =
      {};
    const sensorImageLoading =
      {};
    function ensureSensorImageStyles() {
      if (
        document.getElementById(
          'ld-sensor-product-image-styles'
        )
      ) {
        return;
      }
      const style =
        document.createElement(
          'style'
        );
      style.id =
        'ld-sensor-product-image-styles';
      style.textContent =
        '.ld-sensor-product-image{' +
          'width:100%;' +
          'height:118px;' +
          'display:flex;' +
          'align-items:center;' +
          'justify-content:center;' +
          'margin:0 0 14px;' +
          'padding:10px;' +
          'box-sizing:border-box;' +
          'overflow:hidden;' +
          'border-radius:8px;' +
          'background:#f7f7f7;' +
        '}' +
        '.ld-sensor-product-image img{' +
          'display:block;' +
          'width:100%;' +
          'height:100%;' +
          'max-width:100%;' +
          'max-height:100%;' +
          'object-fit:contain;' +
          'pointer-events:none;' +
        '}' +
        '.ld-sensor-product-image.is-loading{' +
          'opacity:.55;' +
        '}' +
        '.ld-sensor-product-image.is-hidden{' +
          'display:none;' +
        '}' +
        '@media screen and (max-width:749px){' +
          '.ld-sensor-product-image{' +
            'height:100px;' +
            'margin-bottom:10px;' +
          '}' +
        '}';
      document.head.appendChild(
        style
      );
    }
    function normaliseImageUrl(
      url
    ) {
      if (!url) {
        return '';
      }
      if (
        String(url).indexOf('//') ===
        0
      ) {
        return (
          'https:' +
          url
        );
      }
      return url;
    }
    async function getSensorImageUrl(
      sensorKey
    ) {
      if (
        !sensorKey ||
        sensorKey ===
        'none' ||
        !sensors[
          sensorKey
        ] ||
        !sensors[
          sensorKey
        ].handle
      ) {
        return '';
      }
      const handle =
        sensors[
          sensorKey
        ].handle;
      if (
        sensorImageCache[
          handle
        ]
      ) {
        return sensorImageCache[
          handle
        ];
      }
      if (
        sensorImageLoading[
          handle
        ]
      ) {
        return sensorImageLoading[
          handle
        ];
      }
      sensorImageLoading[
        handle
      ] =
        fetch(
          shopRoot() +
          'products/' +
          encodeURIComponent(
            handle
          ) +
          '.js',
          {
            credentials:
              'same-origin'
          }
        )
          .then(function (
            response
          ) {
            if (
              !response.ok
            ) {
              throw new Error(
                'Sensor image product could not be loaded'
              );
            }
            return response.json();
          })
          .then(function (
            productData
          ) {
            const imageUrl =
              normaliseImageUrl(
                productData.featured_image ||
                (
                  productData.images &&
                  productData.images.length
                    ? productData.images[0]
                    : ''
                )
              );
            if (
              imageUrl
            ) {
              sensorImageCache[
                handle
              ] =
                imageUrl;
            }
            return imageUrl;
          })
          .catch(function () {
            return '';
          })
          .finally(function () {
            delete sensorImageLoading[
              handle
            ];
          });
      return sensorImageLoading[
        handle
      ];
    }
    async function loadSensorProductImage(
      card,
      sensorKey
    ) {
      if (!card) {
        return;
      }
      let wrapper =
        card.querySelector(
          '[data-ld-sensor-product-image]'
        );
      if (
        sensorKey ===
        'none'
      ) {
        if (wrapper) {
          wrapper.classList.add(
            'is-hidden'
          );
        }
        return;
      }
      if (
        !sensors[
          sensorKey
        ] ||
        !sensors[
          sensorKey
        ].handle
      ) {
        return;
      }
      if (!wrapper) {
        wrapper =
          document.createElement(
            'div'
          );
        wrapper.className =
          'ld-sensor-product-image is-loading';
        wrapper.setAttribute(
          'data-ld-sensor-product-image',
          ''
        );
        card.insertBefore(
          wrapper,
          card.firstChild
        );
      }
      wrapper.classList.remove(
        'is-hidden'
      );
      const expectedHandle =
        sensors[
          sensorKey
        ].handle;
      if (
        wrapper.dataset.loadedHandle ===
        expectedHandle &&
        wrapper.querySelector(
          'img'
        )
      ) {
        wrapper.classList.remove(
          'is-loading'
        );
        return;
      }
      wrapper.classList.add(
        'is-loading'
      );
      const imageUrl =
        await getSensorImageUrl(
          sensorKey
        );
      if (
        !imageUrl
      ) {
        wrapper.classList.add(
          'is-hidden'
        );
        wrapper.classList.remove(
          'is-loading'
        );
        return;
      }
      if (
        card.dataset.sensor !==
        sensorKey
      ) {
        return;
      }
      const image =
        document.createElement(
          'img'
        );
      image.alt =
        sensors[
          sensorKey
        ].name;
      image.loading =
        'lazy';
      image.src =
        imageUrl;
      image.addEventListener(
        'load',
        function () {
          wrapper.classList.remove(
            'is-loading'
          );
        }
      );
      image.addEventListener(
        'error',
        function () {
          wrapper.classList.add(
            'is-hidden'
          );
          wrapper.classList.remove(
            'is-loading'
          );
        }
      );
      wrapper.innerHTML =
        '';
      wrapper.appendChild(
        image
      );
      wrapper.dataset.loadedHandle =
        expectedHandle;
    }
    function prepareSensorProductImages() {
      ensureSensorImageStyles();
      modal
        .querySelectorAll(
          '.ld-sensor-card'
        )
        .forEach(function (
          card
        ) {
          const sensorKey =
            card.dataset.sensor;
          if (!sensorKey) {
            return;
          }
          loadSensorProductImage(
            card,
            sensorKey
          );
        });
    }
    /* =====================================================
       STYLE & FINISH CHOOSERS
       ===================================================== */
    function ensureBuilderChoiceStyles() {
      if (
        document.getElementById(
          'ld-builder-choice-styles'
        )
      ) {
        return;
      }
      const style =
        document.createElement(
          'style'
        );
      style.id =
        'ld-builder-choice-styles';
      style.textContent =
        '.ld-style-grid--expanded{' +
          'display:grid!important;' +
          'grid-template-columns:repeat(4,minmax(0,1fr))!important;' +
          'gap:14px!important;' +
          'align-items:stretch!important;' +
          'width:100%!important;' +
          'max-width:1000px!important;' +
        '}' +
        '.ld-style-option{' +
          'display:flex!important;' +
          'flex-direction:column!important;' +
          'min-width:0!important;' +
          'height:100%!important;' +
          'gap:8px!important;' +
        '}' +
        '.ld-style-option .ld-style-card--generated{' +
          'flex:1 1 auto!important;' +
          'width:100%!important;' +
        '}' +
        '.ld-style-page-link{' +
          'display:inline-flex!important;' +
          'align-items:center!important;' +
          'justify-content:center!important;' +
          'align-self:flex-start!important;' +
          'margin:0 4px 2px!important;' +
          'padding:8px 11px!important;' +
          'border-radius:999px!important;' +
          'background:#111!important;' +
          'color:#fff!important;' +
          'font-size:10px!important;' +
          'line-height:1.15!important;' +
          'font-weight:850!important;' +
          'letter-spacing:.01em!important;' +
          'text-decoration:none!important;' +
          'box-shadow:none!important;' +
          'transition:transform .16s ease,opacity .16s ease!important;' +
        '}' +
        '.ld-style-page-link:hover{' +
          'transform:translateY(-1px)!important;' +
          'opacity:.88!important;' +
        '}' +
        '.ld-style-page-link:focus-visible{' +
          'outline:3px solid rgba(20,110,245,.35)!important;' +
          'outline-offset:2px!important;' +
        '}' +
        '.ld-style-card--generated{' +
          'display:flex!important;' +
          'flex-direction:column!important;' +
          'min-width:0!important;' +
          'height:100%!important;' +
          'padding:0!important;' +
          'overflow:hidden!important;' +
          'text-align:left!important;' +
          'background:#fff!important;' +
          'border:1px solid #ebe7e0!important;' +
          'border-radius:18px!important;' +
          'box-shadow:0 7px 22px rgba(20,20,20,.04)!important;' +
          'transition:border-color .18s ease,box-shadow .18s ease,transform .18s ease!important;' +
        '}' +
        '.ld-style-card--generated:hover{' +
          'transform:translateY(-3px);' +
          'border-color:#d2c6b8!important;' +
          'box-shadow:0 15px 34px rgba(20,20,20,.085)!important;' +
        '}' +
        '.ld-style-card--generated.is-selected{' +
          'border:3px solid #146ef5!important;' +
          'box-shadow:0 0 0 2px rgba(20,110,245,.12),0 14px 34px rgba(20,110,245,.10)!important;' +
        '}' +
        '.ld-style-card-image{' +
          'position:relative;' +
          'width:100%;' +
          'aspect-ratio:4/3;' +
          'display:flex;' +
          'align-items:center;' +
          'justify-content:center;' +
          'overflow:hidden;' +
          'background:#fff;' +
          'border-bottom:1px solid #f0ece6;' +
        '}' +
        '.ld-style-card-image img{' +
          'display:block;' +
          'width:100%;' +
          'height:100%;' +
          'object-fit:contain;' +
          'padding:10px;' +
          'box-sizing:border-box;' +
          'pointer-events:none;' +
        '}' +
        '.ld-style-card-copy{' +
          'display:flex;' +
          'flex:1 1 auto;' +
          'flex-direction:column;' +
          'padding:16px 15px 15px;' +
        '}' +
        '.ld-style-card-name{' +
          'display:block;' +
          'font-size:17px;' +
          'line-height:1.18;' +
          'font-weight:800;' +
          'letter-spacing:-.01em;' +
          'color:#171717;' +
          'min-height:40px;' +
          'margin:0 0 7px;' +
        '}' +
        '.ld-style-card-description{' +
          'display:block;' +
          'font-size:12px;' +
          'line-height:1.45;' +
          'color:#69655f;' +
          'min-height:34px;' +
          'margin:0 0 12px;' +
        '}' +
        '.ld-style-card-specs{' +
          'display:grid;' +
          'gap:5px;' +
          'margin:0 0 14px;' +
          'padding:11px 12px 10px;' +
          'border:1px solid #eee8df;' +
          'border-radius:11px;' +
          'background:#fbfaf8;' +
          'font-size:11px;' +
          'line-height:1.38;' +
          'color:#625d57;' +
        '}' +
        '.ld-style-card-mounting{' +
          'display:inline-flex;' +
          'align-self:flex-start;' +
          'padding:4px 8px;' +
          'margin:0 0 2px;' +
          'border-radius:999px;' +
          'background:#eee7dc;' +
          'font-size:9px;' +
          'line-height:1;' +
          'font-weight:850;' +
          'letter-spacing:.035em;' +
          'text-transform:uppercase;' +
          'color:#745634;' +
        '}' +
        '.ld-style-card-dimensions{' +
          'font-size:12px;' +
          'line-height:1.3;' +
          'font-weight:800;' +
          'color:#171717;' +
        '}' +
        '.ld-style-card-wattage{' +
          'font-weight:650;' +
          'color:#3e3a35;' +
        '}' +
        '.ld-style-card-cable{' +
          'color:#625d57;' +
        '}' +
        '.ld-style-card-cable b{' +
          'font-weight:800;' +
          'color:#171717;' +
        '}' +
        '.ld-style-card-image img.is-preview-loading{' +
          'opacity:.55;' +
        '}' +
        '.ld-style-finish-swatches{' +
          'position:absolute;' +
          'left:10px;' +
          'bottom:10px;' +
          'z-index:2;' +
          'display:flex;' +
          'align-items:center;' +
          'gap:5px;' +
          'max-width:calc(100% - 20px);' +
          'padding:5px 7px;' +
          'border:1px solid rgba(116,86,52,.14);' +
          'border-radius:999px;' +
          'background:rgba(250,249,247,.95);' +
          'box-shadow:0 2px 8px rgba(20,20,20,.055);' +
          'box-sizing:border-box;' +
        '}' +
        '.ld-style-finish-swatches-label{' +
          'font-size:9px;' +
          'line-height:1;' +
          'font-weight:800;' +
          'letter-spacing:.035em;' +
          'text-transform:uppercase;' +
          'color:#736d66;' +
          'white-space:nowrap;' +
          'margin-right:1px;' +
          'pointer-events:none;' +
        '}' +
        '.ld-style-finish-swatch{' +
          'display:block;' +
          'width:19px;' +
          'height:19px;' +
          'flex:0 0 19px;' +
          'border:2px solid #fff;' +
          'border-radius:50%;' +
          'box-shadow:0 0 0 1px rgba(0,0,0,.24);' +
          'cursor:pointer;' +
          'box-sizing:border-box;' +
          'transition:transform .15s ease,box-shadow .15s ease;' +
        '}' +
        '.ld-style-finish-swatch:hover,' +
        '.ld-style-finish-swatch.is-previewing{' +
          'transform:scale(1.13);' +
          'box-shadow:0 0 0 2px #111;' +
        '}' +
        '.ld-style-finish-swatch.is-aluminium{' +
          'background:linear-gradient(135deg,#f4f4f4 0%,#b9b9b9 48%,#ededed 100%);' +
        '}' +
        '.ld-style-finish-swatch.is-black{' +
          'background:#171717;' +
        '}' +
        '.ld-style-finish-swatch.is-brass{' +
          'background:linear-gradient(135deg,#d9bd7a 0%,#a97d34 52%,#e0c985 100%);' +
        '}' +
        '.ld-style-finish-swatch.is-white{' +
          'background:#fff;' +
        '}' +
        '.ld-style-card-meta{' +
          'display:flex;' +
          'align-items:flex-end;' +
          'justify-content:space-between;' +
          'gap:10px;' +
          'margin-top:auto;' +
        '}' +
        '.ld-style-card-from{' +
          'font-size:10px;' +
          'line-height:1.2;' +
          'font-weight:700;' +
          'letter-spacing:.05em;' +
          'text-transform:uppercase;' +
          'color:#7a746d;' +
        '}' +
        '.ld-style-card-from strong{' +
          'display:block;' +
          'font-size:18px;' +
          'line-height:1.1;' +
          'letter-spacing:-.01em;' +
          'text-transform:none;' +
          'color:#171717;' +
          'margin-top:4px;' +
        '}' +
        '.ld-style-selected-label{' +
          'padding:5px 8px;' +
          'border:1px solid rgba(20,110,245,.24);' +
          'border-radius:999px;' +
          'background:#edf5ff;' +
          'font-size:10px;' +
          'line-height:1.1;' +
          'font-weight:800;' +
          'text-align:right;' +
          'color:#0d55be;' +
        '}' +
        '.ld-finish-grid--expanded{' +
          'display:flex!important;' +
          'flex-wrap:wrap!important;' +
          'justify-content:center!important;' +
          'align-items:stretch!important;' +
          'gap:18px!important;' +
          'width:min(100%,1000px)!important;' +
          'max-width:1000px!important;' +
          'margin-left:auto!important;' +
          'margin-right:auto!important;' +
        '}' +
        '.ld-finish-card--generated{' +
          'position:relative!important;' +
          'display:flex!important;' +
          'flex:0 1 230px!important;' +
          'width:230px!important;' +
          'min-width:0!important;' +
          'min-height:250px!important;' +
          'flex-direction:column!important;' +
          'align-items:stretch!important;' +
          'justify-content:flex-start!important;' +
          'gap:0!important;' +
          'padding:0!important;' +
          'overflow:hidden!important;' +
          'background:#fff!important;' +
          'border:1px solid #ebe7e0!important;' +
          'border-radius:18px!important;' +
          'text-align:center!important;' +
          'box-shadow:0 7px 22px rgba(20,20,20,.04)!important;' +
          'transition:border-color .18s ease,box-shadow .18s ease,transform .18s ease!important;' +
        '}' +
        '.ld-finish-card--generated:hover{' +
          'transform:translateY(-3px);' +
          'border-color:#d2c6b8!important;' +
          'box-shadow:0 15px 34px rgba(20,20,20,.085)!important;' +
        '}' +
        '.ld-finish-card--generated.is-selected{' +
          'border:3px solid #146ef5!important;' +
          'box-shadow:0 0 0 2px rgba(20,110,245,.10),0 14px 30px rgba(20,110,245,.10)!important;' +
        '}' +
        '.ld-finish-card--generated[hidden]{' +
          'display:none!important;' +
        '}' +
        '.ld-finish-product-image{' +
          'width:100%;' +
          'height:158px;' +
          'display:flex;' +
          'align-items:center;' +
          'justify-content:center;' +
          'overflow:hidden;' +
          'box-sizing:border-box;' +
          'padding:12px;' +
          'margin:0;' +
          'background:#fff;' +
          'border-bottom:1px solid #f0ece6;' +
        '}' +
        '.ld-finish-product-image img{' +
          'display:block;' +
          'width:100%;' +
          'height:100%;' +
          'max-width:100%;' +
          'max-height:100%;' +
          'object-fit:contain;' +
          'pointer-events:none;' +
          'transition:transform .18s ease;' +
        '}' +
        '.ld-finish-card--generated:hover .ld-finish-product-image img{' +
          'transform:scale(1.025);' +
        '}' +
        '.ld-finish-product-image.is-loading{' +
          'opacity:.55;' +
        '}' +
        '.ld-finish-product-image.is-hidden{' +
          'display:none;' +
        '}' +
        '.ld-finish-card-copy{' +
          'display:flex;' +
          'flex:1 1 auto;' +
          'flex-direction:column;' +
          'align-items:center;' +
          'padding:15px 16px 14px;' +
        '}' +
        '.ld-finish-name{' +
          'display:block;' +
          'font-size:17px;' +
          'line-height:1.2;' +
          'font-weight:800;' +
          'color:#171717;' +
        '}' +
        '.ld-finish-price{' +
          'display:grid;' +
          'justify-items:center;' +
          'gap:1px;' +
          'margin-top:8px;' +
          'color:#77716a;' +
        '}' +
        '.ld-finish-price small{' +
          'font-size:9px;' +
          'line-height:1;' +
          'font-weight:750;' +
          'letter-spacing:.06em;' +
          'text-transform:uppercase;' +
        '}' +
        '.ld-finish-price strong{' +
          'font-size:18px;' +
          'line-height:1.15;' +
          'font-weight:850;' +
          'color:#171717;' +
        '}' +
        '.ld-finish-price em{' +
          'font-size:10px;' +
          'line-height:1.2;' +
          'font-style:normal;' +
          'color:#8a837b;' +
        '}' +
        '.ld-finish-selected-badge{' +
          'display:none;' +
          'margin-top:auto;' +
          'padding:5px 9px;' +
          'border:1px solid rgba(20,110,245,.24);' +
          'border-radius:999px;' +
          'background:#edf5ff;' +
          'color:#0d55be;' +
          'font-size:10px;' +
          'line-height:1.1;' +
          'font-weight:850;' +
        '}' +
        '.ld-finish-card--generated.is-selected .ld-finish-selected-badge{' +
          'display:inline-flex;' +
        '}' +
        '@media screen and (max-width:989px){' +
          '.ld-style-grid--expanded{' +
            'grid-template-columns:repeat(2,minmax(0,1fr))!important;' +
          '}' +
          '.ld-finish-grid--expanded{' +
            'gap:14px!important;' +
          '}' +
          '.ld-finish-card--generated{' +
            'flex-basis:220px!important;' +
            'width:220px!important;' +
          '}' +
        '}' +
        '@media screen and (max-width:599px){' +
          '.ld-style-grid--expanded{' +
            'grid-template-columns:1fr!important;' +
            'gap:12px!important;' +
          '}' +
          '.ld-style-card--generated{' +
            'display:grid!important;' +
            'grid-template-columns:112px minmax(0,1fr)!important;' +
          '}' +
          '.ld-style-page-link{' +
            'align-self:stretch!important;' +
            'margin:0 2px 2px!important;' +
            'min-height:34px!important;' +
          '}' +
          '.ld-style-card-image{' +
            'aspect-ratio:auto;' +
            'height:100%;' +
            'min-height:126px;' +
          '}' +
          '.ld-style-card-image img{' +
            'padding:8px;' +
          '}' +
          '.ld-style-card-copy{' +
            'padding:12px;' +
          '}' +
          '.ld-style-card-name,' +
          '.ld-style-card-description{' +
            'min-height:0;' +
          '}' +
          '.ld-style-finish-swatches{' +
            'left:7px;' +
            'bottom:7px;' +
            'gap:5px;' +
            'padding:5px 6px;' +
          '}' +
          '.ld-style-finish-swatches-label{' +
            'display:none;' +
          '}' +
          '.ld-style-finish-swatch{' +
            'width:19px;' +
            'height:19px;' +
            'flex-basis:19px;' +
          '}' +
          '.ld-finish-grid--expanded{' +
            'gap:12px!important;' +
          '}' +
          '.ld-finish-card--generated{' +
            'flex:1 1 calc(50% - 6px)!important;' +
            'width:auto!important;' +
            'max-width:230px!important;' +
            'min-height:226px!important;' +
          '}' +
          '.ld-finish-product-image{' +
            'height:138px;' +
          '}' +
          '.ld-finish-card-copy{' +
            'padding:13px 10px 12px;' +
          '}' +
        '}';
      document.head.appendChild(
        style
      );
    }
    function styleDimmingInfo(
      styleKey
    ) {
      const styleProducts =
        lightProducts[
          styleKey
        ] || {};

      let hasDimmable =
        false;
      let hasNonDimmable =
        false;

      Object.keys(
        styleProducts
      ).forEach(function (
        finishKey
      ) {
        const finishProducts =
          styleProducts[
            finishKey
          ] || {};

        Object.keys(
          finishProducts
        ).forEach(function (
          colourKey
        ) {
          const product =
            finishProducts[
              colourKey
            ];

          if (!product) {
            return;
          }

          if (
            product.dimmable ===
            false
          ) {
            hasNonDimmable =
              true;
          } else if (
            product.dimmable ===
            true
          ) {
            hasDimmable =
              true;
          }
        });
      });

      if (
        hasNonDimmable &&
        !hasDimmable
      ) {
        return {
          label:
            'Not dimmable',
          detail:
            'Touch dimmer unavailable',
          warning:
            true
        };
      }

      if (
        hasDimmable &&
        !hasNonDimmable
      ) {
        return {
          label:
            'Dimmable',
          detail:
            'Touch dimmer compatible',
          warning:
            false
        };
      }

      return {
        label:
          'Check dimming by option',
        detail:
          '',
        warning:
          true
      };
    }

    function prepareStyleChooser() {
      if (!screens.style) {
        return;
      }
      const existingCards =
        Array.from(
          screens.style.querySelectorAll(
            '.ld-style-card'
          )
        );
      if (!existingCards.length) {
        return;
      }
      const grid =
        existingCards[0].parentElement;
      if (!grid) {
        return;
      }
      ensureBuilderChoiceStyles();
      existingCards
        .forEach(function (card) {
          card.remove();
        });
      grid.classList.add(
        'ld-style-grid--expanded'
      );
      Object.keys(
        styleCatalog
      )
        .forEach(function (
          styleKey
        ) {
          const details =
            styleCatalog[
              styleKey
            ];
          const wattageSummary =
            styleWattageSummary(
              styleKey
            );
          const dimmingInfo =
            styleDimmingInfo(
              styleKey
            );
          const wattageParts =
            String(
              wattageSummary || ''
            ).split(
              ' · '
            );
          const card =
            document.createElement(
              'button'
            );
          card.type =
            'button';
          card.className =
            'ld-style-card ld-style-card--generated';
          card.dataset.style =
            styleKey;
          card.innerHTML =
            '<span class="ld-style-card-image" data-ld-style-preview-image>' +
              '<img loading="lazy" alt="' +
                escapeHtml(
                  details.name +
                  ' under cabinet light in Aluminium'
                ) +
                '" src="' +
                escapeHtml(
                  details.image
                ) +
              '">' +
              styleFinishSwatchesMarkup(
                styleKey
              ) +
            '</span>' +
            '<span class="ld-style-card-copy">' +
              '<span class="ld-style-card-name">' +
                escapeHtml(
                  details.name
                ) +
              '</span>' +
              '<span class="ld-style-card-description">' +
                escapeHtml(
                  details.description
                ) +
              '</span>' +
              '<span class="ld-style-card-specs">' +
                '<strong class="ld-style-card-mounting">' +
                  escapeHtml(
                    details.mounting || ''
                  ) +
                '</strong>' +
                '<span class="ld-style-card-dimensions">' +
                  escapeHtml(
                    details.dimensions || ''
                  ) +
                '</span>' +
                '<span class="ld-style-card-wattage">' +
                  '<b>' +
                    escapeHtml(
                      wattageParts[0] || ''
                    ) +
                  '</b>' +
                  (
                    wattageParts[1]
                      ? '<small>' +
                          escapeHtml(
                            wattageParts[1]
                          ) +
                        '</small>'
                      : ''
                  ) +
                '</span>' +
                '<span class="ld-style-card-dimming' +
                  (
                    dimmingInfo.warning
                      ? ' is-warning'
                      : ''
                  ) +
                  '">' +
                  '<b>' +
                    escapeHtml(
                      dimmingInfo.label
                    ) +
                  '</b>' +
                  (
                    dimmingInfo.detail
                      ? '<small>' +
                          escapeHtml(
                            dimmingInfo.detail
                          ) +
                        '</small>'
                      : ''
                  ) +
                '</span>' +
                '<span class="ld-style-card-cable">' +
                  '<b>' +
                    escapeHtml(
                      styleCableSummaryFor(
                        styleKey
                      )
                    ) +
                  '</b> cable' +
                  (
                    styleKey === 'square'
                      ? ''
                      : ' included'
                  ) +
                '</span>' +
                '<span class="ld-style-card-extension-note">' +
                  '2m & 5m extensions available' +
                '</span>' +
              '</span>' +
              '<span class="ld-style-origin-label" data-ld-style-origin-label hidden>' +
                'Your starting style' +
              '</span>' +
              '<span class="ld-style-card-meta">' +
                '<span class="ld-style-card-from">' +
                  'From' +
                  '<strong data-ld-style-price="' +
                    escapeHtml(
                      styleKey
                    ) +
                  '"></strong>' +
                '</span>' +
                '<span class="ld-style-selected-label"></span>' +
              '</span>' +
            '</span>';
          const image =
            card.querySelector(
              'img'
            );
          if (image) {
            image.dataset.defaultSrc =
              details.image || '';
            image.addEventListener(
              'error',
              function () {
                const defaultSrc =
                  image.dataset.defaultSrc ||
                  '';
                if (
                  defaultSrc &&
                  image.src !==
                  defaultSrc
                ) {
                  image.src =
                    defaultSrc;
                  image.alt =
                    details.name +
                    ' under cabinet light in Aluminium';
                  image.style.display =
                    'block';
                  return;
                }
                image.style.display =
                  'none';
              }
            );
          }
          bindStyleFinishPreviews(
            card,
            styleKey
          );

          const optionWrap =
            document.createElement(
              'div'
            );
          optionWrap.className =
            'ld-style-option';
          optionWrap.dataset.styleOption =
            styleKey;
          optionWrap.appendChild(
            card
          );

          if (
            details.pageUrl
          ) {
            const pageLink =
              document.createElement(
                'a'
              );
            pageLink.className =
              'ld-style-page-link';
            pageLink.href =
              details.pageUrl;
            pageLink.target =
              '_blank';
            pageLink.rel =
              'noopener';
            pageLink.setAttribute(
              'aria-label',
              'Read more about ' +
                details.name +
                ' (opens in a new tab)'
            );
            pageLink.textContent =
              'View full style page ↗';
            optionWrap.appendChild(
              pageLink
            );
          }

          grid.appendChild(
            optionWrap
          );
        });
    }
    function prepareFinishChooser() {
      if (!screens.finish) {
        return;
      }
      const existingCards =
        Array.from(
          screens.finish.querySelectorAll(
            '.ld-finish-card'
          )
        );
      if (!existingCards.length) {
        return;
      }
      const grid =
        existingCards[0].parentElement;
      if (!grid) {
        return;
      }
      ensureBuilderChoiceStyles();
      existingCards
        .forEach(function (card) {
          card.remove();
        });
      grid.classList.add(
        'ld-finish-grid--expanded'
      );
      [
        {
          key: 'aluminium',
          name: 'Aluminium'
        },
        {
          key: 'black',
          name: 'Black'
        },
        {
          key: 'brass',
          name: 'Brass'
        },
        {
          key: 'white',
          name: 'White'
        }
      ]
        .forEach(function (
          finish
        ) {
          const card =
            document.createElement(
              'button'
            );
          card.type =
            'button';
          card.className =
            'ld-finish-card ld-finish-card--generated';
          card.dataset.finish =
            finish.key;
          card.innerHTML =
            '<span class="ld-finish-product-image is-loading" data-ld-finish-product-image></span>' +
            '<span class="ld-finish-card-copy">' +
              '<span class="ld-finish-name">' +
                escapeHtml(
                  finish.name
                ) +
              '</span>' +
              '<span class="ld-finish-price">' +
                '<small>From</small>' +
                '<strong data-ld-finish-price="' +
                  escapeHtml(
                    finish.key
                  ) +
                '"></strong>' +
                '<em>per light</em>' +
              '</span>' +
              '<span class="ld-finish-selected-badge">✓ Selected</span>' +
            '</span>';
          grid.appendChild(
            card
          );
        });
    }
    function availableFinishesForCurrent() {
      if (
        !state.style ||
        !lightProducts[
          state.style
        ]
      ) {
        return [];
      }
      return Object.keys(
        lightProducts[
          state.style
        ]
      );
    }
    const finishImageCache =
      {};
    let stylePreviewRequestId =
      0;
    function resetStylePreviewCard(
      card
    ) {
      if (!card) {
        return;
      }
      const image =
        card.querySelector(
          '[data-ld-style-preview-image] img'
        );
      if (!image) {
        return;
      }
      stylePreviewRequestId +=
        1;
      card.dataset.ldStylePreviewRequest =
        String(
          stylePreviewRequestId
        );
      const defaultSrc =
        image.dataset.defaultSrc ||
        (
          styleCatalog[
            card.dataset.style
          ]
            ? styleCatalog[
                card.dataset.style
              ].image
            : ''
        );
      if (defaultSrc) {
        image.style.display =
          'block';
        image.classList.remove(
          'is-preview-loading'
        );
        image.src =
          defaultSrc;
        image.alt =
          styleName(
            card.dataset.style
          ) +
          ' under cabinet light in Aluminium';
      }
      card
        .querySelectorAll(
          '[data-ld-style-finish-preview]'
        )
        .forEach(function (
          swatch
        ) {
          swatch.classList.remove(
            'is-previewing'
          );
        });
    }
    async function previewStyleFinish(
      card,
      styleKey,
      finishKey,
      keepHighlight
    ) {
      if (
        !card ||
        !styleKey ||
        !finishKey
      ) {
        return;
      }
      const image =
        card.querySelector(
          '[data-ld-style-preview-image] img'
        );
      if (!image) {
        return;
      }
      const product =
        representativeFinishProduct(
          styleKey,
          finishKey
        );
      if (
        !product ||
        !product.handle
      ) {
        return;
      }
      stylePreviewRequestId +=
        1;
      const requestId =
        String(
          stylePreviewRequestId
        );
      card.dataset.ldStylePreviewRequest =
        requestId;
      image.classList.add(
        'is-preview-loading'
      );
      try {
        let imageUrl =
          finishImageCache[
            product.handle
          ];
        if (!imageUrl) {
          const productData =
            await productDataFromHandle(
              product.handle
            );
          imageUrl =
            normaliseImageUrl(
              productData.featured_image ||
              (
                productData.images &&
                productData.images.length
                  ? productData.images[0]
                  : ''
              )
            );
          if (imageUrl) {
            finishImageCache[
              product.handle
            ] =
              imageUrl;
          }
        }
        if (
          card.dataset.ldStylePreviewRequest !==
          requestId
        ) {
          return;
        }
        if (!imageUrl) {
          resetStylePreviewCard(
            card
          );
          return;
        }
        image.style.display =
          'block';
        image.src =
          imageUrl;
        image.alt =
          styleName(
            styleKey
          ) +
          ' under cabinet light in ' +
          finishName(
            finishKey
          );
        image.classList.remove(
          'is-preview-loading'
        );
        card
          .querySelectorAll(
            '[data-ld-style-finish-preview]'
          )
          .forEach(function (
            swatch
          ) {
            swatch.classList.toggle(
              'is-previewing',
              Boolean(
                keepHighlight
              ) &&
              swatch.dataset.ldStyleFinishPreview ===
              finishKey
            );
          });
      } catch (error) {
        if (
          card.dataset.ldStylePreviewRequest ===
          requestId
        ) {
          resetStylePreviewCard(
            card
          );
        }
      }
    }
    function bindStyleFinishPreviews(
      card,
      styleKey
    ) {
      if (!card) {
        return;
      }
      const swatches =
        card.querySelectorAll(
          '[data-ld-style-finish-preview]'
        );
      swatches.forEach(function (
        swatch
      ) {
        const finishKey =
          swatch.dataset.ldStyleFinishPreview;
        swatch.addEventListener(
          'mouseenter',
          function () {
            previewStyleFinish(
              card,
              styleKey,
              finishKey,
              true
            );
          }
        );
        swatch.addEventListener(
          'mouseleave',
          function () {
            const hoverCapable =
              window.matchMedia &&
              window.matchMedia(
                '(hover: hover) and (pointer: fine)'
              ).matches;
            if (hoverCapable) {
              resetStylePreviewCard(
                card
              );
            }
          }
        );
        swatch.addEventListener(
          'click',
          function (
            event
          ) {
            event.preventDefault();
            event.stopPropagation();
            const hoverCapable =
              window.matchMedia &&
              window.matchMedia(
                '(hover: hover) and (pointer: fine)'
              ).matches;
            if (!hoverCapable) {
              previewStyleFinish(
                card,
                styleKey,
                finishKey,
                true
              );
            }
          }
        );
      });
    }
    function resetAllStylePreviewCards() {
      modal
        .querySelectorAll(
          '.ld-style-card--generated'
        )
        .forEach(function (
          card
        ) {
          resetStylePreviewCard(
            card
          );
        });
    }
    function representativeFinishProduct(
      styleKey,
      finishKey
    ) {
      if (
        !styleKey ||
        !finishKey ||
        !lightProducts[
          styleKey
        ] ||
        !lightProducts[
          styleKey
        ][
          finishKey
        ]
      ) {
        return null;
      }
      const finishProducts =
        lightProducts[
          styleKey
        ][
          finishKey
        ];
      const preferredColours = [
        'cct',
        'warm',
        'natural',
        'cool'
      ];
      for (
        let i = 0;
        i < preferredColours.length;
        i++
      ) {
        const colourKey =
          preferredColours[
            i
          ];
        if (
          finishProducts[
            colourKey
          ]
        ) {
          return finishProducts[
            colourKey
          ];
        }
      }
      const firstKey =
        Object.keys(
          finishProducts
        )[0];
      return firstKey
        ? finishProducts[
            firstKey
          ]
        : null;
    }
    async function loadFinishProductImage(
      card
    ) {
      if (!card) {
        return;
      }
      const finishKey =
        card.dataset.finish;
      const styleKey =
        state.style;
      const wrapper =
        card.querySelector(
          '[data-ld-finish-product-image]'
        );
      if (
        !wrapper ||
        !finishKey ||
        !styleKey
      ) {
        return;
      }
      const product =
        representativeFinishProduct(
          styleKey,
          finishKey
        );
      if (
        !product ||
        !product.handle
      ) {
        wrapper.classList.add(
          'is-hidden'
        );
        return;
      }
      const handle =
        product.handle;
      if (
        wrapper.dataset.loadedHandle ===
        handle &&
        wrapper.querySelector(
          'img'
        )
      ) {
        wrapper.classList.remove(
          'is-loading',
          'is-hidden'
        );
        return;
      }
      wrapper.classList.remove(
        'is-hidden'
      );
      wrapper.classList.add(
        'is-loading'
      );
      try {
        let imageUrl =
          finishImageCache[
            handle
          ];
        if (!imageUrl) {
          const productData =
            await productDataFromHandle(
              handle
            );
          imageUrl =
            normaliseImageUrl(
              productData.featured_image ||
              (
                productData.images &&
                productData.images.length
                  ? productData.images[0]
                  : ''
              )
            );
          if (imageUrl) {
            finishImageCache[
              handle
            ] =
              imageUrl;
          }
        }
        if (
          state.style !==
          styleKey ||
          card.dataset.finish !==
          finishKey
        ) {
          return;
        }
        if (!imageUrl) {
          wrapper.classList.add(
            'is-hidden'
          );
          wrapper.classList.remove(
            'is-loading'
          );
          return;
        }
        const image =
          document.createElement(
            'img'
          );
        image.alt =
          styleName(
            styleKey
          ) +
          ' - ' +
          finishName(
            finishKey
          );
        image.loading =
          'lazy';
        image.src =
          imageUrl;
        image.addEventListener(
          'load',
          function () {
            wrapper.classList.remove(
              'is-loading'
            );
          }
        );
        image.addEventListener(
          'error',
          function () {
            wrapper.classList.add(
              'is-hidden'
            );
            wrapper.classList.remove(
              'is-loading'
            );
          }
        );
        wrapper.innerHTML =
          '';
        wrapper.appendChild(
          image
        );
        wrapper.dataset.loadedHandle =
          handle;
      } catch (error) {
        wrapper.classList.add(
          'is-hidden'
        );
        wrapper.classList.remove(
          'is-loading'
        );
      }
    }
    function updateFinishImages() {
      modal
        .querySelectorAll(
          '.ld-finish-card'
        )
        .forEach(function (
          card
        ) {
          if (
            card.hidden ||
            card.disabled
          ) {
            return;
          }
          loadFinishProductImage(
            card
          );
        });
    }
    /* =====================================================
       EDIT PROJECT REQUEST
       ===================================================== */
    const requestedEditProjectId =
      getRequestedEditProjectId();
    const savedCartProjectsAtLoad =
      readSavedCartProjects();
    const editingProjectSnapshot =
      (
        requestedEditProjectId &&
        savedCartProjectsAtLoad[
          requestedEditProjectId
        ]
      )
        ? deepClone(
            savedCartProjectsAtLoad[
              requestedEditProjectId
            ]
          )
        : null;
    let editingProjectId =
      editingProjectSnapshot
        ? requestedEditProjectId
        : '';
    let projectName =
      editingProjectSnapshot
        ? String(
            editingProjectSnapshot.projectName ||
            ''
          )
        : String(
            sessionStorage.getItem(
              PROJECT_NAME_KEY
            ) ||
            ''
          );
    function cleanProjectName(
      value
    ) {
      return String(
        value ||
        ''
      )
        .replace(
          /\s+/g,
          ' '
        )
        .trim()
        .slice(
          0,
          80
        );
    }
    function saveProjectName() {
      projectName =
        cleanProjectName(
          projectName
        );
      sessionStorage.setItem(
        PROJECT_NAME_KEY,
        projectName
      );
    }
    function updateProjectNameDisplay() {
      const reviewWrap =
        modal.querySelector(
          '[data-ld-project-review-name-wrap]'
        );
      const reviewName =
        modal.querySelector(
          '[data-ld-project-review-name]'
        );
      const cleaned =
        cleanProjectName(
          projectName
        );
      if (reviewName) {
        reviewName.textContent =
          cleaned;
      }
      if (reviewWrap) {
        reviewWrap.hidden =
          !cleaned;
      }
    }
    /* =====================================================
       ZONE MODEL
       ===================================================== */
    function defaultStepDone(
      zoneNumber
    ) {
      return {
        style:
          zoneNumber === 1,
        finish:
          false,
        colour:
          false,
        quantity:
          false,
        driver:
          false,
        sensor:
          false,
        accessories:
          false,
        review:
          false
      };
    }
    function blankAccessories() {
      return {
        extension2: 0,
        extension5: 0,
        wago2: 0,
        wago3: 0
      };
    }
    function normaliseAccessories(value) {
      const source = value || {};
      const clean = key => {
        const number = Number(source[key]);
        return Number.isFinite(number) ? Math.min(99, Math.max(0, Math.floor(number))) : 0;
      };
      return { extension2: clean('extension2'), extension5: clean('extension5'),
        wago2: clean('wago2'), wago3: clean('wago3') };
    }
    function normaliseLightQuantity(value) {
      const number = Number(value);
      return Number.isFinite(number) ? Math.min(36, Math.max(1, Math.floor(number))) : 1;
    }
    function normaliseCablePlan(value) {
      const source =
        Array.isArray(value)
          ? value
          : [];

      return source
        .slice(
          0,
          36
        )
        .map(function (
          item
        ) {
          if (
            item === '' ||
            item === null ||
            typeof item ===
              'undefined'
          ) {
            return '';
          }

          const number =
            Number(
              item
            );

          return (
            Number.isFinite(
              number
            ) &&
            number > 0
          )
            ? Math.round(
                number * 100
              ) / 100
            : '';
        });
    }

    function cleanDriverLocation(
      value
    ) {
      return String(
        value || ''
      )
        .replace(
          /\s+/g,
          ' '
        )
        .trim()
        .slice(
          0,
          80
        );
    }
    function accessoriesForQuantity(value, quantity) {
      // Keep the customer's existing accessory choices intact when light
      // quantity changes. If the new light quantity makes the extension
      // selection invalid, Accessories will explain the conflict and require
      // the customer to resolve it rather than silently deleting a cable.
      return normaliseAccessories(value);
    }
    function blankZone(
      zoneNumber
    ) {
      return {
        zoneNumber:
          zoneNumber,
        style:
          zoneNumber === 1
            ? startingStyle
            : '',
        styleManuallyChanged:
          false,
        finish:
          '',
        colour:
          '',
        quantity:
          1,
        ownDriver:
          false,
        ukPlug:
          false,
        sensor:
          '',
        accessories:
          blankAccessories(),
        cablePlan:
          [],
        driverLocation:
          '',
        name:
          '',
        startMode:
          zoneNumber === 1
            ? 'product-page'
            : '',
        completed:
          false,
        completedOnce:
          false,
        total:
          0,
        stepDone:
          defaultStepDone(
            zoneNumber
          )
      };
    }
    /* =====================================================
       LOAD PROJECT
       ===================================================== */
    let projectZones =
      editingProjectSnapshot
        ? deepClone(
            editingProjectSnapshot.zones ||
            {}
          )
        : parseStoredObject(
            PROJECT_KEY
          );
    if (
      !editingProjectSnapshot &&
      !Object.keys(
        projectZones
      ).length
    ) {
      for (
        let i = 0;
        i < LEGACY_PROJECT_KEYS.length;
        i++
      ) {
        projectZones =
          parseStoredObject(
            LEGACY_PROJECT_KEYS[i]
          );
        if (
          Object.keys(
            projectZones
          ).length
        ) {
          break;
        }
      }
    }
    let zoneCount =
      'dynamic';
    let currentZone =
      editingProjectSnapshot
        ? 1
        : (
            parseInt(
              sessionStorage.getItem(
                CURRENT_ZONE_KEY
              ) ||
              firstStoredValue(
                LEGACY_CURRENT_ZONE_KEYS
              ) ||
              '1',
              10
            ) || 1
          );
    let highestReached =
      editingProjectSnapshot
        ? (
            parseInt(
              editingProjectSnapshot.highestReached ||
              Object.keys(
                projectZones
              ).length ||
              1,
              10
            ) || 1
          )
        : (
            parseInt(
              sessionStorage.getItem(
                HIGHEST_ZONE_KEY
              ) ||
              firstStoredValue(
                LEGACY_HIGHEST_ZONE_KEYS
              ) ||
              '1',
              10
            ) || 1
          );
    let legacyAccessories =
      normaliseAccessories(
        editingProjectSnapshot
          ? deepClone(
              editingProjectSnapshot.accessories ||
              {}
            )
          : parseStoredObject(
              ACCESSORY_KEY
            )
      );
    if (
      !editingProjectSnapshot &&
      !sessionStorage.getItem(
        ACCESSORY_KEY
      )
    ) {
      legacyAccessories =
        normaliseAccessories(
          parseStoredObject(
            'ldLightingAccessoriesV1'
          )
        );
    }
    let accessories =
      blankAccessories();
    /* =====================================================
       LEGACY ZONE 1 MIGRATION
       ===================================================== */
    if (
      !projectZones['1']
    ) {
      const migrated =
        blankZone(1);
      migrated.style =
        sessionStorage.getItem(
          'ldZone1Style'
        ) ||
        startingStyle;
      migrated.styleManuallyChanged =
        sessionStorage.getItem(
          'ldZone1StyleManuallyChanged'
        ) ===
        'true';
      migrated.finish =
        sessionStorage.getItem(
          'ldZone1Finish'
        ) || '';
      migrated.colour =
        sessionStorage.getItem(
          'ldZone1Colour'
        ) || '';
      migrated.quantity =
        parseInt(
          sessionStorage.getItem(
            'ldZone1Quantity'
          ) || '1',
          10
        ) || 1;
      migrated.ownDriver =
        false;
      migrated.ukPlug =
        sessionStorage.getItem(
          'ldZone1UkPlug'
        ) ===
        'true';
      migrated.sensor =
        sessionStorage.getItem(
          'ldZone1Sensor'
        ) || '';
      migrated.name =
        sessionStorage.getItem(
          'ldZone1Name'
        ) || '';
      migrated.total =
        parseFloat(
          sessionStorage.getItem(
            'ldZone1TotalPrice'
          ) || '0'
        ) || 0;
      projectZones['1'] =
        migrated;
    }
    if (
      projectZones['1'] &&
      !projectZones['1'].accessories &&
      (
        legacyAccessories.extension2 > 0 ||
        legacyAccessories.extension5 > 0 ||
        legacyAccessories.wago2 > 0 ||
        legacyAccessories.wago3 > 0
      )
    ) {
      projectZones['1'].accessories =
        deepClone(
          legacyAccessories
        );
    }
    /* =====================================================
       NORMALISE ZONES
       ===================================================== */
    function inferStepDone(
      zone,
      existing
    ) {
      const done =
        Object.assign(
          defaultStepDone(
            zone.zoneNumber
          ),
          existing.stepDone || {}
        );
      if (
        !existing.stepDone && (existing.completedOnce || existing.completed)
      ) {
        STEP_ORDER
          .forEach(function (step) {
            done[step.key] =
              true;
          });
        return done;
      }
      if (
        !existing.stepDone
      ) {
        done.style =
          !!zone.style;
        done.finish =
          !!zone.finish;
        done.colour =
          !!zone.colour;
        done.quantity =
          !!zone.colour &&
          Number(
            zone.quantity || 0
          ) >= 1;
        done.driver =
          !!zone.sensor ||
          zone.ownDriver;
        done.sensor =
          zone.ownDriver ||
          !!zone.sensor;
        done.review =
          false;
        if (
          zone.startMode ===
          'reuse'
        ) {
          done.style =
            true;
          done.finish =
            true;
          done.colour =
            true;
          done.quantity =
            false;
          done.driver =
            false;
          done.sensor =
            false;
        }
      }
      return done;
    }
    function normaliseZone(
      zoneNumber
    ) {
      const base =
        blankZone(
          zoneNumber
        );
      const existing =
        projectZones[
          String(
            zoneNumber
          )
        ] || {};
      const zone =
        Object.assign(
          base,
          existing,
          {
            zoneNumber:
              zoneNumber
          }
        );
      // A compatible driver is mandatory for every lighting zone.
      // Reset older saved projects that previously opted out of a supplied driver.
      zone.ownDriver =
        false;
      zone.accessories =
        normaliseAccessories(
          existing.accessories ||
          zone.accessories
        );
      zone.stepDone =
        inferStepDone(
          zone,
          existing
        );
      zone.quantity = normaliseLightQuantity(zone.quantity);
      zone.accessories = accessoriesForQuantity(zone.accessories, zone.quantity);
      zone.cablePlan =
        normaliseCablePlan(
          existing.cablePlan ||
          zone.cablePlan
        );
      zone.driverLocation =
        cleanDriverLocation(
          existing.driverLocation ||
          zone.driverLocation
        );
      if (
        typeof existing.completedOnce ===
        'undefined' &&
        existing.completed
      ) {
        zone.completedOnce =
          true;
      }
      return zone;
    }
    Object.keys(
      projectZones
    )
      .forEach(function (key) {
        const number =
          parseInt(
            key,
            10
          );
        if (
          !Number.isNaN(
            number
          )
        ) {
          highestReached =
            Math.max(
              highestReached,
              number
            );
        }
      });
    highestReached =
      Math.min(
        6,
        Math.max(
          highestReached,
          currentZone,
          1
        )
      );
    let state =
      normaliseZone(
        currentZone
      );
    projectZones[
      String(
        currentZone
      )
    ] =
      state;
    accessories =
      normaliseAccessories(
        state.accessories
      );
    state.accessories =
      deepClone(
        accessories
      );
    function updateProjectIdentityFields(
      activeInput
    ) {
      const cleanedProjectName =
        cleanProjectName(
          projectName
        );
      modal
        .querySelectorAll(
          '[data-ld-top-project-name]'
        )
        .forEach(function (
          input
        ) {
          if (
            input !== activeInput &&
            input !== document.activeElement
          ) {
            input.value =
              cleanedProjectName;
          }
        });
      const zoneName =
        state && state.name
          ? String(
              state.name
            )
          : '';
      modal
        .querySelectorAll(
          '[data-ld-top-zone-name]'
        )
        .forEach(function (
          input
        ) {
          if (
            input !== activeInput &&
            input !== document.activeElement
          ) {
            input.value =
              zoneName;
          }
        });
      modal
        .querySelectorAll(
          '[data-ld-top-zone-name-label]'
        )
        .forEach(function (
          label
        ) {
          label.innerHTML =
            'Zone ' +
            currentZone +
            ' name <small>Optional</small>';
        });
      const legacyProjectInput =
        modal.querySelector(
          '[data-ld-project-name-input]'
        );
      if (
        legacyProjectInput &&
        legacyProjectInput !== document.activeElement
      ) {
        legacyProjectInput.value =
          cleanedProjectName;
      }
    }
    /* =====================================================
       PRODUCT HELPERS
       ===================================================== */
    function selectedLightProduct(
      zone
    ) {
      const z =
        zone || state;
      if (
        !z ||
        !z.style ||
        !z.finish ||
        !z.colour
      ) {
        return null;
      }
      if (
        !lightProducts[z.style] ||
        !lightProducts[z.style][z.finish] ||
        !lightProducts[z.style][z.finish][z.colour]
      ) {
        return null;
      }
      return (
        lightProducts[
          z.style
        ][
          z.finish
        ][
          z.colour
        ]
      );
    }
    function totalWattsFor(
      zone
    ) {
      const product =
        selectedLightProduct(
          zone
        );
      if (!product) {
        return 0;
      }
      return (
        Number(
          product.watts || 0
        ) *
        Number(
          zone.quantity || 0
        )
      );
    }
    function lightSubtotalFor(
      zone
    ) {
      const product =
        selectedLightProduct(
          zone
        );
      if (!product) {
        return 0;
      }
      return (
        product.price *
        Number(
          zone.quantity || 0
        )
      );
    }
    /* =====================================================
       DRIVER CALCULATION
       ===================================================== */
    function selectDriverFor(
      zone
    ) {
      if (
        !selectedLightProduct(
          zone
        )
      ) {
        return null;
      }
      const watts =
        totalWattsFor(
          zone
        );
      for (
        let i = 0;
        i < drivers.length;
        i++
      ) {
        const driver =
          drivers[i];
        if (
          driver.watts >=
          watts &&
          Number(
            zone.quantity || 0
          ) <=
          (
            driver.ports * 6
          )
        ) {
          return driver;
        }
      }
      return null;
    }
    function requiredBlocksFor(
      zone,
      driver
    ) {
      if (
        !driver
      ) {
        return 0;
      }
      const qty =
        Number(
          zone.quantity || 0
        );
      if (
        qty <=
        driver.ports
      ) {
        return 0;
      }
      return Math.ceil(
        (
          qty -
          driver.ports
        ) / 5
      );
    }
    function baseZoneFor(
      zone
    ) {
      const lightsTotal =
        lightSubtotalFor(
          zone
        );
      const driver =
        selectDriverFor(
          zone
        );
      if (!driver) {
        return {
          driver:
            null,
          blocks:
            0,
          lightsTotal:
            lightsTotal,
          driverTotal:
            0,
          blocksTotal:
            0,
          ukPlugTotal:
            0,
          total:
            lightsTotal
        };
      }
      const blocks =
        requiredBlocksFor(
          zone,
          driver
        );
      const driverTotal =
        driver.price;
      const blocksTotal =
        blocks *
        distributionBlock.price;
      const ukPlugTotal =
        zone.ukPlug
          ? ukPlugCable.price
          : 0;
      return {
        driver:
          driver,
        blocks:
          blocks,
        lightsTotal:
          lightsTotal,
        driverTotal:
          driverTotal,
        blocksTotal:
          blocksTotal,
        ukPlugTotal:
          ukPlugTotal,
        total:
          lightsTotal +
          driverTotal +
          blocksTotal +
          ukPlugTotal
      };
    }
    function finalZoneTotalFor(
      zone
    ) {
      const base =
        baseZoneFor(
          zone
        );
      let sensorPrice =
        0;
      if (
        zone.sensor &&
        sensors[
          zone.sensor
        ]
      ) {
        sensorPrice =
          sensors[
            zone.sensor
          ].price;
      }
      return (
        base.total +
        sensorPrice
      );
    }
    /* =====================================================
       VALIDATION
       ===================================================== */
    function sensorCompatibleFor(
      zone,
      sensorKey
    ) {
      if (
        sensorKey ===
        'none'
      ) {
        return true;
      }
      if (
        sensorKey ===
        'touch'
      ) {
        const product =
          selectedLightProduct(
            zone
          );
        return !!(
          product &&
          product.dimmable !== false
        );
      }
      return Object.prototype.hasOwnProperty.call(sensors, sensorKey);
    }
    function colourAvailableFor(
      zone
    ) {
      return !!selectedLightProduct(
        zone
      );
    }
    function isStepComplete(
      zone,
      key
    ) {
      if (
        !zone ||
        !zone.stepDone
      ) {
        return false;
      }
      if (
        key ===
        'style'
      ) {
        return (
          !!zone.stepDone.style &&
          !!zone.style
        );
      }
      if (
        key ===
        'finish'
      ) {
        return (
          !!zone.stepDone.finish &&
          !!zone.finish &&
          isStepComplete(
            zone,
            'style'
          )
        );
      }
      if (
        key ===
        'colour'
      ) {
        return (
          !!zone.stepDone.colour &&
          colourAvailableFor(
            zone
          ) &&
          isStepComplete(
            zone,
            'finish'
          )
        );
      }
      if (
        key ===
        'quantity'
      ) {
        return (
          !!zone.stepDone.quantity &&
          Number(
            zone.quantity || 0
          ) >= 1 &&
          Number(
            zone.quantity || 0
          ) <= 36 &&
          isStepComplete(
            zone,
            'colour'
          )
        );
      }
      if (
        key ===
        'driver'
      ) {
        return (
          !!zone.stepDone.driver &&
          !!selectDriverFor(
            zone
          ) &&
          isStepComplete(
            zone,
            'quantity'
          )
        );
      }
      if (
        key ===
        'sensor'
      ) {
        if (
          !isStepComplete(
            zone,
            'driver'
          )
        ) {
          return false;
        }
        if (
          zone.ownDriver
        ) {
          return true;
        }
        return (
          !!zone.stepDone.sensor &&
          !!zone.sensor &&
          sensorCompatibleFor(
            zone,
            zone.sensor
          )
        );
      }
      if (
        key ===
        'accessories'
      ) {
        const zoneAccessories =
          normaliseAccessories(
            zone.accessories || {}
          );
        const extensionTotal =
          zoneAccessories.extension2 +
          zoneAccessories.extension5;
        const extensionLimit =
          Math.max(
            1,
            Number(
              zone.quantity || 1
            )
          );

        return (
          !!zone.stepDone.accessories &&
          extensionTotal <=
            extensionLimit &&
          isStepComplete(
            zone,
            'sensor'
          )
        );
      }
      if (
        key ===
        'review'
      ) {
        return (
          !!zone.stepDone.review &&
          isStepComplete(
            zone,
            'accessories'
          )
        );
      }
      return false;
    }
    function isStepUnlocked(
      zone,
      key
    ) {
      const index =
        STEP_ORDER
          .findIndex(function (step) {
            return (
              step.key ===
              key
            );
          });
      if (
        index <= 0
      ) {
        return true;
      }
      return isStepComplete(
        zone,
        STEP_ORDER[
          index - 1
        ].key
      );
    }
    function isZoneComplete(
      zone
    ) {
      return isStepComplete(
        zone,
        'review'
      );
    }
    /* =====================================================
       PROJECT COUNTS
       ===================================================== */
    function displayZoneCount() {
      return Math.max(
        1,
        Math.min(
          6,
          highestReached
        )
      );
    }
    function syncZoneChoicePanel() {
      const separateCard =
        modal.querySelector(
          '[data-ld-separate-groups]'
        );
      const separatePanel =
        modal.querySelector(
          '[data-ld-separate-panel]'
        );
      if (
        !separateCard ||
        !separatePanel
      ) {
        return;
      }
      const isSeparate =
        zoneCount === '2' ||
        zoneCount === '3' ||
        zoneCount === '4plus';
      separatePanel.hidden =
        !isSeparate;
      separateCard.classList.toggle(
        'is-selected',
        isSeparate
      );
      separateCard.setAttribute(
        'aria-expanded',
        isSeparate
          ? 'true'
          : 'false'
      );
    }
    function configuredZonesBeyond(
      targetCount
    ) {
      return Object.keys(
        projectZones
      )
        .map(function (key) {
          return parseInt(
            key,
            10
          );
        })
        .filter(function (zoneNumber) {
          return (
            Number.isFinite(
              zoneNumber
            ) &&
            zoneNumber > targetCount &&
            zoneNumber <= 6
          );
        })
        .sort(function (a, b) {
          return a - b;
        });
    }
    function trimProjectToCount(
      targetCount
    ) {
      const safeTarget =
        Math.max(
          1,
          Math.min(
            3,
            Number(
              targetCount || 1
            )
          )
        );
      saveProject();
      Object.keys(
        projectZones
      )
        .forEach(function (key) {
          const zoneNumber =
            parseInt(
              key,
              10
            );
          if (
            Number.isFinite(
              zoneNumber
            ) &&
            zoneNumber > safeTarget
          ) {
            delete projectZones[
              key
            ];
          }
        });
      zoneCount =
        String(
          safeTarget
        );
      highestReached =
        Math.max(
          1,
          Math.min(
            highestReached,
            safeTarget
          )
        );
      currentZone =
        Math.max(
          1,
          Math.min(
            currentZone,
            safeTarget
          )
        );
      state =
        normaliseZone(
          currentZone
        );
      accessories =
        normaliseAccessories(
          state.accessories
        );
      state.accessories =
        deepClone(
          accessories
        );
      projectZones[
        String(
          currentZone
        )
      ] =
        state;
      saveProject();
      updateEverything();
    }
    function applyZoneCountSelection(
      nextValue
    ) {
      const value =
        String(
          nextValue || ''
        );
      if (!value) {
        zoneCount =
          '';
        sessionStorage.setItem(
          'ldZoneCount',
          zoneCount
        );
        updateZoneCountScreen();
        syncZoneChoicePanel();
        updateZoneShortcuts();
        return;
      }
      if (
        value !== '1' &&
        value !== '2' &&
        value !== '3' &&
        value !== '4plus'
      ) {
        return;
      }
      if (
        value ===
        zoneCount
      ) {
        updateZoneCountScreen();
        syncZoneChoicePanel();
        return;
      }
      if (
        value === '1' ||
        value === '2' ||
        value === '3'
      ) {
        const target =
          parseInt(
            value,
            10
          );
        const removed =
          configuredZonesBeyond(
            target
          );
        if (
          removed.length
        ) {
          const zoneText =
            removed
              .map(function (
                zoneNumber
              ) {
                return 'Zone ' +
                  zoneNumber;
              })
              .join(', ');
          const confirmed =
            window.confirm(
              'Changing this project to ' +
              target +
              (
                target === 1
                  ? ' zone'
                  : ' zones'
              ) +
              ' will remove ' +
              zoneText +
              ' and its saved selections. Continue?'
            );
          if (!confirmed) {
            window.setTimeout(
              function () {
                updateZoneCountScreen();
                syncZoneChoicePanel();
              },
              0
            );
            return;
          }
        }
        trimProjectToCount(
          target
        );
        syncZoneChoicePanel();
        return;
      }
      zoneCount =
        '4plus';
      sessionStorage.setItem(
        'ldZoneCount',
        zoneCount
      );
      updateZoneCountScreen();
      syncZoneChoicePanel();
      updateZoneShortcuts();
    }
    function openZoneCountScreen() {
      saveProject();
      updateZoneCountScreen();
      syncZoneChoicePanel();
      showScreen(
        screens.zones
      );
    }
    function removeZoneFromProject(
      zoneNumber
    ) {
      const activeCount =
        displayZoneCount();
      if (
        zoneNumber <= 1 ||
        zoneNumber > activeCount ||
        activeCount <= 1
      ) {
        return;
      }
      saveProject();
      const zone =
        projectZones[
          String(
            zoneNumber
          )
        ]
          ? normaliseZone(
              zoneNumber
            )
          : null;
      const zoneName =
        (
          zone &&
          zone.name &&
          zone.name.trim()
        )
          ? ' – ' +
            zone.name.trim()
          : '';
      const confirmed =
        window.confirm(
          'Delete Zone ' +
          zoneNumber +
          zoneName +
          '? Any selections saved in this zone will be removed.'
        );
      if (!confirmed) {
        return;
      }
      const oldZones =
        deepClone(
          projectZones
        );
      const newZones =
        {};
      Object.keys(
        oldZones
      )
        .forEach(function (key) {
          const oldNumber =
            parseInt(
              key,
              10
            );
          if (
            !Number.isFinite(
              oldNumber
            ) ||
            oldNumber < 1 ||
            oldNumber > activeCount ||
            oldNumber === zoneNumber
          ) {
            return;
          }
          const newNumber =
            oldNumber > zoneNumber
              ? oldNumber - 1
              : oldNumber;
          const movedZone =
            deepClone(
              oldZones[
                key
              ]
            );
          movedZone.zoneNumber =
            newNumber;
          newZones[
            String(
              newNumber
            )
          ] =
            movedZone;
        });
      projectZones =
        newZones;
      const newCount =
        Math.max(
          1,
          activeCount - 1
        );
      zoneCount =
        'dynamic';
      if (
        currentZone > zoneNumber
      ) {
        currentZone -=
          1;
      } else if (
        currentZone ===
        zoneNumber
      ) {
        currentZone =
          Math.max(
            1,
            Math.min(
              zoneNumber - 1,
              newCount
            )
          );
      }
      const reachedNumbers =
        Object.keys(
          projectZones
        )
          .map(function (key) {
            return parseInt(
              key,
              10
            );
          })
          .filter(function (
            number
          ) {
            return Number.isFinite(
              number
            );
          });
      highestReached =
        reachedNumbers.length
          ? Math.max.apply(
              null,
              reachedNumbers
            )
          : 1;
      highestReached =
        Math.max(
          1,
          Math.min(
            newCount,
            highestReached
          )
        );
      state =
        normaliseZone(
          currentZone
        );
      accessories =
        normaliseAccessories(
          state.accessories
        );
      state.accessories =
        deepClone(
          accessories
        );
      projectZones[
        String(
          currentZone
        )
      ] =
        state;
      saveProject();
      updateEverything();
      syncZoneChoicePanel();
      if (
        currentZone > 1 &&
        !state.startMode &&
        !state.completedOnce
      ) {
        renderZoneStart();
        showScreen(
          screens.zoneStart
        );
        return;
      }
      if (
        isZoneComplete(
          state
        )
      ) {
        showScreen(
          screens.review
        );
        return;
      }
      jumpToStep(
        furthestUnlockedStep(
          state
        )
      );
    }
    function addNextZoneFromPrompt() {
      const activeCount =
        displayZoneCount();

      for (
        let zoneNumber =
          currentZone + 1;
        zoneNumber <= activeCount;
        zoneNumber++
      ) {
        const zone =
          projectZones[
            String(
              zoneNumber
            )
          ]
            ? normaliseZone(
                zoneNumber
              )
            : null;

        if (
          firstIncompletePriorZone(
            zoneNumber
          ) === null &&
          (
            !zone ||
            !isZoneComplete(
              zone
            )
          )
        ) {
          goToNextZone(
            zoneNumber
          );
          return;
        }
      }

      if (
        activeCount >= 6
      ) {
        return;
      }

      const nextZone =
        addZonePlaceholder();

      if (!nextZone) {
        return;
      }

      goToNextZone(
        nextZone
      );
    }
    function zoneIsActiveInProject(
      zoneNumber
    ) {
      return (
        zoneNumber >= 1 &&
        zoneNumber <=
        displayZoneCount()
      );
    }
    function firstIncompletePriorZone(
      zoneNumber
    ) {
      if (zoneNumber <= 1) {
        return null;
      }

      for (
        let i = 1;
        i < zoneNumber;
        i++
      ) {
        const zone =
          i === currentZone
            ? state
            : (
                projectZones[
                  String(i)
                ]
                  ? normaliseZone(i)
                  : null
              );

        if (
          !zone ||
          !isZoneComplete(
            zone
          )
        ) {
          return i;
        }
      }

      return null;
    }

    function addZonePlaceholder() {
      const activeCount =
        displayZoneCount();

      if (
        activeCount >= 6
      ) {
        return null;
      }

      const nextZone =
        activeCount + 1;

      zoneCount =
        'dynamic';

      sessionStorage.setItem(
        'ldZoneCount',
        zoneCount
      );

      if (
        !projectZones[
          String(
            nextZone
          )
        ]
      ) {
        projectZones[
          String(
            nextZone
          )
        ] =
          blankZone(
            nextZone
          );
      }

      highestReached =
        Math.min(
          6,
          Math.max(
            highestReached,
            nextZone
          )
        );

      saveProject();
      updateEverything();

      return nextZone;
    }

    function completedZoneNumbers() {
      const result =
        [];
      for (
        let i = 1;
        i <= displayZoneCount();
        i++
      ) {
        const zone =
          projectZones[
            String(i)
          ]
            ? normaliseZone(i)
            : null;
        if (
          zone &&
          isZoneComplete(
            zone
          )
        ) {
          result.push(
            i
          );
        }
      }
      return result;
    }
    function completedProjectTotal(
      excludeZoneNumber
    ) {
      let total =
        0;
      Object.keys(
        projectZones
      )
        .forEach(function (key) {
          const zoneNumber =
            Number(key);
          if (
            !zoneIsActiveInProject(
              zoneNumber
            )
          ) {
            return;
          }
          if (
            zoneNumber ===
            excludeZoneNumber
          ) {
            return;
          }
          const zone =
            normaliseZone(
              zoneNumber
            );
          if (
            isZoneComplete(
              zone
            )
          ) {
            total +=
              zoneTotalWithAccessoriesFor(
                zone
              );
          }
        });
      return total;
    }
    function projectTotalIncludingCurrent(
      currentAmount
    ) {
      return (
        completedProjectTotal(
          currentZone
        ) +
        Number(
          currentAmount || 0
        )
      );
    }
    function totalProjectLights() {
      let total =
        0;
      for (
        let zoneNumber = 1;
        zoneNumber <= displayZoneCount();
        zoneNumber++
      ) {
        const zone =
          zoneNumber === currentZone
            ? state
            : (
                projectZones[
                  String(
                    zoneNumber
                  )
                ]
                  ? normaliseZone(
                      zoneNumber
                    )
                  : null
              );
        if (
          !zone ||
          !zone.style ||
          Number(
            zone.quantity || 0
          ) < 1
        ) {
          continue;
        }
        if (
          zoneNumber === currentZone ||
          isZoneComplete(
            zone
          )
        ) {
          total +=
            Number(
              zone.quantity || 0
            );
        }
      }
      return total;
    }
    /* =====================================================
       SAVE
       ===================================================== */
    function saveAccessories() {
      clampAccessories();
      accessories =
        normaliseAccessories(
          accessories
        );
      if (state) {
        state.accessories =
          deepClone(
            accessories
          );
        projectZones[
          String(
            currentZone
          )
        ] =
          state;
        sessionStorage.setItem(
          PROJECT_KEY,
          JSON.stringify(
            projectZones
          )
        );
      }
      // Retained only as a legacy/current-zone fallback.
      sessionStorage.setItem(
        ACCESSORY_KEY,
        JSON.stringify(
          accessories
        )
      );
    }
    function saveProject() {
      if (!state) {
        return;
      }
      saveProjectName();
      state.quantity = normaliseLightQuantity(state.quantity);
      state.cablePlan =
        normaliseCablePlan(
          state.cablePlan
        );
      state.driverLocation =
        cleanDriverLocation(
          state.driverLocation
        );
      clampAccessories();
      // Drivers are always supplied as part of the configured lighting zone.
      state.ownDriver =
        false;
      state.accessories =
        deepClone(
          normaliseAccessories(
            accessories
          )
        );
      state.total =
        zoneTotalWithAccessoriesFor(
          state
        );
      state.completed =
        isZoneComplete(
          state
        );
      projectZones[
        String(
          currentZone
        )
      ] =
        state;
      sessionStorage.setItem(
        PROJECT_KEY,
        JSON.stringify(
          projectZones
        )
      );
      sessionStorage.setItem(
        CURRENT_ZONE_KEY,
        String(
          currentZone
        )
      );
      sessionStorage.setItem(
        HIGHEST_ZONE_KEY,
        String(
          highestReached
        )
      );
      sessionStorage.setItem(
        'ldZoneCount',
        zoneCount
      );
      if (
        currentZone === 1
      ) {
        sessionStorage.setItem(
          'ldZone1Style',
          state.style || ''
        );
        sessionStorage.setItem(
          'ldZone1StyleManuallyChanged',
          state.styleManuallyChanged
            ? 'true'
            : 'false'
        );
        sessionStorage.setItem(
          'ldZone1Finish',
          state.finish || ''
        );
        sessionStorage.setItem(
          'ldZone1Colour',
          state.colour || ''
        );
        sessionStorage.setItem(
          'ldZone1Quantity',
          String(
            state.quantity || 1
          )
        );
        sessionStorage.setItem(
          'ldZone1OwnDriver',
          state.ownDriver
            ? 'true'
            : 'false'
        );
        sessionStorage.setItem(
          'ldZone1UkPlug',
          state.ukPlug
            ? 'true'
            : 'false'
        );
        sessionStorage.setItem(
          'ldZone1Name',
          state.name || ''
        );
        sessionStorage.setItem(
          'ldZone1TotalPrice',
          String(
            state.total || 0
          )
        );
        if (
          state.sensor
        ) {
          sessionStorage.setItem(
            'ldZone1Sensor',
            state.sensor
          );
        } else {
          sessionStorage.removeItem(
            'ldZone1Sensor'
          );
        }
      }
      updateZoneShortcuts();
      updateStepNavigation();
    }
    function loadZone(
      zoneNumber
    ) {
      if (state) {
        saveProject();
      }
      currentZone =
        zoneNumber;
      highestReached =
        Math.max(
          highestReached,
          currentZone
        );
      highestReached =
        Math.min(
          6,
          highestReached
        );
      state =
        normaliseZone(
          currentZone
        );
      accessories =
        normaliseAccessories(
          state.accessories
        );
      state.accessories =
        deepClone(
          accessories
        );
      projectZones[
        String(
          currentZone
        )
      ] =
        state;
      saveProject();
      updateDynamicLabels();
    }
    /* =====================================================
       SCREEN HELPERS
       ===================================================== */
    function screenForStep(
      key
    ) {
      const step =
        STEP_ORDER
          .find(function (item) {
            return (
              item.key ===
              key
            );
          });
      if (!step) {
        return null;
      }
      return screens[
        step.screen
      ];
    }
    function furthestUnlockedStep(
      zone
    ) {
      let result =
        'style';
      STEP_ORDER
        .forEach(function (step) {
          if (
            isStepUnlocked(
              zone,
              step.key
            )
          ) {
            result =
              step.key;
          }
        });
      return result;
    }
    function showScreen(
      screen
    ) {
      if (!screen) {
        return;
      }
      modal
        .querySelectorAll(
          '.ld-screen'
        )
        .forEach(function (item) {
          item.classList.remove(
            'is-active'
          );
        });
      screen.classList.add(
        'is-active'
      );
      const modalBody =
        modal.querySelector(
          '.ld-modal-body'
        );
      if (modalBody) {
        modalBody.scrollTop =
          0;
      }
      updateDynamicLabels();
      updateProjectIdentityFields();
      updateZoneShortcuts();
      updateStepNavigation();
      if (
        screen ===
        screens.style
      ) {
        resetAllStylePreviewCards();
      }
      refreshCurrentSummary();
      focusActiveScreen();
      measureFooter();
      const currentStep = screen.querySelector('.ld-step-shortcut.is-current');
      if (currentStep) currentStep.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    /* =====================================================
       DYNAMIC LABELS
       ===================================================== */
    function updateDynamicLabels() {
      const label =
        'Zone ' +
        currentZone;
      modal
        .querySelectorAll(
          '[data-ld-current-zone-label]'
        )
        .forEach(function (
          element
        ) {
          element.textContent =
            label;
        });
      const controlLabel =
        modal.querySelector(
          '[data-ld-current-zone-control-label]'
        );
      if (controlLabel) {
        controlLabel.textContent =
          label +
          ' control:';
      }
      const totalLabel =
        modal.querySelector(
          '[data-ld-current-zone-total-label]'
        );
      if (totalLabel) {
        totalLabel.textContent =
          label +
          ' Total';
      }
      const reviewTotalLabel =
        modal.querySelector(
          '[data-ld-review-zone-total-label]'
        );
      if (reviewTotalLabel) {
        reviewTotalLabel.textContent =
          label +
          ' Total';
      }
      const nextText =
        modal.querySelector(
          '[data-ld-review-next-text]'
        );
      if (nextText) {
        nextText.textContent =
          'Save Zone & Review Project';
      }
      const reviewAddZone =
        modal.querySelector(
          '[data-ld-review-add-zone]'
        );
      if (reviewAddZone) {
        const atZoneLimit =
          displayZoneCount() >= 6;
        reviewAddZone.hidden =
          atZoneLimit;
        reviewAddZone.disabled =
          atZoneLimit;
      }
    }
    /* =====================================================
       ZONE SHORTCUTS
       ===================================================== */
    function updateZoneShortcuts() {
      modal
        .querySelectorAll(
          '[data-ld-zone-shortcuts]'
        )
        .forEach(function (
          bar
        ) {
          if (!zoneCount) {
            bar.classList.add(
              'is-hidden'
            );
            return;
          }
          bar.classList.remove(
            'is-hidden'
          );
          const list =
            bar.querySelector(
              '[data-ld-zone-shortcuts-list]'
            );
          if (!list) {
            return;
          }
          list.innerHTML =
            '';
          const count =
            displayZoneCount();
          for (
            let zoneNumber = 1;
            zoneNumber <= count;
            zoneNumber++
          ) {
            const item =
              document.createElement(
                'div'
              );
            item.className =
              'ld-zone-shortcut-item';
            const button =
              document.createElement(
                'button'
              );
            button.type =
              'button';
            button.className =
              'ld-zone-shortcut';
            const zone =
              projectZones[
                String(
                  zoneNumber
                )
              ]
                ? normaliseZone(
                    zoneNumber
                  )
                : null;
            const zoneName =
              (
                zone &&
                zone.name &&
                zone.name.trim()
              )
                ? zone.name.trim()
                : '';
            button.textContent =
              zoneName
                ? 'Zone ' +
                  zoneNumber +
                  ' – ' +
                  zoneName
                : 'Zone ' +
                  zoneNumber;
            button.classList.toggle(
              'has-zone-name',
              Boolean(
                zoneName
              )
            );
            const blockingZone =
              firstIncompletePriorZone(
                zoneNumber
              );
            const complete =
              zone
                ? isZoneComplete(
                    zone
                  )
                : false;
            const current =
              zoneNumber ===
              currentZone;
            const sequenceLocked =
              blockingZone !== null;

            button.disabled =
              sequenceLocked;
            button.classList.toggle(
              'is-sequence-locked',
              sequenceLocked
            );

            if (sequenceLocked) {
              const mainLabel =
                document.createElement(
                  'span'
                );
              mainLabel.className =
                'ld-zone-shortcut-main';
              mainLabel.textContent =
                zoneName
                  ? 'Zone ' +
                    zoneNumber +
                    ' – ' +
                    zoneName
                  : 'Zone ' +
                    zoneNumber;

              const lockLabel =
                document.createElement(
                  'span'
                );
              lockLabel.className =
                'ld-zone-shortcut-lock';
              lockLabel.textContent =
                'Complete Zone ' +
                blockingZone +
                ' to unlock';

              button.textContent =
                '';
              button.appendChild(
                mainLabel
              );
              button.appendChild(
                lockLabel
              );

              button.title =
                'Complete Zone ' +
                blockingZone +
                ' before opening Zone ' +
                zoneNumber +
                '.';
            }

            button.classList.toggle(
              'is-current',
              current
            );
            button.classList.toggle(
              'is-complete',
              complete
            );

            item.classList.toggle(
              'is-current',
              current
            );
            item.classList.toggle(
              'is-complete',
              complete
            );
            item.classList.toggle(
              'is-sequence-locked',
              sequenceLocked
            );

            button.addEventListener(
              'click',
              function () {
                if (
                  button.disabled
                ) {
                  return;
                }
                if (
                  zoneNumber ===
                  currentZone
                ) {
                  if (
                    isZoneComplete(
                      state
                    )
                  ) {
                    updateReview();
                    showScreen(
                      screens.review
                    );
                  }
                  return;
                }
                jumpToZone(
                  zoneNumber
                );
              }
            );
            item.appendChild(
              button
            );
            if (
              zoneNumber > 1
            ) {
              item.classList.add(
                'has-remove'
              );

              const removeButton =
                document.createElement(
                  'button'
                );
              removeButton.type =
                'button';
              removeButton.className =
                'ld-zone-shortcut-remove';
              removeButton.setAttribute(
                'aria-label',
                'Delete Zone ' +
                  zoneNumber
              );
              removeButton.title =
                'Delete Zone ' +
                zoneNumber;
              removeButton.textContent =
                '×';
              removeButton.addEventListener(
                'click',
                function (
                  event
                ) {
                  event.preventDefault();
                  event.stopPropagation();
                  removeZoneFromProject(
                    zoneNumber
                  );
                }
              );
              item.appendChild(
                removeButton
              );
            }
            list.appendChild(
              item
            );
          }

          const addItem =
            document.createElement(
              'div'
            );
          addItem.className =
            'ld-zone-add-item';

          const addButton =
            document.createElement(
              'button'
            );
          addButton.type =
            'button';
          addButton.className =
            'ld-zone-add-shortcut';

          const atZoneLimit =
            count >= 6;

          addButton.disabled =
            atZoneLimit;
          addButton.textContent =
            atZoneLimit
              ? 'Maximum 6 Zones'
              : '+ Add Lighting Zone';

          addButton.title =
            atZoneLimit
              ? 'This project already has the maximum of 6 lighting zones.'
              : 'Add another lighting zone to the project. It will unlock once the previous zone is complete.';

          addButton.setAttribute(
            'aria-label',
            addButton.title
          );

          addButton.addEventListener(
            'click',
            function () {
              if (
                addButton.disabled
              ) {
                return;
              }

              addZonePlaceholder();
            }
          );

          addItem.appendChild(
            addButton
          );

          list.appendChild(
            addItem
          );
        });
    }
    /* =====================================================
       STEP NAVIGATION
       ===================================================== */
    function updateStepNavigation() {
      modal.querySelectorAll('[data-ld-step-navigation]').forEach(nav => {
        const screen = nav.closest('[data-ld-screen]');
        const title = nav.querySelector('[data-ld-step-navigation-title]');
        const list = nav.querySelector('[data-ld-step-navigation-list]');
        if (title) title.textContent = 'Zone ' + currentZone + (state.name.trim() ? ' – ' + state.name.trim() : '') + ' progress';
        if (!list) return;
        const scroll = list.scrollLeft;
        const focusedKey = list.contains(document.activeElement) ? document.activeElement.dataset.ldStep : null;
        list.innerHTML = '';
        STEP_ORDER.forEach((step, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ld-step-shortcut';
          button.dataset.ldStep = step.key;
          button.innerHTML = '<span class="ld-step-shortcut-number">' + (index + 1) + '</span><span class="ld-step-shortcut-label">' + step.label + '</span>';
          const complete = isStepComplete(state, step.key);
          const unlocked = isStepUnlocked(state, step.key);
          const current = screen.dataset.ldScreen === step.screen;
          button.disabled = !unlocked;
          button.classList.toggle('is-complete', complete);
          button.classList.toggle('is-current', current);
          button.classList.toggle('is-locked', !unlocked);
          if (current) button.setAttribute('aria-current', 'step');
          button.addEventListener('click', () => { if (unlocked && !current) jumpToStep(step.key); });
          list.appendChild(button);
          if (focusedKey === step.key && !button.disabled) button.focus({ preventScroll: true });
        });
        list.scrollLeft = scroll;
      });
    }
    /* =====================================================
       JUMPING
       ===================================================== */
    function jumpToZone(
      zoneNumber
    ) {
      const blockingZone =
        firstIncompletePriorZone(
          zoneNumber
        );

      if (
        blockingZone !== null
      ) {
        updateZoneShortcuts();
        return;
      }

      saveProject();
      loadZone(
        zoneNumber
      );
      updateEverything();
      if (
        zoneNumber > 1 &&
        !state.startMode &&
        !state.completedOnce
      ) {
        renderZoneStart();
        showScreen(
          screens.zoneStart
        );
        return;
      }
      if (
        isZoneComplete(
          state
        )
      ) {
        showScreen(
          screens.review
        );
        return;
      }
      jumpToStep(
        furthestUnlockedStep(
          state
        )
      );
    }
    function jumpToStep(
      key
    ) {
      if (
        !isStepUnlocked(
          state,
          key
        )
      ) {
        return;
      }
      updateEverything();
      if (
        key ===
        'accessories'
      ) {
        openAccessories();
        return;
      }
      showScreen(
        screenForStep(
          key
        )
      );
    }
    /* =====================================================
       PRICE HELPERS
       ===================================================== */
    function styleFromPrice(
      styleKey
    ) {
      const styleData =
        lightProducts[
          styleKey
        ];
      if (!styleData) {
        return null;
      }
      const prices =
        [];
      Object.keys(
        styleData
      )
        .forEach(function (
          finishKey
        ) {
          Object.keys(
            styleData[
              finishKey
            ]
          )
            .forEach(function (
              colourKey
            ) {
              const product =
                styleData[
                  finishKey
                ][
                  colourKey
                ];
              if (
                product &&
                typeof product.price ===
                'number'
              ) {
                prices.push(
                  product.price
                );
              }
            });
        });
      if (!prices.length) {
        return null;
      }
      return Math.min.apply(
        null,
        prices
      );
    }
    function finishFromPrice(
      styleKey,
      finishKey
    ) {
      if (
        !lightProducts[
          styleKey
        ] ||
        !lightProducts[
          styleKey
        ][
          finishKey
        ]
      ) {
        return null;
      }
      const prices =
        Object.keys(
          lightProducts[
            styleKey
          ][
            finishKey
          ]
        )
          .map(function (
            colourKey
          ) {
            return (
              lightProducts[
                styleKey
              ][
                finishKey
              ][
                colourKey
              ].price
            );
          });
      if (!prices.length) {
        return null;
      }
      return Math.min.apply(
        null,
        prices
      );
    }
    function updateStylePrices() {
      modal
        .querySelectorAll(
          '[data-ld-style-price]'
        )
        .forEach(function (
          element
        ) {
          const price =
            styleFromPrice(
              element.dataset.ldStylePrice
            );
          element.textContent =
            price === null
              ? ''
              : money(
                  price
                );
        });
    }
    function updateFinishPrices() {
      modal
        .querySelectorAll(
          '[data-ld-finish-price]'
        )
        .forEach(function (
          element
        ) {
          const price =
            finishFromPrice(
              state.style,
              element.dataset.ldFinishPrice
            );
          element.textContent =
            price === null
              ? ''
              : money(
                  price
                );
        });
    }
    function updateColourPrices() {
      modal
        .querySelectorAll(
          '[data-ld-colour-price]'
        )
        .forEach(function (
          element
        ) {
          const colourKey =
            element.dataset.ldColourPrice;
          const product =
            (
              lightProducts[
                state.style
              ] &&
              lightProducts[
                state.style
              ][
                state.finish
              ] &&
              lightProducts[
                state.style
              ][
                state.finish
              ][
                colourKey
              ]
            )
              ? lightProducts[
                  state.style
                ][
                  state.finish
                ][
                  colourKey
                ]
              : null;
          element.textContent =
            product
              ? money(
                  product.price
                )
              : '';
        });
    }
    /* =====================================================
       COLOUR VALIDATION
       ===================================================== */
    function availableFinishesForColour(
      colourKey
    ) {
      if (
        !state.style ||
        !colourKey ||
        !lightProducts[
          state.style
        ]
      ) {
        return [];
      }

      return Object.keys(
        lightProducts[
          state.style
        ]
      )
        .filter(function (
          finishKey
        ) {
          return !!(
            lightProducts[
              state.style
            ][
              finishKey
            ] &&
            lightProducts[
              state.style
            ][
              finishKey
            ][
              colourKey
            ]
          );
        });
    }

    function unavailableColourFinishText(
      colourKey
    ) {
      const finishes =
        availableFinishesForColour(
          colourKey
        );

      if (!finishes.length) {
        return {
          title:
            'Not available for this light style',
          copy:
            'Choose another colour temperature.'
        };
      }

      const names =
        finishes.map(
          finishName
        );

      let finishList =
        names[0];

      if (names.length === 2) {
        finishList =
          names[0] +
          ' or ' +
          names[1];
      } else if (names.length > 2) {
        finishList =
          names.slice(
            0,
            -1
          ).join(
            ', '
          ) +
          ' or ' +
          names[
            names.length - 1
          ];
      }

      return {
        title:
          names.length === 1
            ? 'Only available with ' +
              finishList +
              ' finish'
            : 'Available with ' +
              finishList +
              ' finishes',
        copy:
          'Go back to Finish to change your selection.'
      };
    }
    function availableColoursForCurrent() {
      if (
        !state.style ||
        !state.finish ||
        !lightProducts[
          state.style
        ] ||
        !lightProducts[
          state.style
        ][
          state.finish
        ]
      ) {
        return [];
      }
      return Object.keys(
        lightProducts[
          state.style
        ][
          state.finish
        ]
      );
    }
    function ensureCurrentColourValid() {
      const available =
        availableColoursForCurrent();

      if (
        state.colour &&
        available.includes(
          state.colour
        )
      ) {
        return false;
      }

      const changed =
        !!state.colour;

      state.colour =
        '';
      state.stepDone.colour =
        false;

      return changed;
    }
    /* =====================================================
       ZONE COUNT UI
       ===================================================== */
    function updateZoneCountScreen() {
      modal
        .querySelectorAll(
          '.ld-zone-option'
        )
        .forEach(function (
          button
        ) {
          button.classList.toggle(
            'is-selected',
            button.dataset.zoneCount ===
            zoneCount
          );
        });
      const next =
        modal.querySelector(
          '[data-ld-zone-next]'
        );
      if (next) {
        next.disabled =
          !zoneCount;
      }
      const note =
        modal.querySelector(
          '[data-ld-four-zone-note]'
        );
      if (note) {
        note.classList.toggle(
          'is-visible',
          zoneCount ===
          '4plus'
        );
      }
      syncZoneChoicePanel();
    }
    /* =====================================================
       UPDATE STYLE
       ===================================================== */
    function updateStyle() {
      updateStylePrices();
      modal
        .querySelectorAll(
          '.ld-style-card'
        )
        .forEach(function (
          card
        ) {
          const selected =
            card.dataset.style ===
            state.style;
          const sourceStyle =
            currentZone === 1 &&
            card.dataset.style ===
            startingStyle;
          card.classList.toggle(
            'is-selected',
            selected
          );
          card.classList.toggle(
            'is-source-style',
            sourceStyle
          );
          const label =
            card.querySelector(
              '.ld-style-selected-label'
            );
          if (label) {
            label.textContent =
              selected
                ? (
                    sourceStyle &&
                    !state.styleManuallyChanged
                  )
                    ? '✓ Selected'
                    : '✓ Selected'
                : '';
          }
          const sourceLabel =
            card.querySelector(
              '[data-ld-style-origin-label]'
            );
          if (sourceLabel) {
            sourceLabel.hidden =
              !sourceStyle;
          }
        });
      const note =
        modal.querySelector(
          '[data-ld-preselected-note]'
        );
      if (note) {
        note.style.display =
          currentZone === 1
            ? 'block'
            : 'none';
      }
      const noteStyle =
        modal.querySelector(
          '[data-ld-preselected-style-name]'
        );
      if (noteStyle) {
        noteStyle.textContent =
          styleName(
            startingStyle
          );
      }
      const back =
        modal.querySelector(
          '[data-ld-style-back]'
        );
      if (back) {
        back.style.display =
          currentZone === 1
            ? 'none'
            : '';
      }
      const next =
        modal.querySelector(
          '[data-ld-style-next]'
        );
      if (next) {
        next.disabled =
          !state.style;
      }
      modal.querySelectorAll('.ld-style-card, .ld-finish-card, .ld-colour-card').forEach(card => {
        card.setAttribute('aria-pressed', String(card.classList.contains('is-selected')));
      });
    }
    /* =====================================================
       UPDATE FINISH
       ===================================================== */
    function updateFinish() {
      const available =
        availableFinishesForCurrent();
      if (
        state.finish &&
        !available.includes(
          state.finish
        )
      ) {
        state.finish =
          '';
        state.colour =
          '';
        state.stepDone.finish =
          false;
        state.stepDone.colour =
          false;
      }
      updateFinishPrices();
      modal
        .querySelectorAll(
          '.ld-finish-card'
        )
        .forEach(function (
          card
        ) {
          const allowed =
            available.includes(
              card.dataset.finish
            );
          card.hidden =
            !allowed;
          card.disabled =
            !allowed;
          card.classList.toggle(
            'is-selected',
            (
              allowed &&
              card.dataset.finish ===
              state.finish
            )
          );
        });
      updateFinishImages();
      const next =
        modal.querySelector(
          '[data-ld-finish-next]'
        );
      if (next) {
        next.disabled =
          !state.finish ||
          !available.includes(
            state.finish
          );
      }
      const summary =
        modal.querySelector(
          '[data-ld-finish-style-summary]'
        );
      if (summary) {
        summary.textContent =
          styleName(
            state.style
          );
      }
      modal.querySelectorAll('.ld-style-card, .ld-finish-card, .ld-colour-card').forEach(card => {
        card.setAttribute('aria-pressed', String(card.classList.contains('is-selected')));
      });
    }
    /* =====================================================
       UPDATE COLOUR
       ===================================================== */
    function updateColour() {
      ensureCurrentColourValid();
      updateColourPrices();
      updateStyleSpecificColourCopy();
      const available =
        availableColoursForCurrent();
      modal
        .querySelectorAll(
          '.ld-colour-card'
        )
        .forEach(function (
          card
        ) {
          const value =
            card.dataset.colour;
          const allowed =
            available.includes(
              value
            );
          const hideUnavailableCctForLineaPure =
            state.style === 'long-rectangle-2' &&
            value === 'cct';
          card.hidden =
            hideUnavailableCctForLineaPure;
          card.disabled =
            !allowed;
          card.classList.toggle(
            'is-selected',
            (
              allowed &&
              value ===
              state.colour
            )
          );
          const unavailable =
            card.querySelector(
              '.ld-unavailable-label'
            );
          const availabilityTitle =
            card.querySelector(
              '[data-ld-colour-availability-title]'
            );
          const availabilityCopy =
            card.querySelector(
              '[data-ld-colour-availability-copy]'
            );

          if (!allowed) {
            const reason =
              unavailableColourFinishText(
                value
              );

            if (unavailable) {
              unavailable.textContent =
                reason.title;
            }
            if (availabilityTitle) {
              availabilityTitle.textContent =
                reason.title;
            }
            if (availabilityCopy) {
              availabilityCopy.textContent =
                reason.copy;
            }
          } else {
            if (unavailable) {
              unavailable.textContent =
                '';
            }
            if (availabilityTitle) {
              availabilityTitle.textContent =
                '';
            }
            if (availabilityCopy) {
              availabilityCopy.textContent =
                '';
            }
          }
        });
      const styleSummary =
        modal.querySelector(
          '[data-ld-colour-style-summary]'
        );
      const finishSummary =
        modal.querySelector(
          '[data-ld-colour-finish-summary]'
        );
      if (styleSummary) {
        styleSummary.textContent =
          styleName(
            state.style
          );
      }
      if (finishSummary) {
        finishSummary.textContent =
          finishName(
            state.finish
          );
      }

      const colourNext =
        modal.querySelector(
          '[data-ld-colour-next]'
        );
      if (colourNext) {
        colourNext.disabled =
          !state.colour ||
          !available.includes(
            state.colour
          );
      }

      const cctTradeoff =
        modal.querySelector(
          '[data-ld-cct-tradeoff]'
        );
      if (cctTradeoff) {
        const showAureliaTradeoff =
          state.style ===
            'round-surface' &&
          state.finish ===
            'aluminium' &&
          available.includes(
            'cct'
          ) &&
          available.includes(
            'natural'
          );

        cctTradeoff.hidden =
          !showAureliaTradeoff;

        if (showAureliaTradeoff) {
          cctTradeoff.innerHTML =
            '<strong>Flexibility vs maximum brightness:</strong> ' +
            'Aurelia CCT is 150–180lm at £15.99 per light. ' +
            'Natural White is up to 242lm at £7.99 per light. ' +
            'Choose CCT for adjustable white light, or fixed white for the strongest output and lower price.';
        }
      }

      modal.querySelectorAll('.ld-style-card, .ld-finish-card, .ld-colour-card').forEach(card => {
        card.setAttribute('aria-pressed', String(card.classList.contains('is-selected')));
      });
    }
    /* =====================================================
       UPDATE QUANTITY
       ===================================================== */
    function updateQuantityPlanningGuide() {

      const guidance =
        planningGuidance[
          state.style
        ] || null;


      function setPlanningText(
        selector,
        value
      ) {

        const element =
          modal.querySelector(
            selector
          );

        if (element) {
          element.textContent =
            value;
        }

      }


      setPlanningText(
        '[data-ld-quantity-guide-selected-style]',
        styleName(
          state.style
        )
      );


      const aureliaDiagram =
        modal.querySelector(
          '[data-ld-quantity-guide-aurelia-diagram]'
        );


      if (guidance) {

        if (aureliaDiagram) {
          aureliaDiagram.hidden =
            false;
        }

        setPlanningText(
          '[data-ld-quantity-guide-spacing]',
          guidance.spacing
        );

        setPlanningText(
          '[data-ld-quantity-guide-spacing-note]',
          guidance.spacingNote
        );

        setPlanningText(
          '[data-ld-quantity-guide-spacing-copy]',
          guidance.spacingCopy
        );

        setPlanningText(
          '[data-ld-quantity-guide-spacing-svg]',
          guidance.spacing +
            ' centres'
        );

        return;

      }


      if (aureliaDiagram) {
        aureliaDiagram.hidden =
          true;
      }


      setPlanningText(
        '[data-ld-quantity-guide-spacing]',
        'Evenly'
      );

      setPlanningText(
        '[data-ld-quantity-guide-spacing-note]',
        'across the illuminated run'
      );

      setPlanningText(
        '[data-ld-quantity-guide-spacing-copy]',
        'Space the fittings evenly across the illuminated run. Use the product-specific installation guidance for final positioning.'
      );

      setPlanningText(
        '[data-ld-quantity-guide-spacing-svg]',
        'Even spacing'
      );

    }

    function updateQuantity() {

      updateQuantityPlanningGuide();

      state.quantity = normaliseLightQuantity(state.quantity);
      clampAccessories();
      const product =
        selectedLightProduct(
          state
        );
      if (!product) {
        return;
      }
      const lightsTotal =
        lightSubtotalFor(
          state
        );
      const wattsPerLight =
        product.watts || 0;
      const totalPower =
        totalWattsFor(
          state
        );
      function set(
        selector,
        value
      ) {
        const element =
          modal.querySelector(
            selector
          );
        if (element) {
          element.textContent =
            value;
        }
      }
      set(
        '[data-ld-quantity-number]',
        state.quantity
      );
      set(
        '[data-ld-connection-zone-quantity]',
        'Your zone: ' +
          state.quantity +
          (state.quantity === 1
            ? ' light'
            : ' lights')
      );
      set(
        '[data-ld-quantity-product-name]',
        styleName(
          state.style
        )
      );
      set(
        '[data-ld-quantity-product-spec]',
        finishName(
          state.finish
        ) +
        ' · ' +
        colourName(
          state.colour
        )
      );
      set(
        '[data-ld-light-unit-price]',
        money(
          product.price
        )
      );
      set(
        '[data-ld-lights-subtotal]',
        money(
          lightsTotal
        )
      );
      set(
        '[data-ld-power-per-light]',
        tidyWatts(
          wattsPerLight
        )
      );
      set(
        '[data-ld-zone-total-power]',
        tidyWatts(
          totalPower
        )
      );
      set(
        '[data-ld-light-line-title]',
        state.quantity +
        ' × ' +
        styleName(
          state.style
        )
      );
      set(
        '[data-ld-light-line-calculation]',
        state.quantity +
        ' × ' +
        money(
          product.price
        )
      );
      set(
        '[data-ld-light-line-total]',
        money(
          lightsTotal
        )
      );
      set(
        '[data-ld-quantity-project-total]',
        money(
          projectTotalIncludingCurrent(
            lightsTotal
          )
        )
      );
      set(
        '[data-ld-quantity-total-note]',
        currentZone === 1
          ? 'Zone 1 lights'
          : 'Completed zones + Zone ' +
            currentZone +
            ' lights'
      );
      const minus =
        modal.querySelector(
          '[data-ld-quantity-minus]'
        );
      const plus =
        modal.querySelector(
          '[data-ld-quantity-plus]'
        );
      if (minus) {
        minus.disabled =
          state.quantity <= 1;
      }
      if (plus) {
        plus.disabled =
          state.quantity >= 36;
      }
      const warning =
        modal.querySelector(
          '[data-ld-max-quantity-warning]'
        );
      if (warning) {
        warning.classList.toggle(
          'is-visible',
          state.quantity >= 36
        );
      }
      saveProject();
      refreshCurrentSummary();
    }
    /* =====================================================
       UPDATE DRIVER
       ===================================================== */
    let driverImageRequest =
      0;
    function updateDriverImage(
      driver
    ) {
      const wrap =
        modal.querySelector(
          '[data-ld-driver-image-wrap]'
        );
      const image =
        modal.querySelector(
          '[data-ld-driver-image]'
        );
      if (
        !wrap ||
        !image ||
        !driver ||
        !driver.handle
      ) {
        return;
      }
      const requestId =
        ++driverImageRequest;
      wrap.hidden =
        false;
      wrap.classList.add(
        'is-loading'
      );
      productDataFromHandle(
        driver.handle
      )
        .then(function (
          product
        ) {
          if (
            requestId !==
            driverImageRequest
          ) {
            return;
          }
          const src =
            product.featured_image ||
            (
              product.images &&
              product.images[0]
            ) ||
            '';
          if (!src) {
            wrap.hidden =
              true;
            return;
          }
          image.src =
            src;
          image.alt =
            product.title ||
            (
              '24V ' +
              driver.watts +
              'W LED Driver'
            );
        })
        .catch(function () {
          if (
            requestId ===
            driverImageRequest
          ) {
            wrap.hidden =
              true;
          }
        })
        .finally(function () {
          if (
            requestId ===
            driverImageRequest
          ) {
            wrap.classList.remove(
              'is-loading'
            );
          }
        });
    }
    function updateDriver() {
      // Driver is a required component and cannot be removed from the bundle.
      state.ownDriver =
        false;
      const product =
        selectedLightProduct(
          state
        );
      const driver =
        selectDriverFor(
          state
        );
      if (
        !product ||
        !driver
      ) {
        return;
      }
      updateDriverImage(
        driver
      );
      if (
        state.ownDriver
      ) {
        state.ukPlug =
          false;
      }
      const base =
        baseZoneFor(
          state
        );
      const watts =
        totalWattsFor(
          state
        );
      const blocks =
        base.blocks;
      const connections =
        driver.ports +
        (
          blocks * 5
        );
      function set(
        selector,
        value
      ) {
        const element =
          modal.querySelector(
            selector
          );
        if (element) {
          element.textContent =
            value;
        }
      }
      set(
        '[data-ld-driver-heading]',
        driver.watts +
        'W Driver'
      );
      set(
        '[data-ld-driver-reason]',
        'Smallest compatible driver for ' +
          state.quantity +
          (
            state.quantity === 1
              ? ' light using '
              : ' lights using '
          ) +
          tidyWatts(
            watts
          ) +
          ' in total.'
      );
      set(
        '[data-ld-driver-product-name]',
        '24V ' +
        driver.watts +
        'W LED Driver'
      );
      set(
        '[data-ld-driver-product-spec]',
        driver.watts +
        'W capacity · Automatically matched'
      );
      set(
        '[data-ld-driver-price]',
        money(
          driver.price
        )
      );
      set(
        '[data-ld-driver-cost-note]',
        'Required driver · ' +
          money(
            driver.price
          ) +
          ' added to this zone'
      );
      set(
        '[data-ld-driver-zone-power]',
        tidyWatts(
          watts
        )
      );
      set(
        '[data-ld-driver-capacity]',
        driver.watts +
        'W'
      );
      set(
        '[data-ld-driver-ports]',
        driver.ports
      );

      set(
        '[data-ld-driver-light-count]',
        state.quantity
      );
      const ownCheckbox =
        modal.querySelector(
          '[data-ld-own-driver]'
        );
      const ownWarning =
        modal.querySelector(
          '[data-ld-own-driver-warning]'
        );
      if (ownCheckbox) {
        ownCheckbox.checked =
          state.ownDriver;
      }
      if (ownWarning) {
        ownWarning.classList.toggle(
          'is-visible',
          state.ownDriver
        );
      }
      const plugWrap =
        modal.querySelector(
          '[data-ld-uk-plug-wrap]'
        );
      const plugCheckbox =
        modal.querySelector(
          '[data-ld-uk-plug]'
        );
      if (plugWrap) {
        plugWrap.classList.toggle(
          'is-hidden',
          state.ownDriver
        );
      }
      if (plugCheckbox) {
        plugCheckbox.checked =
          (
            !state.ownDriver &&
            state.ukPlug
          );
      }
      const bareMainsOption =
        modal.querySelector(
          '[data-ld-bare-mains-option]'
        );
      const ukPlugOption =
        modal.querySelector(
          '[data-ld-uk-plug-option]'
        );
      const bareMainsCheck =
        modal.querySelector(
          '[data-ld-bare-mains-check]'
        );
      const ukPlugCheck =
        modal.querySelector(
          '[data-ld-uk-plug-check]'
        );
      const ukPlugSelected =
        (
          !state.ownDriver &&
          state.ukPlug
        );
      if (bareMainsOption) {
        bareMainsOption.setAttribute('aria-pressed', String(!ukPlugSelected));
        bareMainsOption.classList.toggle(
          'is-selected',
          !ukPlugSelected
        );
      }
      if (ukPlugOption) {
        ukPlugOption.classList.toggle(
          'is-selected',
          ukPlugSelected
        );
      }
      if (bareMainsCheck) {
        bareMainsCheck.hidden =
          ukPlugSelected;
      }
      if (ukPlugCheck) {
        ukPlugCheck.hidden =
          !ukPlugSelected;
      }
      const blockSection =
        modal.querySelector(
          '[data-ld-block-section]'
        );
      const blockNone =
        modal.querySelector(
          '[data-ld-block-none]'
        );
      const blockRow =
        modal.querySelector(
          '[data-ld-breakdown-block-row]'
        );
      if (
        blocks > 0
      ) {

        set(
          '[data-ld-connection-summary-heading]',
          'Extra connections added automatically'
        );

        set(
          '[data-ld-connection-summary-copy]',
          state.quantity +
            ' lights need more connections than the ' +
            driver.ports +
            '-port driver provides on its own, so we have added the minimum required distribution block' +
            (
              blocks === 1
                ? '.'
                : 's.'
            )
        );

        set(
          '[data-ld-block-intro]',
          'Your ' +
            state.quantity +
            ' lights need more connections than this driver provides on its own, so we have automatically added ' +
            blocks +
            (
              blocks === 1
                ? ' 6-way distribution block.'
                : ' 6-way distribution blocks.'
            )
        );

        set(
          '[data-ld-block-driver-ports]',
          driver.ports +
            (
              driver.ports === 1
                ? ' light port'
                : ' light ports'
            )
        );

        set(
          '[data-ld-block-count-flow]',
          blocks +
            (
              blocks === 1
                ? ' × 6-way block'
                : ' × 6-way blocks'
            )
        );

        set(
          '[data-ld-block-total-connections]',
          connections +
            ' total'
        );

        if (blockSection) {
          blockSection.style.display =
            'block';
        }
        if (blockNone) {
          blockNone.style.display =
            'none';
        }
        if (blockRow) {
          blockRow.style.display =
            'flex';
        }
        set(
          '[data-ld-block-product-text]',
          blocks +
          ' × 6-Way Distribution ' +
          (
            blocks === 1
              ? 'Block'
              : 'Blocks'
          )
        );
        set(
          '[data-ld-block-connection-text]',
          'Automatically added · ' +
          connections +
          ' usable light connections available in total.'
        );
        set(
          '[data-ld-block-price]',
          money(
            base.blocksTotal
          )
        );
        set(
          '[data-ld-breakdown-block-label]',
          blocks +
          ' × 6-Way Distribution ' +
          (
            blocks === 1
              ? 'Block'
              : 'Blocks'
          )
        );
        set(
          '[data-ld-breakdown-block-price]',
          money(
            base.blocksTotal
          )
        );
      } else {

        set(
          '[data-ld-connection-summary-heading]',
          'All lights connect directly to this driver'
        );

        set(
          '[data-ld-connection-summary-copy]',
          'No extra connection hardware is required for this zone.'
        );

        const sparePorts =
          Math.max(
            0,
            driver.ports -
              state.quantity
          );

        set(
          '[data-ld-block-none-text]',
          'Your ' +
            state.quantity +
            (
              state.quantity === 1
                ? ' light connects directly to this ' :
                  ' lights connect directly to this '
            ) +
            driver.ports +
            '-port driver. ' +
            (
              sparePorts > 0
                ? sparePorts +
                  (
                    sparePorts === 1
                      ? ' spare light port remains.'
                      : ' spare light ports remain.'
                  )
                : 'All available light ports are in use.'
            )
        );

        set(
          '[data-ld-block-none-driver-ports]',
          driver.ports +
            (
              driver.ports === 1
                ? ' light port'
                : ' light ports'
            )
        );

        set(
          '[data-ld-block-none-lights]',
          state.quantity +
            (
              state.quantity === 1
                ? ' light'
                : ' lights'
            )
        );

        if (blockSection) {
          blockSection.style.display =
            'none';
        }
        if (blockNone) {
          blockNone.style.display =
            'block';
        }
        if (blockRow) {
          blockRow.style.display =
            'none';
        }
      }
      set(
        '[data-ld-breakdown-lights-label]',
        state.quantity +
        ' × ' +
        styleName(
          state.style
        ) +
        ' lights'
      );
      set(
        '[data-ld-breakdown-lights-price]',
        money(
          base.lightsTotal
        )
      );
      set(
        '[data-ld-breakdown-driver-label]',
        driver.watts +
          'W Driver'
      );
      set(
        '[data-ld-breakdown-driver-price]',
        money(
          base.driverTotal
        )
      );
      set(
        '[data-ld-breakdown-uk-plug-price]',
        money(
          ukPlugCable.price
        )
      );
      set(
        '[data-ld-zone-total-price]',
        money(
          base.total
        )
      );
      set(
        '[data-ld-driver-project-total]',
        money(
          projectTotalIncludingCurrent(
            base.total
          )
        )
      );
      const extrasWrap =
        modal.querySelector(
          '[data-ld-breakdown-current-extras]'
        );

      if (extrasWrap) {
        extrasWrap.innerHTML =
          '';

        function addRetainedBreakdownRow(
          label,
          price
        ) {
          const row =
            document.createElement(
              'div'
            );
          row.className =
            'ld-price-row ld-price-row--retained';
          row.innerHTML =
            '<span>' +
              escapeHtml(
                label
              ) +
            '</span>' +
            '<strong>' +
              money(
                price
              ) +
            '</strong>';
          extrasWrap.appendChild(
            row
          );
        }

        if (
          state.sensor &&
          state.sensor !==
            'none' &&
          sensors[
            state.sensor
          ]
        ) {
          addRetainedBreakdownRow(
            sensorName(
              state.sensor
            ),
            sensors[
              state.sensor
            ].price
          );
        }

        const retainedAccessories =
          normaliseAccessories(
            accessories
          );

        Object.keys(
          accessoryProducts
        )
          .forEach(function (
            key
          ) {
            const quantity =
              Number(
                retainedAccessories[
                  key
                ] || 0
              );
            if (
              quantity <= 0
            ) {
              return;
            }

            addRetainedBreakdownRow(
              quantity +
              ' × ' +
              accessoryProducts[
                key
              ].name,
              quantity *
              accessoryProducts[
                key
              ].price
            );
          });
      }

      const plugRow =
        modal.querySelector(
          '[data-ld-breakdown-uk-plug-row]'
        );
      if (plugRow) {
        plugRow.style.display =
          (
            !state.ownDriver &&
            state.ukPlug
          )
            ? 'flex'
            : 'none';
      }
      const totalNote =
        modal.querySelector(
          '[data-ld-driver-total-note]'
        );
      if (totalNote) {
        totalNote.textContent =
          state.ownDriver
            ? 'Zone ' +
              currentZone +
              ' lights + required accessories · driver not supplied'
            : state.ukPlug
              ? 'Zone ' +
                currentZone +
                ' lights + driver + UK plug cable + required accessories'
              : 'Zone ' +
                currentZone +
                ' lights + required driver/accessories';
      }
      const summary =
        modal.querySelector(
          '[data-ld-driver-summary]'
        );
      if (summary) {
        let text =
          state.quantity +
          ' × ' +
          styleName(
            state.style
          ) +
          ' · ' +
          finishName(
            state.finish
          ) +
          ' · ' +
          colourName(
            state.colour
          );
        text +=
          state.ownDriver
            ? ' · Own compatible driver'
            : ' · ' +
              driver.watts +
              'W driver';
        if (
          !state.ownDriver &&
          state.ukPlug
        ) {
          text +=
            ' · 2m UK plug cable';
        }
        summary.textContent =
          text;
      }
      saveProject();
      refreshCurrentSummary();
    }
    /* =====================================================
       SENSOR
       ===================================================== */
    function validateCurrentSensor() {
      if (
        state.ownDriver
      ) {
        state.sensor =
          '';
        return;
      }
      if (
        state.sensor &&
        !sensorCompatibleFor(
          state,
          state.sensor
        )
      ) {
        state.sensor =
          '';
        state.stepDone.sensor =
          false;
        state.stepDone.accessories =
          false;
        state.stepDone.review =
          false;
      }
    }
    function updateSensor() {
      prepareSensorProductImages();
      validateCurrentSensor();
      const base =
        baseZoneFor(
          state
        );
      const warning =
        modal.querySelector(
          '[data-ld-sensor-driver-required]'
        );
      const grid =
        modal.querySelector(
          '[data-ld-sensor-grid]'
        );
      const summaryWrap =
        modal.querySelector(
          '[data-ld-sensor-summary-wrap]'
        );
      const summary =
        modal.querySelector(
          '[data-ld-sensor-summary]'
        );
      const next =
        modal.querySelector(
          '[data-ld-sensor-next]'
        );
      const controlIntro =
        modal.querySelector(
          '[data-ld-control-intro]'
        );
      const controlCompatibilityNote =
        modal.querySelector(
          '[data-ld-control-compatibility-note]'
        );
      const selectedControlProduct =
        selectedLightProduct(
          state
        );
      const selectedStyleIsDimmable =
        !selectedControlProduct ||
        selectedControlProduct.dimmable !==
          false;

      if (controlIntro) {
        controlIntro.textContent =
          selectedStyleIsDimmable
            ? 'Choose how this zone should switch on, off or dim. One control operates every light in the zone.'
            : 'Choose how this zone should switch on or off. This light style is not dimmable, so the Touch Dimmer is not available.';
      }

      if (controlCompatibilityNote) {
        controlCompatibilityNote.hidden =
          selectedStyleIsDimmable;
        controlCompatibilityNote.textContent =
          selectedStyleIsDimmable
            ? ''
            : 'Dimming compatibility: this light style is on/off only. PIR, door sensors and No Sensor remain available.';
      }
      if (warning) {
        warning.classList.toggle(
          'is-visible',
          state.ownDriver
        );
      }
      if (grid) {
        grid.classList.toggle(
          'is-driver-disabled',
          state.ownDriver
        );
      }
      modal
        .querySelectorAll(
          '.ld-sensor-card'
        )
        .forEach(function (
          card
        ) {
          const sensorKey =
            card.dataset.sensor;
          const incompatible =
            (
              !state.ownDriver &&
              !sensorCompatibleFor(
                state,
                sensorKey
              )
            );
          const disabled =
            state.ownDriver ||
            incompatible;
          card.hidden = incompatible;
          card.setAttribute('aria-pressed', String(!disabled && state.sensor === sensorKey));
          card.disabled = disabled;
          card.classList.toggle(
            'is-unavailable',
            incompatible
          );
          card.classList.toggle(
            'is-selected',
            (
              !disabled &&
              state.sensor ===
              sensorKey
            )
          );
          const price =
            card.querySelector(
              '[data-ld-sensor-price]'
            );
          if (
            price &&
            sensors[
              sensorKey
            ]
          ) {
            price.textContent =
              sensorKey ===
                'none'
                ? 'No extra cost'
                : money(
                    sensors[
                      sensorKey
                    ].price
                  );
          }
          const unavailable =
            card.querySelector(
              '.ld-sensor-unavailable'
            );
          if (
            unavailable &&
            sensorKey ===
            'touch'
          ) {
            unavailable.textContent =
              incompatible
                ? 'Not compatible — this light is not dimmable'
                : '';
          }
        });
      let sensorPrice =
        0;
      if (
        !state.ownDriver &&
        state.sensor &&
        sensors[
          state.sensor
        ]
      ) {
        sensorPrice =
          sensors[
            state.sensor
          ].price;
      }
      const finalTotal =
        base.total +
        sensorPrice;
      if (summaryWrap) {
        summaryWrap.classList.toggle(
          'is-hidden',
          state.ownDriver
        );
      }
      if (summary) {
        summary.textContent =
          state.ownDriver
            ? ''
            : state.sensor
              ? sensorName(
                  state.sensor
                )
              : 'Not selected';
      }
      if (next) {
        next.disabled =
          state.ownDriver
            ? false
            : !state.sensor;
      }
      const projectTotal =
        modal.querySelector(
          '[data-ld-sensor-project-total]'
        );
      if (projectTotal) {
        projectTotal.textContent =
          money(
            projectTotalIncludingCurrent(
              finalTotal
            )
          );
      }
      const totalNote =
        modal.querySelector(
          '[data-ld-sensor-total-note]'
        );
      if (totalNote) {
        totalNote.textContent =
          state.ownDriver
            ? 'Zone ' +
              currentZone +
              ' lights + required accessories · sensors unavailable without supplied driver'
            : state.sensor &&
              state.sensor !==
              'none'
              ? 'Zone ' +
                currentZone +
                ' + ' +
                sensorName(
                  state.sensor
                )
              : 'Zone ' +
                currentZone +
                ' lights + driver/accessories';
      }
      state.total =
        finalTotal;
      saveProject();
      refreshCurrentSummary();
    }
    /* =====================================================
       SENSOR POPUP
       ===================================================== */
    const sensorInfoOverlay =
      modal.querySelector(
        '[data-ld-sensor-info-overlay]'
      );

    const sensorInfoModal =
      modal.querySelector(
        '[data-ld-sensor-info-modal]'
      );

    const sensorInfoTitle =
      modal.querySelector(
        '[data-ld-sensor-info-title]'
      );

    const sensorInfoBestFor =
      modal.querySelector(
        '[data-ld-sensor-info-best-for]'
      );

    const sensorInfoIntro =
      modal.querySelector(
        '[data-ld-sensor-info-intro]'
      );

    const sensorInfoFacts =
      modal.querySelectorAll(
        '[data-ld-sensor-info-fact]'
      );

    const sensorInfoImageWrap =
      modal.querySelector(
        '[data-ld-sensor-info-image-wrap]'
      );

    const sensorInfoImage =
      modal.querySelector(
        '[data-ld-sensor-info-image]'
      );

    const sensorInfoSystemNote =
      modal.querySelector(
        '[data-ld-sensor-info-system-note]'
      );

    const sensorInfoInstallation =
      modal.querySelector(
        '[data-ld-sensor-info-installation]'
      );

    const sensorInfoInstallationWrap =
      sensorInfoInstallation
        ? sensorInfoInstallation.closest(
            '.ld-sensor-info-installation'
          )
        : null;

    const sensorInfoClose =
      modal.querySelector(
        '[data-ld-sensor-info-close]'
      );

    const sensorInfoDone =
      modal.querySelector(
        '[data-ld-sensor-info-done]'
      );


    function sensorPopupOpen() {
      return (
        sensorInfoModal &&
        sensorInfoModal.classList.contains(
          'is-open'
        )
      );
    }


    let sensorReturnFocus =
      null;

    let sensorInfoActiveKey =
      '';


    async function openSensorPopup(
      sensorKey
    ) {

      if (
        state.ownDriver ||
        !sensorCompatibleFor(
          state,
          sensorKey
        ) ||
        !sensorHelp[
          sensorKey
        ]
      ) {
        return;
      }


      const help =
        sensorHelp[
          sensorKey
        ];

      sensorInfoActiveKey =
        sensorKey;


      let bestFor =
        help.bestFor;

      let intro =
        help.intro;

      let facts =
        help.facts.slice();

      let installation =
        help.installation;


      if (
        sensorKey ===
        'none'
      ) {

        if (
          state.ukPlug
        ) {

          bestFor =
            'Best for simple socket control';

          intro =
            'No separate 24V sensor is required. Switch the whole zone on or off at the socket or its normal switched supply. This route is on/off only.';

          facts = [
            'No extra sensor',
            'No extra cost',
            'Socket control',
            'On/off only'
          ];

          installation =
            'The driver connects to a standard UK socket using the 2m UK plug cable selected on the Driver step. The supplied driver must not be connected to a mains dimmer; choose the Touch On/Off & Dimmer if you want dimming.';

        } else {

          bestFor =
            'Best for a standard wall light switch';

          intro =
            'No separate 24V sensor is required. Use your normal wall light switch to switch the whole zone on or off. This route is on/off only.';

          facts = [
            'No extra sensor',
            'No extra cost',
            'Wall-switch control',
            'On/off only'
          ];

          installation =
            'An electrician connects the supplied 24V driver to the switched mains supply. The supplied driver must not be connected to a mains wall dimmer; choose the Touch On/Off & Dimmer if you want dimming.';

        }

      }


      if (
        sensorInfoTitle
      ) {
        sensorInfoTitle.textContent =
          help.title;
      }


      if (
        sensorInfoBestFor
      ) {
        sensorInfoBestFor.textContent =
          bestFor;
      }


      if (
        sensorInfoIntro
      ) {
        sensorInfoIntro.textContent =
          intro;
      }


      sensorInfoFacts
        .forEach(function (
          factElement,
          index
        ) {

          const fact =
            facts[
              index
            ] || '';

          factElement.textContent =
            fact;

          factElement.hidden =
            !fact;

        });


      if (
        sensorInfoSystemNote
      ) {
        sensorInfoSystemNote.hidden =
          sensorKey ===
          'none';
      }


      if (
        sensorInfoInstallation
      ) {
        sensorInfoInstallation.textContent =
          installation;
      }


      if (
        sensorInfoInstallationWrap
      ) {
        sensorInfoInstallationWrap.hidden =
          !installation;
      }


      if (
        sensorInfoImageWrap
      ) {
        sensorInfoImageWrap.hidden =
          sensorKey ===
          'none';
      }


      if (
        sensorInfoImage
      ) {
        sensorInfoImage.removeAttribute(
          'src'
        );
        sensorInfoImage.alt =
          '';
      }


      if (
        sensorInfoModal
      ) {

        sensorReturnFocus =
          document.activeElement;

        sensorInfoModal.classList.toggle(
          'is-no-sensor',
          sensorKey ===
            'none'
        );

        sensorInfoModal.classList.add(
          'is-open'
        );

      }


      if (
        sensorInfoOverlay
      ) {
        sensorInfoOverlay.classList.add(
          'is-open'
        );
      }


      if (
        sensorInfoClose
      ) {
        sensorInfoClose.focus({
          preventScroll:
            true
        });
      }


      if (
        sensorKey !==
        'none' &&
        sensorInfoImage
      ) {

        const imageUrl =
          await getSensorImageUrl(
            sensorKey
          );

        if (
          sensorInfoActiveKey !==
          sensorKey ||
          !sensorPopupOpen()
        ) {
          return;
        }

        if (
          imageUrl
        ) {

          sensorInfoImage.src =
            imageUrl;

          sensorInfoImage.alt =
            sensors[
              sensorKey
            ].name;

        } else if (
          sensorInfoImageWrap
        ) {

          sensorInfoImageWrap.hidden =
            true;

        }

      }

    }


    function closeSensorPopup() {

      const wasOpen =
        sensorInfoModal &&
        sensorInfoModal.classList.contains(
          'is-open'
        );


      sensorInfoActiveKey =
        '';


      if (
        sensorInfoOverlay
      ) {
        sensorInfoOverlay.classList.remove(
          'is-open'
        );
      }


      if (
        sensorInfoModal
      ) {
        sensorInfoModal.classList.remove(
          'is-open'
        );
      }


      if (
        wasOpen &&
        sensorReturnFocus &&
        sensorReturnFocus.isConnected
      ) {

        sensorReturnFocus.focus({
          preventScroll:
            true
        });

      }

    }


    /* =====================================================
       ZONE REVIEW
       ===================================================== */
    function updateReview() {
      const product =
        selectedLightProduct(
          state
        );
      const driver =
        selectDriverFor(
          state
        );
      if (
        !product ||
        !driver
      ) {
        return;
      }
      const base =
        baseZoneFor(
          state
        );
      const blocks =
        base.blocks;
      const finalTotal =
        finalZoneTotalFor(
          state
        );
      state.total =
        finalTotal;
      function set(
        selector,
        value
      ) {
        const element =
          modal.querySelector(
            selector
          );
        if (element) {
          element.textContent =
            value;
        }
      }
      const nameInput =
        modal.querySelector(
          '[data-ld-review-zone-name]'
        );
      if (
        nameInput &&
        document.activeElement !==
        nameInput
      ) {
        nameInput.value =
          state.name || '';
      }
      set(
        '[data-ld-review-zone-title]',
        state.name.trim()
          ? state.name.trim()
          : 'Your Lighting Zone'
      );
      set(
        '[data-ld-review-light-description]',
        state.quantity +
        ' × ' +
        styleName(
          state.style
        ) +
        ' · ' +
        finishName(
          state.finish
        ) +
        ' · ' +
        colourName(
          state.colour
        )
      );
      set(
        '[data-ld-review-light-unit]',
        money(
          product.price
        ) +
        ' each'
      );
      set(
        '[data-ld-review-light-total]',
        money(
          base.lightsTotal
        )
      );
      set(
        '[data-ld-review-driver-description]',
        state.ownDriver
          ? 'Customer Supplying Own Compatible Driver'
          : driver.watts +
            'W · ' +
            driver.ports +
            (
              driver.ports === 1
                ? ' light port'
                : ' light ports'
            )
      );
      set(
        '[data-ld-review-driver-note]',
        state.ownDriver
          ? 'Recommended capacity: ' +
            driver.watts +
            'W · ' +
            driver.ports +
            (
              driver.ports === 1
                ? ' light port'
                : ' light ports'
            )
          : 'Automatically selected for ' +
            tidyWatts(
              totalWattsFor(
                state
              )
            ) +
            ' of lighting'
      );
      set(
        '[data-ld-review-driver-total]',
        money(
          base.driverTotal
        )
      );
      const blockRow =
        modal.querySelector(
          '[data-ld-review-block-row]'
        );
      if (blockRow) {
        blockRow.style.display =
          blocks > 0
            ? 'grid'
            : 'none';
      }
      set(
        '[data-ld-review-block-description]',
        blocks +
        ' × 6-Way Distribution ' +
        (
          blocks === 1
            ? 'Block'
            : 'Blocks'
        )
      );
      set(
        '[data-ld-review-block-total]',
        money(
          base.blocksTotal
        )
      );
      const mainsRow =
        modal.querySelector(
          '[data-ld-review-mains-row]'
        );
      if (mainsRow) {
        mainsRow.style.display =
          state.ownDriver
            ? 'none'
            : 'grid';
      }
      if (
        !state.ownDriver
      ) {
        set(
          '[data-ld-review-mains-description]',
          state.ukPlug
            ? 'Plug into a socket · 2m UK Plug Cable'
            : 'Wire into the lighting circuit · 1m Bare-Ended Mains Cable'
        );
        set(
          '[data-ld-review-mains-note]',
          state.ukPlug
            ? '2m UK plug cable selected'
            : '1m bare-ended mains lead included'
        );
        set(
          '[data-ld-review-mains-total]',
          state.ukPlug
            ? money(
                ukPlugCable.price
              )
            : 'Included'
        );
      }
      if (
        state.ownDriver
      ) {
        set(
          '[data-ld-review-sensor-description]',
          'Not Available'
        );
        set(
          '[data-ld-review-sensor-note]',
          'Sensors are unavailable when using a customer-supplied driver'
        );
        set(
          '[data-ld-review-sensor-total]',
          money(0)
        );
      } else if (
        state.sensor ===
        'none'
      ) {
        set(
          '[data-ld-review-sensor-description]',
          'No Sensor'
        );
        set(
          '[data-ld-review-sensor-note]',
          state.ukPlug ? 'Socket on/off control only; no separate sensor' : 'Wall-switch on/off only; supplied driver must not be connected to a mains wall dimmer'
        );
        set(
          '[data-ld-review-sensor-total]',
          'No extra cost'
        );
      } else if (
        state.sensor &&
        sensors[
          state.sensor
        ]
      ) {
        const notes = {
          touch:
            'On / off, dimming and brightness memory · controls the whole zone',
          pir:
            'Hands-free occupancy control · 1–3m range · 30s hold',
          'single-door':
            'Automatic door control · 1–3cm sensing range',
          'double-door':
            'Either door activates the whole zone · 1–3cm sensing range'
        };
        set(
          '[data-ld-review-sensor-description]',
          sensorName(
            state.sensor
          )
        );
        set(
          '[data-ld-review-sensor-note]',
          notes[
            state.sensor
          ] || ''
        );
        set(
          '[data-ld-review-sensor-total]',
          money(
            sensors[
              state.sensor
            ].price
          )
        );
      }
      const reviewAccessories =
        modal.querySelector(
          '[data-ld-review-accessories]'
        );
      if (reviewAccessories) {
        reviewAccessories.innerHTML =
          '';
        const selectedAccessories = [
          {
            key: 'extension2',
            label: '2m Extension Lead'
          },
          {
            key: 'extension5',
            label: '5m Extension Lead'
          },
          {
            key: 'wago2',
            label: '2 Way WAGO Connector'
          },
          {
            key: 'wago3',
            label: '3 Way WAGO Connector'
          }
        ];
        selectedAccessories
          .forEach(function (
            item
          ) {
            const quantity =
              Number(
                accessories[
                  item.key
                ] || 0
              );
            if (
              quantity <= 0
            ) {
              return;
            }
            const product =
              accessoryProducts[
                item.key
              ];
            if (!product) {
              return;
            }
            const row =
              document.createElement(
                'div'
              );
            row.className =
              'ld-review-line';
            row.innerHTML =
              '<div class="ld-review-line-label">Accessory</div>' +
              '<div class="ld-review-line-main">' +
                '<strong>' +
                  escapeHtml(
                    quantity +
                    ' × ' +
                    item.label
                  ) +
                '</strong>' +
                '<span>' +
                  escapeHtml(
                    money(
                      product.price
                    ) +
                    ' each'
                  ) +
                '</span>' +
              '</div>' +
              '<div class="ld-review-line-price">' +
                escapeHtml(
                  money(
                    quantity *
                    product.price
                  )
                ) +
              '</div>';
            reviewAccessories.appendChild(
              row
            );
          });

      }
      const reviewAccessoriesTotal =
        accessoriesSubtotal();
      set(
        '[data-ld-review-total]',
        money(
          finalTotal +
          reviewAccessoriesTotal
        )
      );
      set(
        '[data-ld-review-project-total]',
        money(
          projectTotalIncludingCurrent(
            finalTotal
          ) +
          accessoriesSubtotal()
        )
      );
      const completedOtherZonesTotal =
        completedProjectTotal(
          currentZone
        );

      const projectTotalWrap =
        modal.querySelector(
          '[data-ld-review-project-total-wrap]'
        );

      if (projectTotalWrap) {
        projectTotalWrap.hidden =
          completedOtherZonesTotal <= 0;
      }

      const projectNote =
        modal.querySelector(
          '[data-ld-review-project-note]'
        );
      if (projectNote) {
        projectNote.textContent =
          'Includes this zone and all previously completed zones';
      }
      saveProject();
      refreshCurrentSummary();
    }
    /* =====================================================
       UPDATE EVERYTHING
       ===================================================== */
    function updateEverything() {
      updateDynamicLabels();
      updateProjectIdentityFields();
      updateZoneCountScreen();
      updateStyle();
      updateFinish();
      updateColour();
      updateQuantity();
      updateDriver();
      updateSensor();
      updateReview();
      updateZoneShortcuts();
      updateStepNavigation();
    }
    /* =====================================================
       PREVIOUS SETUPS
       ===================================================== */
    function setupKey(
      zone
    ) {
      return [
        zone.style,
        zone.finish,
        zone.colour
      ].join('|');
    }
    function previousSetupGroups() {
      const groups =
        {};
      for (
        let i = 1;
        i < currentZone;
        i++
      ) {
        const zone =
          projectZones[
            String(i)
          ]
            ? normaliseZone(i)
            : null;
        if (
          !zone ||
          !isZoneComplete(
            zone
          ) ||
          !zone.style ||
          !zone.finish ||
          !zone.colour
        ) {
          continue;
        }
        const key =
          setupKey(
            zone
          );
        if (
          !groups[
            key
          ]
        ) {
          groups[
            key
          ] = {
            zones: [],
            zone:
              zone
          };
        }
        groups[
          key
        ].zones.push(
          i
        );
      }
      return Object.keys(
        groups
      )
        .map(function (
          key
        ) {
          return groups[
            key
          ];
        });
    }
    function zoneReferenceText(
      zones
    ) {
      if (
        zones.length === 1
      ) {
        return (
          'Zone ' +
          zones[0]
        );
      }
      if (
        zones.length === 2
      ) {
        return (
          'Zones ' +
          zones[0] +
          ' & ' +
          zones[1]
        );
      }
      return (
        'Zones ' +
        zones
          .slice(
            0,
            -1
          )
          .join(', ') +
        ' & ' +
        zones[
          zones.length - 1
        ]
      );
    }
    /* =====================================================
       PRODUCT IMAGE LOOKUP
       ===================================================== */
    const imageCache =
      {};
    function fallbackSetupImage(
      wrapper,
      zone
    ) {
      wrapper.classList.add(
        'is-placeholder'
      );
      const details =
        styleCatalog[
          zone.style
        ];
      if (
        details &&
        details.image
      ) {
        const image =
          document.createElement(
            'img'
          );
        image.alt =
          styleName(
            zone.style
          );
        image.src =
          details.image;
        image.addEventListener(
          'load',
          function () {
            wrapper.classList.remove(
              'is-placeholder'
            );
          }
        );
        image.addEventListener(
          'error',
          function () {
            wrapper.innerHTML =
              '<div class="ld-round-demo"></div>';
          }
        );
        wrapper.innerHTML =
          '';
        wrapper.appendChild(
          image
        );
        return;
      }
      wrapper.innerHTML =
        '<div class="ld-round-demo"></div>';
    }
    async function loadSetupImage(
      wrapper,
      zone
    ) {
      const product =
        selectedLightProduct(
          zone
        );
      if (
        !product ||
        !product.handle
      ) {
        fallbackSetupImage(
          wrapper,
          zone
        );
        return;
      }
      const handle =
        product.handle;
      try {
        let imageUrl =
          imageCache[
            handle
          ];
        if (!imageUrl) {
          const response =
            await fetch(
              shopRoot() +
              'products/' +
              encodeURIComponent(
                handle
              ) +
              '.js',
              {
                credentials:
                  'same-origin'
              }
            );
          if (
            !response.ok
          ) {
            throw new Error(
              'Product image could not be loaded'
            );
          }
          const productData =
            await response.json();
          imageUrl =
            normaliseImageUrl(
              productData.featured_image ||
              (
                productData.images &&
                productData.images.length
                  ? productData.images[0]
                  : ''
              )
            );
          if (imageUrl) {
            imageCache[
              handle
            ] =
              imageUrl;
          }
        }
        if (!imageUrl) {
          fallbackSetupImage(
            wrapper,
            zone
          );
          return;
        }
        const image =
          document.createElement(
            'img'
          );
        image.alt =
          styleName(
            zone.style
          ) +
          ' - ' +
          finishName(
            zone.finish
          ) +
          ' - ' +
          colourName(
            zone.colour
          );
        image.onload =
          function () {
            wrapper.classList.remove(
              'is-placeholder'
            );
          };
        image.onerror =
          function () {
            fallbackSetupImage(
              wrapper,
              zone
            );
          };
        image.src =
          imageUrl;
        wrapper.innerHTML =
          '';
        wrapper.appendChild(
          image
        );
      } catch (error) {
        fallbackSetupImage(
          wrapper,
          zone
        );
      }
    }
    /* =====================================================
       START NEXT ZONE
       ===================================================== */
    function renderZoneStart() {
      updateDynamicLabels();
      updateZoneShortcuts();
      const container =
        modal.querySelector(
          '[data-ld-zone-start-options]'
        );
      const projectTotal =
        modal.querySelector(
          '[data-ld-zone-start-project-total]'
        );
      const intro =
        modal.querySelector(
          '[data-ld-zone-start-intro]'
        );
      if (!container) {
        return;
      }
      const groups =
        previousSetupGroups();
      if (intro) {
        if (
          currentZone === 2 &&
          groups.length === 1
        ) {
          intro.textContent =
            "Continue with Zone 1's light choices, or give Zone 2 a different style.";
        } else {
          intro.textContent =
            'Reuse a completed zone\u2019s light choices, or give Zone ' +
            currentZone +
            ' a different style.';
        }
      }
      container.innerHTML =
        '';
      container.style.gridTemplateColumns =
        groups.length === 1
          ? '1fr'
          : '';
      groups
        .forEach(function (
          group
        ) {
          const sourceZone =
            group.zone;
          const card =
            document.createElement(
              'button'
            );
          card.type =
            'button';
          card.className =
            'ld-zone-start-card';
          const names =
            group.zones
              .map(function (
                zoneNumber
              ) {
                const zone =
                  normaliseZone(
                    zoneNumber
                  );
                if (
                  zone.name &&
                  zone.name.trim()
                ) {
                  return (
                    'Zone ' +
                    zoneNumber +
                    ' – ' +
                    zone.name.trim()
                  );
                }
                return '';
              })
              .filter(Boolean);
          const namesHtml =
            names.length
              ? (
                  '<span class="ld-zone-start-zone-name">' +
                    'Used in: ' +
                    names
                      .map(
                        escapeHtml
                      )
                      .join(' · ') +
                  '</span>'
                )
              : '';
          const sourceStyleName =
            styleName(
              sourceZone.style
            );
          const sourceRangeName =
            sourceStyleName
              .split('—')[0]
              .trim();
          card.innerHTML =
            '<div class="ld-zone-start-image is-placeholder" data-ld-zone-card-image></div>' +
            '<div class="ld-zone-start-card-content">' +
              '<span class="ld-zone-start-card-kicker">' +
                'Use ' +
                escapeHtml(
                  zoneReferenceText(
                    group.zones
                  )
                ) +
                ' light choices' +
              '</span>' +
              '<h3>' +
                escapeHtml(
                  sourceStyleName
                ) +
              '</h3>' +
              namesHtml +
              '<span class="ld-zone-start-setup-spec">' +
                escapeHtml(
                  finishName(
                    sourceZone.finish
                  )
                ) +
                ' · ' +
                escapeHtml(
                  colourName(
                    sourceZone.colour
                  )
                ) +
              '</span>' +
              '<p>' +
                'Keeps the same light, finish and colour.' +
              '</p>' +
              '<span class="ld-zone-start-action">' +
                'Continue with ' +
                escapeHtml(
                  sourceRangeName
                ) +
                ' <span aria-hidden="true">→</span>' +
              '</span>' +
            '</div>';
          loadSetupImage(
            card.querySelector(
              '[data-ld-zone-card-image]'
            ),
            sourceZone
          );
          card.addEventListener(
            'click',
            function () {
              reusePreviousSetup(
                sourceZone
              );
            }
          );
          container.appendChild(
            card
          );
        });
      if (projectTotal) {
        projectTotal.textContent =
          money(
            completedProjectTotal(
              currentZone
            )
          );
      }
    }
    function reusePreviousSetup(
      sourceZone
    ) {
      state.style =
        sourceZone.style;
      state.finish =
        sourceZone.finish;
      state.colour =
        sourceZone.colour;
      state.quantity =
        1;
      accessories =
        blankAccessories();
      state.accessories =
        deepClone(
          accessories
        );
      state.ownDriver =
        false;
      state.ukPlug =
        false;
      state.sensor =
        '';
      state.startMode =
        'reuse';
      state.completed =
        false;
      state.completedOnce =
        false;
      state.total =
        0;
      state.styleManuallyChanged =
        false;
      state.stepDone = {
        style:
          true,
        finish:
          true,
        colour:
          true,
        quantity:
          false,
        driver:
          false,
        sensor:
          false,
        accessories:
          false,
        review:
          false
      };
      saveProject();
      updateEverything();
      showScreen(
        screens.quantity
      );
    }
    function startDifferentSetup() {
      state.style =
        '';
      state.finish =
        '';
      state.colour =
        '';
      state.quantity =
        1;
      state.ownDriver =
        false;
      state.ukPlug =
        false;
      state.sensor =
        '';
      accessories =
        blankAccessories();
      state.accessories =
        deepClone(
          accessories
        );
      state.startMode =
        'new';
      state.completed =
        false;
      state.completedOnce =
        false;
      state.total =
        0;
      state.styleManuallyChanged =
        true;
      state.stepDone =
        defaultStepDone(
          currentZone
        );
      state.stepDone.style =
        false;
      saveProject();
      updateEverything();
      showScreen(
        screens.style
      );
    }
    /* =====================================================
       NEW ZONES
       ===================================================== */
    function prepareNewZone(
      zoneNumber
    ) {
      if (state) {
        state.accessories =
          deepClone(
            normaliseAccessories(
              accessories
            )
          );

        state.total =
          zoneTotalWithAccessoriesFor(
            state
          );
      }

      saveProject();
      currentZone =
        zoneNumber;
      highestReached =
        Math.max(
          highestReached,
          zoneNumber
        );
      highestReached =
        Math.min(
          6,
          highestReached
        );
      if (
        !projectZones[
          String(
            zoneNumber
          )
        ]
      ) {
        projectZones[
          String(
            zoneNumber
          )
        ] =
          blankZone(
            zoneNumber
          );
      }
      state =
        normaliseZone(
          zoneNumber
        );
      accessories =
        normaliseAccessories(
          state.accessories
        );
      state.accessories =
        deepClone(
          accessories
        );
      projectZones[
        String(
          zoneNumber
        )
      ] =
        state;
      saveProject();
      renderZoneStart();
      showScreen(
        screens.zoneStart
      );
    }
    function goToNextZone(
      zoneNumber
    ) {
      const existing =
        projectZones[
          String(
            zoneNumber
          )
        ]
          ? normaliseZone(
              zoneNumber
            )
          : null;
      if (!existing) {
        prepareNewZone(
          zoneNumber
        );
        return;
      }
      loadZone(
        zoneNumber
      );
      updateEverything();
      if (
        !state.startMode &&
        !state.completedOnce
      ) {
        renderZoneStart();
        showScreen(
          screens.zoneStart
        );
      } else if (
        isZoneComplete(
          state
        )
      ) {
        showScreen(
          screens.review
        );
      } else {
        jumpToStep(
          furthestUnlockedStep(
            state
          )
        );
      }
    }
    /* =====================================================
       ZONE MORE
       ===================================================== */
    function renderZoneMore() {
      const completed =
        completedZoneNumbers();

      const projectReviewBackText =
        modal.querySelector(
          '[data-ld-project-review-back-text]'
        );
      if (projectReviewBackText) {
        projectReviewBackText.textContent =
          completed.length === 1 &&
          displayZoneCount() === 1
            ? 'Back to Accessories'
            : 'Back to Zone Review';
      }
      const summary =
        modal.querySelector(
          '[data-ld-zone-more-summary]'
        );
      const total =
        modal.querySelector(
          '[data-ld-zone-more-total]'
        );
      const addButton =
        modal.querySelector(
          '[data-ld-add-another-zone]'
        );
      const addLabel =
        modal.querySelector(
          '[data-ld-add-zone-label]'
        );
      const limit =
        modal.querySelector(
          '[data-ld-zone-limit-message]'
        );
      if (summary) {
        const names =
          completed
            .map(function (
              zoneNumber
            ) {
              const zone =
                normaliseZone(
                  zoneNumber
                );
              return (
                zone.name &&
                zone.name.trim()
              )
                ? 'Zone ' +
                  zoneNumber +
                  ' – ' +
                  zone.name.trim()
                : 'Zone ' +
                  zoneNumber;
            });
        summary.textContent =
          names.length
            ? names.join(
                ' · '
              ) +
              ' saved'
            : 'Zone saved';
      }
      if (total) {
        total.textContent =
          money(
            completedProjectTotal()
          );
      }
      const activeCount =
        displayZoneCount();
      const nextZone =
        Math.min(
          6,
          activeCount + 1
        );
      const atLimit =
        activeCount >= 6;
      if (addLabel) {
        addLabel.textContent =
          atLimit
            ? 'Maximum 6 Zones Reached'
            : 'Add Zone ' +
              nextZone;
      }
      if (addButton) {
        addButton.disabled =
          atLimit;
      }
      if (limit) {
        limit.classList.toggle(
          'is-visible',
          atLimit
        );
      }
    }
    /* =====================================================
       ACCESSORIES
       ===================================================== */
    function clampAccessories() {
      // Historical function name retained because it is called throughout the
      // builder. We now normalise values only; we do not silently trim mixed
      // extension lengths when quantity is reduced.
      accessories = normaliseAccessories(accessories);
    }
    function accessoriesSubtotalFor(
      selection
    ) {
      const value =
        normaliseAccessories(
          selection
        );
      let total =
        0;
      total +=
        value.extension2 *
        accessoryProducts.extension2.price;
      total +=
        value.extension5 *
        accessoryProducts.extension5.price;
      total +=
        value.wago2 *
        accessoryProducts.wago2.price;
      total +=
        value.wago3 *
        accessoryProducts.wago3.price;
      return total;
    }
    function accessoriesSubtotal() {
      return accessoriesSubtotalFor(
        accessories
      );
    }
    function zoneTotalWithAccessoriesFor(
      zone
    ) {
      return (
        finalZoneTotalFor(
          zone
        ) +
        accessoriesSubtotalFor(
          zone &&
          zone.accessories
            ? zone.accessories
            : blankAccessories()
        )
      );
    }
    function projectAccessoriesSubtotal() {
      let total =
        0;
      completedZoneNumbers()
        .forEach(function (
          zoneNumber
        ) {
          const zone =
            normaliseZone(
              zoneNumber
            );
          total +=
            accessoriesSubtotalFor(
              zone.accessories
            );
        });
      return total;
    }
    function aggregateProjectAccessories() {
      const combined =
        blankAccessories();
      completedZoneNumbers()
        .forEach(function (
          zoneNumber
        ) {
          const zone =
            normaliseZone(
              zoneNumber
            );
          const zoneAccessories =
            normaliseAccessories(
              zone.accessories
            );
          Object.keys(
            combined
          )
            .forEach(function (
              key
            ) {
              combined[
                key
              ] +=
                Number(
                  zoneAccessories[
                    key
                  ] || 0
                );
            });
        });
      return combined;
    }
    function cableBaseMetresFor(
      zone
    ) {
      const source =
        zone || state;
      return fittedCableMetresFor(
        source.style || state.style,
        source.colour || state.colour
      );
    }

    function cableRecommendationForDistance(
      zone,
      distance
    ) {
      const base =
        cableBaseMetresFor(
          zone
        );
      const metres =
        Number(
          distance
        );

      if (
        !Number.isFinite(
          metres
        ) ||
        metres <= 0
      ) {
        return {
          key:
            'unmeasured',
          label:
            'Not measured',
          reach:
            base
        };
      }

      if (
        metres <=
        base
      ) {
        return {
          key:
            'none',
          label:
            'No extension',
          reach:
            base
        };
      }

      if (
        metres <=
        base + 2
      ) {
        return {
          key:
            'extension2',
          label:
            'Add 2m extension',
          reach:
            base + 2
        };
      }

      if (
        metres <=
        base + 5
      ) {
        return {
          key:
            'extension5',
          label:
            'Add 5m extension',
          reach:
            base + 5
        };
      }

      return {
        key:
          'over',
        label:
          'Route exceeds supported single-extension reach',
        reach:
          base + 5
      };
    }

    function cablePlannerValuesForCurrentZone() {
      const quantity =
        Math.max(
          1,
          Number(
            state.quantity || 1
          )
        );
      const plan =
        normaliseCablePlan(
          state.cablePlan
        );

      while (
        plan.length <
        quantity
      ) {
        plan.push('');
      }

      state.cablePlan =
        plan;

      return plan.slice(
        0,
        quantity
      );
    }

    function updateCablePlannerSummary() {
      const result =
        modal.querySelector(
          '[data-ld-cable-planner-result]'
        );
      const applyButton =
        modal.querySelector(
          '[data-ld-cable-planner-apply]'
        );

      if (
        !result ||
        !applyButton
      ) {
        return;
      }

      const values =
        cablePlannerValuesForCurrentZone();
      let measured =
        0;
      let extension2Count =
        0;
      let extension5Count =
        0;
      let overCount =
        0;

      values.forEach(function (
        value
      ) {
        const recommendation =
          cableRecommendationForDistance(
            state,
            value
          );

        if (
          recommendation.key !==
          'unmeasured'
        ) {
          measured += 1;
        }

        if (
          recommendation.key ===
          'extension2'
        ) {
          extension2Count += 1;
        }

        if (
          recommendation.key ===
          'extension5'
        ) {
          extension5Count += 1;
        }

        if (
          recommendation.key ===
          'over'
        ) {
          overCount += 1;
        }
      });

      const total =
        values.length;

      result.classList.toggle(
        'is-ready',
        measured ===
          total &&
        overCount ===
          0
      );
      result.classList.toggle(
        'has-warning',
        overCount > 0
      );

      if (
        overCount > 0
      ) {
        result.innerHTML =
          '<strong>' +
            overCount +
            (
              overCount === 1
                ? ' route is'
                : ' routes are'
            ) +
          ' longer than the supported reach.</strong> ' +
          'Move the driver closer, revise the route or contact us before ordering. ' +
          'We will not apply an extension recommendation automatically.';
        applyButton.disabled =
          true;
        return;
      }

      if (
        measured <
        total
      ) {
        result.innerHTML =
          '<strong>' +
            measured +
            ' of ' +
            total +
            ' light routes measured.</strong> ' +
          'Complete every route if you want the planner to set your extension quantities.';
        applyButton.disabled =
          true;
        return;
      }

      result.innerHTML =
        '<strong>Recommended for this zone:</strong> ' +
        (
          extension2Count > 0
            ? extension2Count +
              ' × 2m extension'
            : 'no 2m extensions'
        ) +
        ' · ' +
        (
          extension5Count > 0
            ? extension5Count +
              ' × 5m extension'
            : 'no 5m extensions'
        ) +
        '.';

      applyButton.disabled =
        false;
      applyButton.dataset
        .ldExtension2Count =
          String(
            extension2Count
          );
      applyButton.dataset
        .ldExtension5Count =
          String(
            extension5Count
          );
    }

    function renderCableRoutePlanner() {
      const rows =
        modal.querySelector(
          '[data-ld-cable-planner-rows]'
        );
      const locationInput =
        modal.querySelector(
          '[data-ld-driver-location]'
        );

      if (!rows) {
        return;
      }

      if (
        locationInput &&
        locationInput !==
          document.activeElement
      ) {
        locationInput.value =
          state.driverLocation ||
          '';
      }

      const values =
        cablePlannerValuesForCurrentZone();
      const signature =
        currentZone +
        ':' +
        state.quantity +
        ':' +
        values.join(
          '|'
        );

      if (
        rows.dataset
          .ldPlannerSignature !==
        signature
      ) {
        rows.dataset
          .ldPlannerSignature =
            signature;
        rows.innerHTML =
          '';

        values.forEach(function (
          value,
          index
        ) {
          const recommendation =
            cableRecommendationForDistance(
              state,
              value
            );
          const row =
            document.createElement(
              'label'
            );
          row.className =
            'ld-cable-planner-row';
          row.innerHTML =
            '<span class="ld-cable-planner-light">' +
              '<strong>Light ' +
                (
                  index + 1
                ) +
              '</strong>' +
              '<small>Routed distance</small>' +
            '</span>' +
            '<span class="ld-cable-planner-input-wrap">' +
              '<input type="number" min="0.1" max="50" step="0.1" inputmode="decimal" ' +
                'data-ld-route-distance="' +
                index +
                '" value="' +
                (
                  value === ''
                    ? ''
                    : escapeHtml(
                        String(
                          value
                        )
                      )
                ) +
                '" placeholder="e.g. 3.4">' +
              '<span>m</span>' +
            '</span>' +
            '<span class="ld-cable-planner-recommendation ' +
              (
                recommendation.key ===
                  'over'
                  ? 'is-warning'
                  : recommendation.key ===
                      'unmeasured'
                    ? 'is-muted'
                    : 'is-ok'
              ) +
              '" data-ld-route-recommendation="' +
              index +
              '">' +
              escapeHtml(
                recommendation.label
              ) +
            '</span>';

          rows.appendChild(
            row
          );
        });
      }

      updateCablePlannerSummary();
    }

    function updateAccessoriesUI() {
      clampAccessories();
      saveAccessories();
      [
        'extension2',
        'extension5',
        'wago2',
        'wago3'
      ]
        .forEach(function (
          key
        ) {
          const qty =
            modal.querySelector(
              '[data-ld-accessory-qty="' +
              key +
              '"]'
            );
          const minus =
            modal.querySelector(
              '[data-ld-accessory-minus="' +
              key +
              '"]'
            );
          const plus =
            modal.querySelector(
              '[data-ld-accessory-plus="' +
              key +
              '"]'
            );
          if (qty) {
            qty.textContent =
              accessories[
                key
              ];
          }

          const accessoryCard =
            modal.querySelector(
              '[data-ld-accessory-card="' +
              key +
              '"]'
            );

          if (accessoryCard) {
            accessoryCard.classList.toggle(
              'has-quantity',
              accessories[
                key
              ] > 0
            );
          }
          if (minus) {
            minus.disabled =
              accessories[
                key
              ] <= 0;
          }
          if (
            plus &&
            (
              key ===
              'wago2' ||
              key ===
              'wago3'
            )
          ) {
            plus.disabled =
              accessories[
                key
              ] >= 99;
          }
        });
      const maxExtensions =
        Math.max(
          1,
          Number(
            state &&
            state.quantity
              ? state.quantity
              : 1
          )
        );
      const extensionTotal =
        accessories.extension2 +
        accessories.extension5;
      [
        'extension2',
        'extension5'
      ]
        .forEach(function (
          key
        ) {
          const plus =
            modal.querySelector(
              '[data-ld-accessory-plus="' +
              key +
              '"]'
            );
          if (plus) {
            plus.disabled =
              extensionTotal >=
              maxExtensions;
          }
        });
      const limitNote =
        modal.querySelector(
          '[data-ld-extension-limit-note]'
        );
      const extensionOverageWarning =
        modal.querySelector(
          '[data-ld-extension-overage-warning]'
        );
      const extensionOverage =
        Math.max(
          0,
          extensionTotal -
          maxExtensions
        );

      if (limitNote) {
        const remaining =
          Math.max(
            0,
            maxExtensions -
            extensionTotal
          );

        limitNote.textContent =
          extensionOverage > 0
            ? 'Your previous extension choices have been kept so you can decide which lead length to remove.'
            : (
                remaining +
                (
                  remaining === 1
                    ? ' extension slot remaining'
                    : ' extension slots remaining'
                ) +
                ' · maximum one extension per light'
              );
      }

      if (extensionOverageWarning) {
        extensionOverageWarning.hidden =
          extensionOverage <= 0;

        if (extensionOverage > 0) {
          extensionOverageWarning.innerHTML =
            '<strong>Please review your extension leads.</strong> ' +
            'You now have ' +
            extensionTotal +
            ' extensions selected for ' +
            maxExtensions +
            (
              maxExtensions === 1
                ? ' light'
                : ' lights'
            ) +
            '. Remove ' +
            extensionOverage +
            (
              extensionOverage === 1
                ? ' extension'
                : ' extensions'
            ) +
            ' before continuing. We have not removed anything automatically.';
        }
      }
      const cableSummary =
        modal.querySelector(
          '[data-ld-light-cable-summary]'
        );
      if (cableSummary) {
        cableSummary.innerHTML =
          '';
        const fittedCableLabel =
          fittedCableLabelFor(
            state.style,
            state.colour
          );
        const line =
          document.createElement(
            'div'
          );
        line.className =
          'ld-light-cable-summary__line';
        const zoneLabel =
          (
            state.name &&
            state.name.trim()
          )
            ? 'Zone ' +
              currentZone +
              ' – ' +
              state.name.trim()
            : 'Zone ' +
              currentZone;
        line.innerHTML =
          '<strong>' +
            escapeHtml(
              state.quantity +
              (
                state.quantity === 1
                  ? ' light'
                  : ' lights'
              )
            ) +
          '</strong> · ' +
          escapeHtml(
            fittedCableLabel +
            ' fitted cable on each · up to ' +
            maxExtensions +
            ' extensions total'
          );
        cableSummary.appendChild(
          line
        );
      }
      const fittedCableLabel =
        fittedCableLabelFor(
          state.style,
          state.colour
        );
      const currentCableLength =
        modal.querySelector(
          '[data-ld-current-zone-cable-length]'
        );
      const currentExtensionMax =
        modal.querySelector(
          '[data-ld-current-zone-extension-max]'
        );
      if (currentCableLength) {
        currentCableLength.textContent =
          fittedCableLabel;
      }
      if (currentExtensionMax) {
        currentExtensionMax.textContent =
          String(
            Math.max(
              1,
              Number(
                state.quantity || 1
              )
            )
          );
      }

      const cableMetres =
        cableBaseMetresFor(
          state
        );

      function metresLabel(
        value
      ) {
        return (
          Number.isInteger(
            value
          )
            ? String(value)
            : String(
                Math.round(
                  value * 10
                ) / 10
              )
        ) + 'm';
      }

      const noExtensionReach =
        modal.querySelector(
          '[data-ld-cable-reach="none"]'
        );
      const extension2Reach =
        modal.querySelector(
          '[data-ld-cable-reach="extension2"]'
        );
      const extension5Reach =
        modal.querySelector(
          '[data-ld-cable-reach="extension5"]'
        );
      const extension2CardReach =
        modal.querySelector(
          '[data-ld-extension-reach="extension2"]'
        );
      const extension5CardReach =
        modal.querySelector(
          '[data-ld-extension-reach="extension5"]'
        );

      if (noExtensionReach) {
        noExtensionReach.textContent =
          metresLabel(
            cableMetres
          ) +
          ' total';
      }
      if (extension2Reach) {
        extension2Reach.textContent =
          metresLabel(
            cableMetres + 2
          ) +
          ' total';
      }
      if (extension5Reach) {
        extension5Reach.textContent =
          metresLabel(
            cableMetres + 5
          ) +
          ' total';
      }
      if (extension2CardReach) {
        extension2CardReach.textContent =
          metresLabel(
            cableMetres + 2
          );
      }
      if (extension5CardReach) {
        extension5CardReach.textContent =
          metresLabel(
            cableMetres + 5
          );
      }

      const installerAccessories =
        modal.querySelector(
          '[data-ld-installer-accessories]'
        );
      const installerAccessoriesNote =
        modal.querySelector(
          '[data-ld-installer-accessories-note]'
        );

      if (installerAccessoriesNote) {
        installerAccessoriesNote.textContent =
          state.ukPlug
            ? 'Usually not needed with a plug-in setup. Open only if your installer needs WAGO connectors for separate mains wiring.'
            : 'Optional WAGO connectors for mains wiring — most customers can leave this section closed.';
      }

      if (installerAccessories) {
        const currentInstallerZone =
          String(
            currentZone
          );
        const previousInstallerZone =
          installerAccessories.dataset
            .ldZoneNumber || '';

        if (
          previousInstallerZone !==
            currentInstallerZone
        ) {
          installerAccessories.dataset
            .ldZoneNumber =
              currentInstallerZone;

          if (
            Number(
              accessories.wago2 || 0
            ) <= 0 &&
            Number(
              accessories.wago3 || 0
            ) <= 0
          ) {
            installerAccessories.open =
              false;
          }
        }

        if (
          Number(
            accessories.wago2 || 0
          ) > 0 ||
          Number(
            accessories.wago3 || 0
          ) > 0
        ) {
          installerAccessories.open =
            true;
        }
      }

      const accessoriesNextButton =
        modal.querySelector(
          '[data-ld-accessories-next]'
        );
      if (accessoriesNextButton) {
        accessoriesNextButton.textContent =
          displayZoneCount() === 1 &&
          currentZone === 1
            ? 'Review Project'
            : 'Review This Zone';

        accessoriesNextButton.disabled =
          extensionTotal >
          maxExtensions;
      }

      const subtotal =
        accessoriesSubtotal();
      const subtotalElement =
        modal.querySelector(
          '[data-ld-accessories-subtotal]'
        );
      const projectTotal =
        modal.querySelector(
          '[data-ld-accessories-project-total]'
        );
      const subtotalRow =
        modal.querySelector(
          '[data-ld-accessories-subtotal-row]'
        );

      if (subtotalElement) {
        subtotalElement.textContent =
          money(
            subtotal
          );
      }

      if (subtotalRow) {
        subtotalRow.hidden =
          subtotal <= 0;
      }

      if (projectTotal) {
        projectTotal.textContent =
          money(
            projectTotalIncludingCurrent(
              finalZoneTotalFor(
                state
              )
            ) +
            subtotal
          );
      }
      renderCableRoutePlanner();
      refreshCurrentSummary();
    }
    function openAccessories() {
      updateAccessoriesUI();
      showScreen(
        screens.accessories
      );
    }
    /* =====================================================
       FINAL PROJECT REVIEW
       ===================================================== */
    function renderProjectConnectionPlan() {
      const container =
        modal.querySelector(
          '[data-ld-project-connection-plan]'
        );

      if (!container) {
        return;
      }

      container.innerHTML =
        '';

      completedZoneNumbers()
        .forEach(function (
          zoneNumber
        ) {
          const zone =
            normaliseZone(
              zoneNumber
            );
          const product =
            selectedLightProduct(
              zone
            );
          const driver =
            selectDriverFor(
              zone
            );
          const base =
            baseZoneFor(
              zone
            );

          if (
            !product ||
            !driver
          ) {
            return;
          }

          const card =
            document.createElement(
              'article'
            );
          card.className =
            'ld-project-map-zone';

          const zoneTitle =
            (
              zone.name &&
              zone.name.trim()
            )
              ? 'Zone ' +
                zoneNumber +
                ' · ' +
                zone.name.trim()
              : 'Zone ' +
                zoneNumber;

          const powerTitle =
            zone.ukPlug
              ? '230V socket'
              : 'Lighting circuit';
          const powerNote =
            zone.ukPlug
              ? '2m UK plug cable'
              : '1m bare-ended mains cable';

          const controlTitle =
            (
              zone.sensor &&
              zone.sensor !==
                'none'
            )
              ? sensorName(
                  zone.sensor
                )
              : 'No sensor';
          const controlNote =
            (
              zone.sensor &&
              zone.sensor !==
                'none'
            )
              ? 'Controls this zone'
              : zone.ukPlug
                ? 'Socket switching: on/off only; no mains dimmer'
                : 'Standard wall switch: on/off only; no mains wall dimmer';

          const flow =
            [];

          flow.push({
            kicker:
              'Mains',
            title:
              powerTitle,
            note:
              powerNote
          });

          flow.push({
            kicker:
              '24V power',
            title:
              driver.watts +
              'W Driver',
            note:
              driver.ports +
              ' ports'
          });

          flow.push({
            kicker:
              'Control',
            title:
              controlTitle,
            note:
              controlNote
          });

          if (
            base.blocks > 0
          ) {
            flow.push({
              kicker:
                'Distribution',
              title:
                base.blocks +
                ' × 6-way block' +
                (
                  base.blocks === 1
                    ? ''
                    : 's'
                ),
              note:
                'Automatically required'
            });
          }

          flow.push({
            kicker:
              'Lights',
            title:
              zone.quantity +
              ' × ' +
              styleName(
                zone.style
              ),
            note:
              finishName(
                zone.finish
              ) +
              ' · ' +
              colourName(
                zone.colour
              )
          });

          const flowHtml =
            flow
              .map(function (
                item,
                index
              ) {
                return (
                  (
                    index > 0
                      ? '<span class="ld-project-map-arrow" aria-hidden="true">→</span>'
                      : ''
                  ) +
                  '<div class="ld-project-map-node">' +
                    '<span>' +
                      escapeHtml(
                        item.kicker
                      ) +
                    '</span>' +
                    '<strong>' +
                      escapeHtml(
                        item.title
                      ) +
                    '</strong>' +
                    '<small>' +
                      escapeHtml(
                        item.note
                      ) +
                    '</small>' +
                  '</div>'
                );
              })
              .join('');

          const zoneAccessories =
            normaliseAccessories(
              zone.accessories
            );
          const extensionParts =
            [];
          if (
            zoneAccessories.extension2 >
            0
          ) {
            extensionParts.push(
              zoneAccessories.extension2 +
              ' × 2m extension'
            );
          }
          if (
            zoneAccessories.extension5 >
            0
          ) {
            extensionParts.push(
              zoneAccessories.extension5 +
              ' × 5m extension'
            );
          }

          const cablePlan =
            normaliseCablePlan(
              zone.cablePlan
            )
              .slice(
                0,
                Number(
                  zone.quantity || 0
                )
              );
          const measuredCount =
            cablePlan.filter(function (
              value
            ) {
              return (
                Number.isFinite(
                  Number(
                    value
                  )
                ) &&
                Number(
                  value
                ) > 0
              );
            }).length;

          const detailBits =
            [];
          if (
            zone.driverLocation
          ) {
            detailBits.push(
              'Driver location: ' +
              zone.driverLocation
            );
          }
          detailBits.push(
            extensionParts.length
              ? 'Extensions: ' +
                extensionParts.join(
                  ' · '
                )
              : 'Extensions: none selected'
          );
          if (
            measuredCount > 0
          ) {
            detailBits.push(
              'Cable routes planned: ' +
              measuredCount +
              '/' +
              zone.quantity
            );
          }

          card.innerHTML =
            '<div class="ld-project-map-zone-head">' +
              '<div>' +
                '<span>Zone connection</span>' +
                '<strong>' +
                  escapeHtml(
                    zoneTitle
                  ) +
                '</strong>' +
              '</div>' +
              '<small>' +
                zone.quantity +
                (
                  Number(
                    zone.quantity
                  ) === 1
                    ? ' light'
                    : ' lights'
                ) +
              '</small>' +
            '</div>' +
            '<div class="ld-project-map-flow">' +
              flowHtml +
            '</div>' +
            '<div class="ld-project-map-meta">' +
              detailBits
                .map(function (
                  bit
                ) {
                  return (
                    '<span>' +
                      escapeHtml(
                        bit
                      ) +
                    '</span>'
                  );
                })
                .join('') +
            '</div>';

          container.appendChild(
            card
          );
        });
    }

    function renderProjectReadiness() {
      const readiness =
        modal.querySelector(
          '[data-ld-project-readiness]'
        );
      const title =
        modal.querySelector(
          '[data-ld-project-readiness-title]'
        );
      const copy =
        modal.querySelector(
          '[data-ld-project-readiness-copy]'
        );

      if (
        !readiness ||
        !title ||
        !copy
      ) {
        return;
      }

      const ready =
        projectReadyForCart();

      readiness.classList.toggle(
        'is-ready',
        ready
      );
      readiness.classList.toggle(
        'needs-attention',
        !ready
      );

      if (ready) {
        title.textContent =
          'Project checks complete';
        copy.textContent =
          'Every zone is complete, a compatible 24V driver has been matched, required distribution blocks are included and extension quantities are within the allowed limits.';
      } else {
        title.textContent =
          'One more check is needed';
        copy.textContent =
          'Finish or remove every planned zone before adding the project to your basket.';
      }
    }

    function renderProjectReview() {
      saveProject();
      saveProjectName();
      updateProjectNameDisplay();
      const zonesContainer =
        modal.querySelector(
          '[data-ld-project-review-zones]'
        );
      const accessoriesContainer =
        modal.querySelector(
          '[data-ld-project-review-accessories]'
        );
      const zonesTotalElement =
        modal.querySelector(
          '[data-ld-project-review-zones-total]'
        );
      const accessoriesTotalElement =
        modal.querySelector(
          '[data-ld-project-review-accessories-total]'
        );
      const grandTotalElement =
        modal.querySelector(
          '[data-ld-project-review-total]'
        );
      const projectSummaryElement =
        modal.querySelector(
          '[data-ld-project-review-summary]'
        );
      const projectAddZoneButton =
        modal.querySelector(
          '[data-ld-project-add-zone]'
        );
      const completed =
        completedZoneNumbers();
      if (zonesContainer) {
        zonesContainer.innerHTML =
          '';
        completed
          .forEach(function (
            zoneNumber
          ) {
            const zone =
              normaliseZone(
                zoneNumber
              );
            const product =
              selectedLightProduct(
                zone
              );
            const driver =
              selectDriverFor(
                zone
              );
            const base =
              baseZoneFor(
                zone
              );
            if (
              !product ||
              !driver
            ) {
              return;
            }
            const zoneCard =
              document.createElement(
                'div'
              );
            zoneCard.className =
              'ld-project-review-zone-card';
            const hasZoneName =
              !!(
                zone.name &&
                zone.name.trim()
              );
            const displayName =
              hasZoneName
                ? zone.name.trim()
                : 'Zone ' + zoneNumber;
            const zoneKicker =
              hasZoneName
                ? 'Zone ' + zoneNumber
                : 'Lighting Zone';
            const zoneSummary =
              zone.quantity +
              ' ' +
              (
                Number(zone.quantity) === 1
                  ? 'light'
                  : 'lights'
              ) +
              ' · ' +
              styleName(
                zone.style
              );
            const blockText =
              base.blocks > 0
                ? (
                    base.blocks +
                    ' × 6-Way Distribution ' +
                    (
                      base.blocks === 1
                        ? 'Block'
                        : 'Blocks'
                    )
                  )
                : 'Not required';
            let controlText =
              'No Sensor';
            let controlPrice =
              money(0);
            if (
              zone.ownDriver
            ) {
              controlText =
                'Not available — own driver';
            } else if (
              zone.sensor &&
              zone.sensor !==
              'none'
            ) {
              controlText =
                sensorName(
                  zone.sensor
                );
              controlPrice =
                money(
                  sensors[
                    zone.sensor
                  ].price
                );
            }
            const driverText =
              zone.ownDriver
                ? 'Customer supplying own compatible driver'
                : driver.watts +
                  'W Driver · ' +
                  driver.ports +
                  ' Ports';
            const mainsText =
              zone.ownDriver
                ? 'Not supplied'
                : zone.ukPlug
                  ? 'Plug into a socket · 2m UK Plug Cable'
                  : 'Wire into the lighting circuit · 1m Bare-Ended Mains Cable';
            const zoneAccessories =
              normaliseAccessories(
                zone.accessories
              );
            let accessoryRowsHtml =
              '';
            Object.keys(
              accessoryProducts
            )
              .forEach(function (
                key
              ) {
                const quantity =
                  Number(
                    zoneAccessories[
                      key
                    ] || 0
                  );
                if (
                  quantity <= 0
                ) {
                  return;
                }
                const product =
                  accessoryProducts[
                    key
                  ];
                const accessoryLabel =
                  key.indexOf('extension') === 0
                    ? 'Extension Lead'
                    : key.indexOf('wago') === 0
                      ? 'WAGO Connector'
                      : 'Accessory';
                accessoryRowsHtml +=
                  '<div class="ld-project-review-zone-line">' +
                    '<span class="ld-project-review-zone-line-label">' +
                      escapeHtml(
                        accessoryLabel
                      ) +
                    '</span>' +
                    '<span class="ld-project-review-zone-line-main">' +
                      escapeHtml(
                        quantity +
                        ' × ' +
                        product.name
                      ) +
                    '</span>' +
                    '<strong class="ld-project-review-zone-line-price">' +
                      money(
                        quantity *
                        product.price
                      ) +
                    '</strong>' +
                  '</div>';
              });
            zoneCard.innerHTML =
              '<div class="ld-project-review-zone-head">' +
                '<div class="ld-project-review-zone-head-left">' +
                  '<div class="ld-project-review-zone-thumb is-placeholder" data-ld-project-review-zone-image></div>' +
                  '<div class="ld-project-review-zone-head-copy">' +
                    '<span>' +
                      escapeHtml(
                        zoneKicker
                      ) +
                    '</span>' +
                    '<h3>' +
                      escapeHtml(
                        displayName
                      ) +
                    '</h3>' +
                    '<small class="ld-project-review-zone-summary">' +
                      escapeHtml(
                        zoneSummary
                      ) +
                    '</small>' +
                  '</div>' +
                '</div>' +
                '<button type="button" class="ld-project-review-edit" data-edit-zone="' +
                  zoneNumber +
                  '" aria-label="Edit Zone ' +
                  zoneNumber +
                '">' +
                  'Edit' +
                '</button>' +
              '</div>' +
              '<div class="ld-project-review-zone-lines">' +
                '<div class="ld-project-review-zone-line">' +
                  '<span class="ld-project-review-zone-line-label">' +
                    'Lights' +
                  '</span>' +
                  '<span class="ld-project-review-zone-line-main">' +
                    zone.quantity +
                    ' × ' +
                    escapeHtml(
                      styleName(
                        zone.style
                      )
                    ) +
                    ' · ' +
                    escapeHtml(
                      finishName(
                        zone.finish
                      )
                    ) +
                    ' · ' +
                    escapeHtml(
                      colourName(
                        zone.colour
                      )
                    ) +
                  '</span>' +
                  '<strong class="ld-project-review-zone-line-price">' +
                    money(
                      base.lightsTotal
                    ) +
                  '</strong>' +
                '</div>' +
                '<div class="ld-project-review-zone-line">' +
                  '<span class="ld-project-review-zone-line-label">' +
                    'Driver' +
                  '</span>' +
                  '<span class="ld-project-review-zone-line-main">' +
                    escapeHtml(
                      driverText
                    ) +
                  '</span>' +
                  '<strong class="ld-project-review-zone-line-price">' +
                    money(
                      base.driverTotal
                    ) +
                  '</strong>' +
                '</div>' +
                (
                  base.blocks > 0
                    ? (
                        '<div class="ld-project-review-zone-line">' +
                          '<span class="ld-project-review-zone-line-label">' +
                            'Distribution Block' +
                          '</span>' +
                          '<span class="ld-project-review-zone-line-main">' +
                            escapeHtml(
                              blockText
                            ) +
                          '</span>' +
                          '<strong class="ld-project-review-zone-line-price">' +
                            money(
                              base.blocksTotal
                            ) +
                          '</strong>' +
                        '</div>'
                      )
                    : ''
                ) +
                '<div class="ld-project-review-zone-line">' +
                  '<span class="ld-project-review-zone-line-label">' +
                    'Mains Connection' +
                  '</span>' +
                  '<span class="ld-project-review-zone-line-main">' +
                    escapeHtml(
                      mainsText
                    ) +
                  '</span>' +
                  '<strong class="ld-project-review-zone-line-price">' +
                    (
                      zone.ownDriver
                        ? '—'
                        : zone.ukPlug
                          ? money(
                              base.ukPlugTotal
                            )
                          : 'Included'
                    ) +
                  '</strong>' +
                '</div>' +
                '<div class="ld-project-review-zone-line">' +
                  '<span class="ld-project-review-zone-line-label">' +
                    'Control' +
                  '</span>' +
                  '<span class="ld-project-review-zone-line-main">' +
                    escapeHtml(
                      controlText
                    ) +
                  '</span>' +
                  '<strong class="ld-project-review-zone-line-price">' +
                    controlPrice +
                  '</strong>' +
                '</div>' +
                accessoryRowsHtml +
              '</div>' +
              '<div class="ld-project-review-zone-total">' +
                '<strong>' +
                  'Zone ' +
                  zoneNumber +
                  ' Total' +
                '</strong>' +
                '<strong>' +
                  money(
                    zoneTotalWithAccessoriesFor(
                      zone
                    )
                  ) +
                '</strong>' +
              '</div>';
            const zoneImage =
              zoneCard.querySelector(
                '[data-ld-project-review-zone-image]'
              );
            if (zoneImage) {
              loadSetupImage(
                zoneImage,
                zone
              );
            }
            const editButton =
              zoneCard.querySelector(
                '[data-edit-zone]'
              );
            if (editButton) {
              editButton.addEventListener(
                'click',
                function () {
                  loadZone(
                    zoneNumber
                  );
                  updateEverything();
                  showScreen(
                    screens.review
                  );
                }
              );
            }
            zonesContainer.appendChild(
              zoneCard
            );
          });
      }
      const zonesTotal =
        completedProjectTotal();
      const totalLights =
        completed.reduce(
          function (sum, zoneNumber) {
            const zone =
              normaliseZone(
                zoneNumber
              );
            return (
              sum +
              Number(
                zone.quantity || 0
              )
            );
          },
          0
        );
      if (projectSummaryElement) {
        projectSummaryElement.textContent =
          completed.length +
          ' ' +
          (
            completed.length === 1
              ? 'zone'
              : 'zones'
          ) +
          ' · ' +
          totalLights +
          ' ' +
          (
            totalLights === 1
              ? 'light'
              : 'lights'
          );
      }
      if (projectAddZoneButton) {
        projectAddZoneButton.hidden =
          displayZoneCount() >= 6;
      }
      if (zonesTotalElement) {
        zonesTotalElement.textContent =
          money(
            zonesTotal
          );
      }
      if (grandTotalElement) {
        grandTotalElement.textContent =
          money(
            zonesTotal
          );
      }
      if (finalAddButton) finalAddButton.disabled = !projectReadyForCart() || cartBusy;
      let incomplete = screens.projectReview.querySelector('[data-ld-incomplete-project]');
      if (!incomplete) {
        incomplete = document.createElement('p');
        incomplete.dataset.ldIncompleteProject = '';
        incomplete.className = 'ld-project-incomplete';
        incomplete.setAttribute('role', 'status');
        zonesContainer.before(incomplete);
      }
      incomplete.hidden = projectReadyForCart();
      incomplete.textContent = 'An unfinished zone is not included in this total. Use its zone tab to finish it, or remove it, before adding your project.';

      renderProjectConnectionPlan();
      renderProjectReadiness();
    }
    /* =====================================================
       PROJECT PACK EVENTS
       ===================================================== */
    const downloadProjectPackButton =
      modal.querySelector(
        '[data-ld-download-project-pack]'
      );
    const printProjectPackButton =
      modal.querySelector(
        '[data-ld-print-project-pack]'
      );
    const copyProjectPackButton =
      modal.querySelector(
        '[data-ld-copy-project-pack]'
      );

    if (downloadProjectPackButton) {
      downloadProjectPackButton.addEventListener(
        'click',
        downloadProjectPack
      );
    }

    if (printProjectPackButton) {
      printProjectPackButton.addEventListener(
        'click',
        printProjectPack
      );
    }

    if (copyProjectPackButton) {
      copyProjectPackButton.addEventListener(
        'click',
        copyProjectPack
      );
    }

    /* =====================================================
       PROJECT HELP
       ===================================================== */
    const helpOverlay =
      modal.querySelector(
        '[data-ld-project-help-overlay]'
      );
    const helpModal =
      modal.querySelector(
        '[data-ld-project-help-modal]'
      );
    const helpOpenButtons =
      modal.querySelectorAll(
        '[data-ld-open-project-help]'
      );
    const helpClose =
      modal.querySelector(
        '[data-ld-close-project-help]'
      );
    const helpCancel =
      modal.querySelector(
        '[data-ld-cancel-project-help]'
      );
    const helpSummary =
      modal.querySelector(
        '[data-ld-help-project-summary]'
      );
    const helpPreview =
      modal.querySelector(
        '[data-ld-help-project-preview]'
      );
    function projectHelpOpen() {
      return (
        helpModal &&
        helpModal.classList.contains(
          'is-open'
        )
      );
    }
    function buildProjectSummaryText() {
      const lines =
        [];
      lines.push(
        'LOOPSDIRECT LIGHTING PROJECT'
      );
      lines.push(
        '============================'
      );
      lines.push('');
      if (
        cleanProjectName(
          projectName
        )
      ) {
        lines.push(
          'Project / Job: ' +
          cleanProjectName(
            projectName
          )
        );
        lines.push('');
      }
      completedZoneNumbers()
        .forEach(function (
          zoneNumber
        ) {
          const zone =
            normaliseZone(
              zoneNumber
            );
          const product =
            selectedLightProduct(
              zone
            );
          const driver =
            selectDriverFor(
              zone
            );
          const base =
            baseZoneFor(
              zone
            );
          const zoneLabel =
            (
              zone.name &&
              zone.name.trim()
            )
              ? 'Zone ' +
                zoneNumber +
                ' - ' +
                zone.name.trim()
              : 'Zone ' +
                zoneNumber;
          lines.push(
            zoneLabel
          );
          lines.push(
            'Light: ' +
            zone.quantity +
            ' x ' +
            styleName(
              zone.style
            ) +
            ' | ' +
            finishName(
              zone.finish
            ) +
            ' | ' +
            colourName(
              zone.colour
            ) +
            (
              product
                ? ' | SKU ' +
                  product.sku
                : ''
            )
          );
          if (
            zone.ownDriver
          ) {
            lines.push(
              'Driver: Customer supplying own compatible 24V driver'
            );
            lines.push(
              'Recommended capacity: ' +
              (
                driver
                  ? driver.watts +
                    'W / ' +
                    driver.ports +
                    ' ports'
                  : ''
              )
            );
          } else {
            lines.push(
              'Driver: ' +
              (
                driver
                  ? driver.watts +
                    'W / ' +
                    driver.ports +
                    ' ports / SKU ' +
                    driver.sku
                  : 'Not available'
              )
            );
          }
          if (
            base.blocks > 0
          ) {
            lines.push(
              'Required Distribution Blocks: ' +
              base.blocks +
              ' x 6-Way / SKU ' +
              distributionBlock.sku
            );
          } else {
            lines.push(
              'Required Distribution Blocks: None'
            );
          }
          lines.push(
            'Mains Connection: ' +
            (
              zone.ownDriver
                ? 'Not supplied'
                : zone.ukPlug
                  ? '2m UK Plug Cable / SKU ' +
                    ukPlugCable.sku
                  : '1m Bare-Ended Mains Cable (included)'
            )
          );
          lines.push(
            'Sensor / Control: ' +
            (
              zone.ownDriver
                ? 'Not available - own driver'
                : zone.sensor ===
                  'none'
                  ? 'No Sensor'
                  : sensorName(
                      zone.sensor
                    ) +
                    (
                      sensors[
                        zone.sensor
                      ] &&
                      sensors[
                        zone.sensor
                      ].sku
                        ? ' / SKU ' +
                          sensors[
                            zone.sensor
                          ].sku
                        : ''
                    )
            )
          );
          const zoneAccessories =
            normaliseAccessories(
              zone.accessories
            );
          Object.keys(
            accessoryProducts
          )
            .forEach(function (
              key
            ) {
              const quantity =
                Number(
                  zoneAccessories[
                    key
                  ] || 0
                );
              if (
                quantity <= 0
              ) {
                return;
              }
              lines.push(
                'Accessory: ' +
                quantity +
                ' x ' +
                accessoryProducts[
                  key
                ].name +
                ' / SKU ' +
                accessoryProducts[
                  key
                ].sku
              );
            });
          if (
            zone.driverLocation
          ) {
            lines.push(
              'Planned Driver Location: ' +
              cleanDriverLocation(
                zone.driverLocation
              )
            );
          }

          const savedCablePlan =
            normaliseCablePlan(
              zone.cablePlan
            )
              .slice(
                0,
                Number(
                  zone.quantity || 0
                )
              );

          if (
            savedCablePlan.some(function (
              value
            ) {
              return (
                Number.isFinite(
                  Number(
                    value
                  )
                ) &&
                Number(
                  value
                ) > 0
              );
            })
          ) {
            lines.push(
              'Cable Route Plan:'
            );

            savedCablePlan.forEach(function (
              value,
              index
            ) {
              if (
                !Number.isFinite(
                  Number(
                    value
                  )
                ) ||
                Number(
                  value
                ) <= 0
              ) {
                lines.push(
                  '  Light ' +
                  (
                    index + 1
                  ) +
                  ': Not measured'
                );
                return;
              }

              const recommendation =
                cableRecommendationForDistance(
                  zone,
                  value
                );

              lines.push(
                '  Light ' +
                (
                  index + 1
                ) +
                ': ' +
                value +
                'm routed distance -> ' +
                recommendation.label
              );
            });
          }

          lines.push(
            'Zone Total: ' +
            money(
              zoneTotalWithAccessoriesFor(
                zone
              )
            )
          );
          lines.push('');
        });
      lines.push(
        'Project Total: ' +
        money(
          completedProjectTotal()
        )
      );
      lines.push('');
      lines.push(
        'Prices include VAT.'
      );
      lines.push(
        'Free UK mainland delivery applies to this lighting project; non-mainland delivery options are shown at checkout.'
      );
      lines.push('');
      lines.push(
        'INSTALLATION NOTE'
      );
      lines.push(
        'This project pack is a component/planning summary, not an electrical wiring instruction. General mains wiring materials, suitable enclosures, labour and installation-specific items not listed above may still be required.'
      );
      return lines.join(
        '\n'
      );
    }

    function projectPackFileName() {
      const cleaned =
        cleanProjectName(
          projectName
        ) ||
        'Lighting Project';

      const safe =
        cleaned
          .replace(
            /[^a-z0-9]+/gi,
            '-'
          )
          .replace(
            /^-+|-+$/g,
            ''
          )
          .slice(
            0,
            60
          ) ||
        'Lighting-Project';

      return (
        'LoopsDirect-' +
        safe +
        '-Project-Pack.txt'
      );
    }

    function setProjectPackStatus(
      message,
      type
    ) {
      const status =
        modal.querySelector(
          '[data-ld-project-pack-status]'
        );

      if (!status) {
        return;
      }

      status.textContent =
        message || '';
      status.className =
        'ld-project-pack-status' +
        (
          type
            ? ' is-' + type
            : ''
        );
    }

    function downloadProjectPack() {
      const text =
        buildProjectSummaryText();
      const blob =
        new Blob(
          [text],
          {
            type:
              'text/plain;charset=utf-8'
          }
        );
      const url =
        URL.createObjectURL(
          blob
        );
      const link =
        document.createElement(
          'a'
        );

      link.href =
        url;
      link.download =
        projectPackFileName();
      document.body
        .appendChild(
          link
        );
      link.click();
      link.remove();

      setTimeout(
        function () {
          URL.revokeObjectURL(
            url
          );
        },
        1000
      );

      setProjectPackStatus(
        'Project parts list downloaded.',
        'success'
      );
    }

    async function copyProjectPack() {
      const text =
        buildProjectSummaryText();

      try {
        if (
          navigator.clipboard &&
          navigator.clipboard.writeText
        ) {
          await navigator.clipboard.writeText(
            text
          );
        } else {
          const textarea =
            document.createElement(
              'textarea'
            );
          textarea.value =
            text;
          textarea.setAttribute(
            'readonly',
            ''
          );
          textarea.style.position =
            'fixed';
          textarea.style.opacity =
            '0';
          document.body.appendChild(
            textarea
          );
          textarea.select();
          document.execCommand(
            'copy'
          );
          textarea.remove();
        }

        setProjectPackStatus(
          'Project parts list copied.',
          'success'
        );
      } catch (error) {
        setProjectPackStatus(
          'Could not copy automatically. Use Download Parts List instead.',
          'error'
        );
      }
    }

    function buildProjectPrintHtml() {
      const projectTitle =
        cleanProjectName(
          projectName
        ) ||
        'Under Cabinet Lighting Project';

      const zonesHtml =
        completedZoneNumbers()
          .map(function (
            zoneNumber
          ) {
            const zone =
              normaliseZone(
                zoneNumber
              );
            const product =
              selectedLightProduct(
                zone
              );
            const driver =
              selectDriverFor(
                zone
              );
            const base =
              baseZoneFor(
                zone
              );
            const zoneAccessories =
              normaliseAccessories(
                zone.accessories
              );
            const rows =
              [];

            rows.push([
              'Lights',
              zone.quantity +
                ' × ' +
                styleName(
                  zone.style
                ) +
                ' · ' +
                finishName(
                  zone.finish
                ) +
                ' · ' +
                colourName(
                  zone.colour
                ),
              product
                ? product.sku
                : ''
            ]);

            rows.push([
              'Driver',
              driver
                ? driver.watts +
                  'W · ' +
                  driver.ports +
                  ' ports'
                : '—',
              driver
                ? driver.sku
                : ''
            ]);

            if (
              base.blocks > 0
            ) {
              rows.push([
                'Distribution',
                base.blocks +
                  ' × 6-way block',
                distributionBlock.sku
              ]);
            }

            rows.push([
              'Mains',
              zone.ukPlug
                ? '2m UK plug cable'
                : '1m bare-ended mains cable',
              zone.ukPlug
                ? ukPlugCable.sku
                : 'Included'
            ]);

            rows.push([
              'Control',
              (
                zone.sensor &&
                zone.sensor !==
                  'none'
              )
                ? sensorName(
                    zone.sensor
                  )
                : 'No sensor',
              (
                zone.sensor &&
                zone.sensor !==
                  'none' &&
                sensors[
                  zone.sensor
                ]
              )
                ? sensors[
                    zone.sensor
                  ].sku || ''
                : ''
            ]);

            Object.keys(
              accessoryProducts
            ).forEach(function (
              key
            ) {
              const quantity =
                Number(
                  zoneAccessories[
                    key
                  ] || 0
                );

              if (
                quantity <= 0
              ) {
                return;
              }

              rows.push([
                'Accessory',
                quantity +
                  ' × ' +
                  accessoryProducts[
                    key
                  ].name,
                accessoryProducts[
                  key
                ].sku
              ]);
            });

            const cablePlan =
              normaliseCablePlan(
                zone.cablePlan
              )
                .slice(
                  0,
                  Number(
                    zone.quantity || 0
                  )
                );

            const routeHtml =
              cablePlan.some(function (
                value
              ) {
                return (
                  Number.isFinite(
                    Number(
                      value
                    )
                  ) &&
                  Number(
                    value
                  ) > 0
                );
              })
                ? (
                    '<div class="routes">' +
                      '<strong>Cable route plan</strong>' +
                      '<ul>' +
                        cablePlan
                          .map(function (
                            value,
                            index
                          ) {
                            if (
                              !Number.isFinite(
                                Number(
                                  value
                                )
                              ) ||
                              Number(
                                value
                              ) <= 0
                            ) {
                              return (
                                '<li>Light ' +
                                (
                                  index + 1
                                ) +
                                ': not measured</li>'
                              );
                            }

                            const recommendation =
                              cableRecommendationForDistance(
                                zone,
                                value
                              );

                            return (
                              '<li>Light ' +
                              (
                                index + 1
                              ) +
                              ': ' +
                              escapeHtml(
                                String(
                                  value
                                )
                              ) +
                              'm — ' +
                              escapeHtml(
                                recommendation.label
                              ) +
                              '</li>'
                            );
                          })
                          .join('') +
                      '</ul>' +
                    '</div>'
                  )
                : '';

            return (
              '<section class="zone">' +
                '<div class="zone-head">' +
                  '<div>' +
                    '<span>Zone ' +
                      zoneNumber +
                    '</span>' +
                    '<h2>' +
                      escapeHtml(
                        (
                          zone.name &&
                          zone.name.trim()
                        )
                          ? zone.name.trim()
                          : 'Lighting Zone'
                      ) +
                    '</h2>' +
                  '</div>' +
                  '<strong>' +
                    money(
                      zoneTotalWithAccessoriesFor(
                        zone
                      )
                    ) +
                  '</strong>' +
                '</div>' +
                (
                  zone.driverLocation
                    ? (
                        '<p class="driver-location"><strong>Planned driver location:</strong> ' +
                        escapeHtml(
                          zone.driverLocation
                        ) +
                        '</p>'
                      )
                    : ''
                ) +
                '<table>' +
                  '<thead><tr><th>Component</th><th>Selection</th><th>SKU</th></tr></thead>' +
                  '<tbody>' +
                    rows
                      .map(function (
                        row
                      ) {
                        return (
                          '<tr>' +
                            '<td>' +
                              escapeHtml(
                                row[0]
                              ) +
                            '</td>' +
                            '<td>' +
                              escapeHtml(
                                row[1]
                              ) +
                            '</td>' +
                            '<td>' +
                              escapeHtml(
                                row[2]
                              ) +
                            '</td>' +
                          '</tr>'
                        );
                      })
                      .join('') +
                  '</tbody>' +
                '</table>' +
                routeHtml +
              '</section>'
            );
          })
          .join('');

      return (
        '<!doctype html>' +
        '<html><head><meta charset="utf-8">' +
        '<title>' +
          escapeHtml(
            projectTitle
          ) +
        ' · LoopsDirect Project Pack</title>' +
        '<style>' +
          'body{font-family:Arial,sans-serif;color:#1f1f1f;margin:32px;line-height:1.45}' +
          '.brand{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#6d6258;font-weight:700}' +
          'h1{font-size:28px;margin:6px 0 4px}.intro{color:#665f58;margin:0 0 26px}' +
          '.zone{page-break-inside:avoid;border:1px solid #d9d3cb;border-radius:12px;padding:18px;margin:0 0 18px}' +
          '.zone-head{display:flex;justify-content:space-between;gap:20px;align-items:flex-start;margin-bottom:12px}' +
          '.zone-head span{font-size:11px;text-transform:uppercase;letter-spacing:.08em;color:#8b7a69}' +
          '.zone-head h2{margin:3px 0 0;font-size:19px}.zone-head>strong{font-size:17px}' +
          '.driver-location{background:#f6f3ee;padding:8px 10px;border-radius:8px;font-size:12px}' +
          'table{width:100%;border-collapse:collapse;font-size:12px}th,td{text-align:left;padding:8px 7px;border-bottom:1px solid #ece7e1;vertical-align:top}' +
          'th{font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#766b61}' +
          '.routes{margin-top:14px;padding:12px;background:#faf8f5;border-radius:9px;font-size:12px}.routes ul{margin:7px 0 0;padding-left:18px}' +
          '.total{display:flex;justify-content:space-between;align-items:center;border-top:2px solid #222;padding-top:16px;margin-top:26px;font-size:18px;font-weight:700}' +
          '.note{margin-top:22px;padding:12px 14px;background:#f5f2ed;border-radius:8px;color:#655e57;font-size:11px}' +
          '@media print{body{margin:14mm}.zone{break-inside:avoid}}' +
        '</style></head><body>' +
          '<div class="brand">LoopsDirect · Under Cabinet Lighting</div>' +
          '<h1>' +
            escapeHtml(
              projectTitle
            ) +
          '</h1>' +
          '<p class="intro">Project parts and planning summary · ' +
            completedZoneNumbers().length +
            (
              completedZoneNumbers().length === 1
                ? ' zone'
                : ' zones'
            ) +
          '</p>' +
          zonesHtml +
          '<div class="total"><span>Project Total</span><strong>' +
            money(
              completedProjectTotal()
            ) +
          '</strong></div>' +
          '<div class="note">' +
            '<strong>Installation note:</strong> This project pack is a component/planning summary, not an electrical wiring instruction. ' +
            'General mains wiring materials, suitable enclosures, labour and installation-specific items not explicitly listed may still be required. ' +
            'Prices include VAT. Free UK mainland delivery applies; non-mainland delivery options are shown at checkout.' +
          '</div>' +
        '</body></html>'
      );
    }

    function printProjectPack() {
      const printWindow =
        window.open(
          '',
          '_blank'
        );

      if (!printWindow) {
        setProjectPackStatus(
          'Your browser blocked the print window. Allow pop-ups for this page or use Download Parts List.',
          'error'
        );
        return;
      }

      printWindow.document.open();
      printWindow.document.write(
        buildProjectPrintHtml()
      );
      printWindow.document.close();

      setProjectPackStatus(
        'Project plan opened for printing or saving as PDF.',
        'success'
      );

      setTimeout(
        function () {
          try {
            printWindow.focus();
            printWindow.print();
          } catch (error) {
            // The print-ready project plan remains open in the new tab.
          }
        },
        350
      );
    }

    function buildProjectHelpPreview() {
      if (!helpPreview) {
        return;
      }
      helpPreview.innerHTML =
        '';
      completedZoneNumbers()
        .forEach(function (
          zoneNumber
        ) {
          const zone =
            normaliseZone(
              zoneNumber
            );
          const driver =
            selectDriverFor(
              zone
            );
          const base =
            baseZoneFor(
              zone
            );
          const item =
            document.createElement(
              'div'
            );
          item.className =
            'ld-help-preview-zone';
          const title =
            (
              zone.name &&
              zone.name.trim()
            )
              ? 'Zone ' +
                zoneNumber +
                ' – ' +
                zone.name.trim()
              : 'Zone ' +
                zoneNumber;
          let line =
            zone.quantity +
            ' × ' +
            styleName(
              zone.style
            ) +
            ' · ' +
            finishName(
              zone.finish
            ) +
            ' · ' +
            colourName(
              zone.colour
            );
          line +=
            zone.ownDriver
              ? ' · Own driver'
              : ' · ' +
                driver.watts +
                'W driver';
          if (
            base.blocks > 0
          ) {
            line +=
              ' · ' +
              base.blocks +
              ' required distribution ' +
              (
                base.blocks === 1
                  ? 'block'
                  : 'blocks'
              );
          }
          if (
            zone.ukPlug
          ) {
            line +=
              ' · UK plug cable';
          }
          if (
            zone.sensor &&
            zone.sensor !==
            'none'
          ) {
            line +=
              ' · ' +
              sensorName(
                zone.sensor
              );
          }
          const zoneAccessories =
            normaliseAccessories(
              zone.accessories
            );
          Object.keys(
            accessoryProducts
          )
            .forEach(function (
              key
            ) {
              const quantity =
                Number(
                  zoneAccessories[
                    key
                  ] || 0
                );
              if (
                quantity > 0
              ) {
                line +=
                  ' · ' +
                  quantity +
                  ' × ' +
                  accessoryProducts[
                    key
                  ].name;
              }
            });
          item.innerHTML =
            '<strong>' +
              escapeHtml(
                title
              ) +
            '</strong>' +
            '<span>' +
              escapeHtml(
                line
              ) +
            '</span>';
          helpPreview.appendChild(
            item
          );
        });
      const total =
        document.createElement(
          'div'
        );
      total.className =
        'ld-help-preview-total';
      total.innerHTML =
        '<span>' +
          'Project Total' +
        '</span>' +
        '<strong>' +
          money(
            completedProjectTotal()
          ) +
        '</strong>';
      helpPreview.appendChild(
        total
      );
    }
    let helpReturnFocus = null;
    function openProjectHelp() {
      renderProjectReview();
      if (helpSummary) {
        helpSummary.value =
          buildProjectSummaryText();
      }
      buildProjectHelpPreview();
      if (helpOverlay) {
        helpOverlay.classList.add(
          'is-open'
        );
      }
      if (helpModal) {
        helpReturnFocus = document.activeElement;
        helpModal.classList.add(
          'is-open'
        );
        helpModal.scrollTop =
          0;
      }
      if (helpModal) { const focusTarget = helpModal.querySelector('input, button'); if (focusTarget) focusTarget.focus({ preventScroll: true }); }
    }
    function closeProjectHelp() {
      const wasOpen = helpModal && helpModal.classList.contains('is-open');
      if (helpOverlay) {
        helpOverlay.classList.remove(
          'is-open'
        );
      }
      if (helpModal) {
        helpModal.classList.remove(
          'is-open'
        );
      }
      if (wasOpen && helpReturnFocus && helpReturnFocus.isConnected) helpReturnFocus.focus({ preventScroll: true });
    }
    helpOpenButtons
      .forEach(function (
        helpOpenButton
      ) {
        helpOpenButton.addEventListener(
          'click',
          openProjectHelp
        );
      });
    if (helpClose) {
      helpClose.addEventListener(
        'click',
        closeProjectHelp
      );
    }
    if (helpCancel) {
      helpCancel.addEventListener(
        'click',
        closeProjectHelp
      );
    }
    if (helpOverlay) {
      helpOverlay.addEventListener(
        'click',
        closeProjectHelp
      );
    }
    /* =====================================================
       CART STATUS
       ===================================================== */
    const cartStatus =
      modal.querySelector(
        '[data-ld-cart-status]'
      );
    const finalAddButton =
      modal.querySelector(
        '[data-ld-final-add-to-cart]'
      );
    function finalButtonText() {
      return editingProjectId
        ? 'Update My Lighting Project'
        : 'Add My Lighting Project to Basket';
    }
    function resetFinalButton() {
      const disabled =
        !projectReadyForCart();
      if (finalAddButton) {
        finalAddButton.disabled =
          disabled;
        finalAddButton.textContent =
          finalButtonText();
      }
    }
    function showCartStatus(
      type,
      text
    ) {
      if (!cartStatus) {
        return;
      }
      cartStatus.className =
        'ld-cart-status is-visible is-' +
        type;
      cartStatus.textContent =
        text;
    }
    function clearCartStatus() {
      if (!cartStatus) {
        return;
      }
      cartStatus.className =
        'ld-cart-status';
      cartStatus.textContent =
        '';
    }
    /* =====================================================
       SHOPIFY VARIANT LOOKUP
       ===================================================== */
    const variantCache =
      {};
    async function productDataFromHandle(
      handle
    ) {
      const response =
        await fetch(
          shopRoot() +
          'products/' +
          encodeURIComponent(
            handle
          ) +
          '.js',
          {
            credentials:
              'same-origin'
          }
        );
      if (
        !response.ok
      ) {
        throw new Error(
          'Could not load Shopify product ' +
          handle
        );
      }
      return response.json();
    }
    async function variantIdFromKnownHandle(
      sku,
      handle
    ) {
      if (
        !sku ||
        !handle
      ) {
        return null;
      }
      const product =
        await productDataFromHandle(
          handle
        );
      const variants =
        product.variants || [];
      const match =
        variants.find(function (
          variant
        ) {
          return (
            String(
              variant.sku || ''
            )
              .trim()
              .toLowerCase() ===
            String(
              sku
            )
              .trim()
              .toLowerCase()
          );
        });
      return match
        ? match.id
        : null;
    }
    async function searchProductHandlesBySku(
      sku
    ) {
      const url =
        shopRoot() +
        'search/suggest.json' +
        '?q=' +
        encodeURIComponent(
          sku
        ) +
        '&resources[type]=product' +
        '&resources[limit]=10' +
        '&resources[options][unavailable_products]=show';
      const response =
        await fetch(
          url,
          {
            credentials:
              'same-origin',
            headers: {
              Accept:
                'application/json'
            }
          }
        );
      if (
        !response.ok
      ) {
        throw new Error(
          'Shopify product search failed for ' +
          sku
        );
      }
      const data =
        await response.json();
      const products =
        (
          data &&
          data.resources &&
          data.resources.results &&
          data.resources.results.products
        )
          ? data.resources.results.products
          : [];
      return products
        .map(function (
          product
        ) {
          return product.handle;
        })
        .filter(Boolean);
    }
    async function resolveVariantId(
      sku,
      knownHandle
    ) {
      if (!sku) {
        return null;
      }
      const cacheKey =
        String(
          sku
        ).toLowerCase();
      if (
        variantCache[
          cacheKey
        ]
      ) {
        return variantCache[
          cacheKey
        ];
      }
      if (knownHandle) {
        try {
          const knownId =
            await variantIdFromKnownHandle(
              sku,
              knownHandle
            );
          if (knownId) {
            variantCache[
              cacheKey
            ] =
              knownId;
            return knownId;
          }
        } catch (error) {
          // Fall through to search.
        }
      }
      const handles =
        await searchProductHandlesBySku(
          sku
        );
      for (
        let i = 0;
        i < handles.length;
        i++
      ) {
        try {
          const variantId =
            await variantIdFromKnownHandle(
              sku,
              handles[i]
            );
          if (variantId) {
            variantCache[
              cacheKey
            ] =
              variantId;
            return variantId;
          }
        } catch (error) {
          // Try next matching product.
        }
      }
      return null;
    }
    /* =====================================================
       UNIQUE PROJECT IDs
       ===================================================== */
    let pendingCartProjectId =
      '';
    function createProjectId() {
      let uniquePart =
        '';
      if (
        window.crypto &&
        typeof window.crypto.randomUUID ===
        'function'
      ) {
        uniquePart =
          window.crypto
            .randomUUID()
            .replace(
              /-/g,
              ''
            )
            .slice(
              0,
              10
            )
            .toUpperCase();
      } else {
        uniquePart =
          (
            Date.now()
              .toString(36) +
            Math.random()
              .toString(36)
              .slice(
                2,
                8
              )
          )
            .toUpperCase();
      }
      return (
        'LD-' +
        uniquePart
      );
    }
    /* =====================================================
       BUILD CART COMPONENTS
       ===================================================== */
    function zoneProperties(
      projectId,
      zoneNumber,
      zone,
      component,
      componentKey
    ) {
      const properties = {
        'Lighting Project':
          'Under Cabinet Lighting',
        'Zone':
          'Zone ' +
          zoneNumber,
        'Component':
          component,
        '_ld_project_id':
          projectId,
        '_ld_zone_number':
          String(
            zoneNumber
          ),
        '_ld_component':
          componentKey,
        '_ld_style':
          styleName(
            zone.style
          ),
        '_ld_finish':
          finishName(
            zone.finish
          ),
        '_ld_colour':
          colourName(
            zone.colour
          )
      };
      const cleanedProjectName =
        cleanProjectName(
          projectName
        );
      if (
        cleanedProjectName
      ) {
        properties[
          'Project / Job Name'
        ] =
          cleanedProjectName;
        properties[
          '_ld_project_name'
        ] =
          cleanedProjectName;
      }
      if (
        zone.name &&
        zone.name.trim()
      ) {
        properties[
          'Zone Name'
        ] =
          zone.name.trim();
        properties[
          '_ld_zone_name'
        ] =
          zone.name.trim();
      }
      return properties;
    }
    function projectAccessoryProperties(
      projectId,
      componentKey
    ) {
      const properties = {
        'Lighting Project':
          'Under Cabinet Lighting',
        'Component':
          'Project Accessory',
        '_ld_project_id':
          projectId,
        '_ld_zone_number':
          '0',
        '_ld_component':
          componentKey
      };
      const cleanedProjectName =
        cleanProjectName(
          projectName
        );
      if (
        cleanedProjectName
      ) {
        properties[
          'Project / Job Name'
        ] =
          cleanedProjectName;
        properties[
          '_ld_project_name'
        ] =
          cleanedProjectName;
      }
      return properties;
    }
    function rawProjectCartLines(
      projectId
    ) {
      const lines =
        [];
      completedZoneNumbers()
        .forEach(function (
          zoneNumber
        ) {
          const zone =
            normaliseZone(
              zoneNumber
            );
          const light =
            selectedLightProduct(
              zone
            );
          const driver =
            selectDriverFor(
              zone
            );
          const blocks =
            requiredBlocksFor(
              zone,
              driver
            );
          if (light) {
            lines.push({
              sku:
                light.sku,
              handle:
                light.handle || '',
              quantity:
                Number(
                  zone.quantity || 0
                ),
              properties:
                zoneProperties(
                  projectId,
                  zoneNumber,
                  zone,
                  'Lights',
                  'lights'
                ),
              description:
                'Zone ' +
                zoneNumber +
                ' lights'
            });
          }
          if (
            driver
          ) {
            lines.push({
              sku:
                driver.sku,
              handle:
                driver.handle || '',
              quantity:
                1,
              properties:
                zoneProperties(
                  projectId,
                  zoneNumber,
                  zone,
                  'Driver',
                  'driver'
                ),
              description:
                'Zone ' +
                zoneNumber +
                ' driver'
            });
          }
          if (
            blocks > 0
          ) {
            lines.push({
              sku:
                distributionBlock.sku,
              handle:
                distributionBlock.handle || '',
              quantity:
                blocks,
              properties:
                zoneProperties(
                  projectId,
                  zoneNumber,
                  zone,
                  'Required Distribution Block',
                  'distribution-block'
                ),
              description:
                'Zone ' +
                zoneNumber +
                ' required distribution block'
            });
          }
          if (
            zone.ukPlug
          ) {
            lines.push({
              sku:
                ukPlugCable.sku,
              handle:
                ukPlugCable.handle || '',
              quantity:
                1,
              properties:
                zoneProperties(
                  projectId,
                  zoneNumber,
                  zone,
                  'UK Plug Cable',
                  'uk-plug'
                ),
              description:
                'Zone ' +
                zoneNumber +
                ' UK plug cable'
            });
          }
          if (
            zone.sensor &&
            zone.sensor !==
            'none' &&
            sensors[
              zone.sensor
            ] &&
            sensors[
              zone.sensor
            ].sku
          ) {
            lines.push({
              sku:
                sensors[
                  zone.sensor
                ].sku,
              handle:
                sensors[
                  zone.sensor
                ].handle || '',
              quantity:
                1,
              properties:
                zoneProperties(
                  projectId,
                  zoneNumber,
                  zone,
                  'Sensor / Control',
                  'sensor'
                ),
              description:
                'Zone ' +
                zoneNumber +
                ' sensor'
            });
          }
          const zoneAccessories =
            normaliseAccessories(
              zone.accessories
            );
          Object.keys(
            accessoryProducts
          )
            .forEach(function (
              key
            ) {
              const quantity =
                Number(
                  zoneAccessories[
                    key
                  ] || 0
                );
              if (
                quantity <= 0
              ) {
                return;
              }
              lines.push({
                sku:
                  accessoryProducts[
                    key
                  ].sku,
                handle:
                  accessoryProducts[
                    key
                  ].handle || '',
                quantity:
                  quantity,
                properties:
                  zoneProperties(
                    projectId,
                    zoneNumber,
                    zone,
                    accessoryProducts[
                      key
                    ].name,
                    'accessory-' +
                    key
                  ),
                description:
                  'Zone ' +
                  zoneNumber +
                  ' ' +
                  accessoryProducts[
                    key
                  ].name
              });
            });
        });
      return lines;
    }
    /* =====================================================
       SAVE CART PROJECT SNAPSHOT
       ===================================================== */
    function saveCartProjectSnapshot(
      projectId
    ) {
      const savedProjects =
        readSavedCartProjects();
      const savedZones =
        {};
      completedZoneNumbers()
        .forEach(function (
          zoneNumber
        ) {
          savedZones[
            String(
              zoneNumber
            )
          ] =
            deepClone(
              normaliseZone(
                zoneNumber
              )
            );
        });
      savedProjects[
        projectId
      ] = {
        projectId:
          projectId,
        projectName:
          cleanProjectName(
            projectName
          ),
        zoneCount:
          zoneCount,
        highestReached:
          highestReached,
        zones:
          savedZones,
        // Kept as an aggregate for backwards compatibility.
        // The source of truth is now each saved zone's own accessories object.
        accessories:
          aggregateProjectAccessories(),
        sourcePath:
          cleanCurrentSourcePath(),
        sourceUrl:
          cleanCurrentSourceUrl(),
        savedAt:
          new Date()
            .toISOString()
      };
      sessionStorage.setItem(
        SAVED_CART_PROJECTS_KEY,
        JSON.stringify(
          savedProjects
        )
      );
    }
    function deleteSavedCartProjectSnapshot(
      projectId
    ) {
      if (!projectId) {
        return;
      }
      const savedProjects =
        readSavedCartProjects();
      if (
        savedProjects[
          projectId
        ]
      ) {
        delete savedProjects[
          projectId
        ];
        sessionStorage.setItem(
          SAVED_CART_PROJECTS_KEY,
          JSON.stringify(
            savedProjects
          )
        );
      }
    }
    function clearEditRequest() {
      sessionStorage.removeItem(
        EDIT_REQUEST_KEY
      );
    }
    /* =====================================================
       RESOLVE CART
       ===================================================== */
    async function resolveCartLines(
      projectId
    ) {
      const rawLines =
        rawProjectCartLines(
          projectId
        );
      const items =
        [];
      for (
        let i = 0;
        i < rawLines.length;
        i++
      ) {
        const line =
          rawLines[i];
        showCartStatus(
          'working',
          'Checking ' +
          line.description +
          '...'
        );
        const variantId =
          await resolveVariantId(
            line.sku,
            line.handle
          );
        if (!variantId) {
          throw new Error(
            'We could not find the Shopify product for SKU ' +
            line.sku +
            ' (' +
            line.description +
            '). Nothing has been added to the basket.'
          );
        }
        items.push({
          id:
            variantId,
          quantity:
            line.quantity,
          properties:
            line.properties
        });
      }
      return items;
    }
    /* =====================================================
       SHOPIFY CART HELPERS
       ===================================================== */
    async function addItemsToShopifyCart(
      items
    ) {
      const response =
        await fetch(
          shopRoot() +
          'cart/add.js',
          {
            method:
              'POST',
            credentials:
              'same-origin',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body:
              JSON.stringify({
                items:
                  items
              })
          }
        );
      if (
        !response.ok
      ) {
        let errorMessage =
          'Shopify could not add the project to the basket.';
        try {
          const errorData =
            await response.json();
          if (
            errorData &&
            (
              errorData.description ||
              errorData.message
            )
          ) {
            errorMessage =
              errorData.description ||
              errorData.message;
          }
        } catch (error) {
          // Keep default message.
        }
        throw new Error(
          errorMessage
        );
      }
      return response.json();
    }
    async function getShopifyCart() {
      const response =
        await fetch(
          shopRoot() +
          'cart.js',
          {
            credentials:
              'same-origin',
            headers: {
              Accept:
                'application/json'
            }
          }
        );
      if (
        !response.ok
      ) {
        throw new Error(
          'We could not read the current basket.'
        );
      }
      return response.json();
    }
    async function removeCartProjectById(
      projectId
    ) {
      if (!projectId) {
        return;
      }
      const cart =
        await getShopifyCart();
      const updates =
        {};
      (
        cart.items || []
      )
        .forEach(function (
          item
        ) {
          const properties =
            item.properties || {};
          if (
            properties[
              '_ld_project_id'
            ] === projectId
          ) {
            updates[
              item.key
            ] =
              0;
          }
        });
      if (
        !Object.keys(
          updates
        ).length
      ) {
        return;
      }
      const response =
        await fetch(
          shopRoot() +
          'cart/update.js',
          {
            method:
              'POST',
            credentials:
              'same-origin',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body:
              JSON.stringify({
                updates:
                  updates
              })
          }
        );
      if (
        !response.ok
      ) {
        throw new Error(
          'The updated project was added, but the original project could not be removed.'
        );
      }
      return response.json();
    }
    /* =====================================================
       ADD / UPDATE PROJECT
       ===================================================== */
    let cartBusy =
      false;
    async function addProjectToCart() {
      if (
        cartBusy
      ) {
        return;
      }
      cartBusy =
        true;
      clearCartStatus();
      const isEditing =
        Boolean(
          editingProjectId
        );
      const oldProjectId =
        editingProjectId;
      const targetProjectId = pendingCartProjectId || createProjectId();
      pendingCartProjectId = targetProjectId;
      if (finalAddButton) {
        finalAddButton.disabled =
          true;
        finalAddButton.textContent =
          isEditing
            ? 'Updating Your Project...'
            : 'Preparing Your Project...';
      }
      try {
        renderProjectReview();
        showCartStatus(
          'working',
          isEditing
            ? 'Checking your updated lighting project...'
            : 'Checking your lighting project before adding it to the basket...'
        );
        if (!projectReadyForCart()) throw new Error('Please finish or remove each unfinished zone before adding the project.');
        const items =
          await resolveCartLines(
            targetProjectId
          );
        if (
          !items.length
        ) {
          throw new Error(
            'There are no completed lighting products to add.'
          );
        }
        showCartStatus(
          'working',
          isEditing
            ? 'Adding your updated project...'
            : 'Everything is ready. Adding your lighting project to the basket...'
        );
        const existingCart = await getShopifyCart();
        if ((existingCart.items || []).some(item => (item.properties || {})._ld_project_id === targetProjectId)) {
          await removeCartProjectById(targetProjectId);
        }
        await addItemsToShopifyCart(items);
        saveCartProjectSnapshot(
          targetProjectId
        );
        if (
          isEditing
        ) {
          showCartStatus(
            'working',
            'Updated project added. Replacing the previous version...'
          );
          try {
            await removeCartProjectById(
              oldProjectId
            );
          } catch (removeError) {
            clearEditRequest();
            pendingCartProjectId =
              '';
            editingProjectId =
              '';
            showCartStatus(
              'error',
              'Your updated project has been added, but the previous version could not be removed automatically. Opening your basket so you can remove the older project.'
            );
            if (finalAddButton) {
              finalAddButton.textContent =
                'Updated Project Added';
            }
            window.setTimeout(
              function () {
                window.location.href =
                  shopRoot() +
                  'cart';
              },
              1400
            );
            return;
          }
          deleteSavedCartProjectSnapshot(
            oldProjectId
          );
          clearEditRequest();
          editingProjectId =
            '';
          pendingCartProjectId =
            '';
          showCartStatus(
            'success',
            'Your lighting project has been updated successfully. Opening your basket...'
          );
          if (finalAddButton) {
            finalAddButton.textContent =
              'Updated ✓';
          }
        } else {
          pendingCartProjectId =
            '';
          showCartStatus(
            'success',
            'Your lighting project has been added successfully. Opening your basket...'
          );
          if (finalAddButton) {
            finalAddButton.textContent =
              'Added ✓';
          }
        }
        window.setTimeout(
          function () {
            window.location.href =
              shopRoot() +
              'cart';
          },
          650
        );
      } catch (error) {
        showCartStatus(
          'error',
          error &&
          error.message
            ? error.message
            : 'Something went wrong while preparing the basket.'
        );
        resetFinalButton();
        cartBusy =
          false;
      }
    }
    /* =====================================================
       OPEN / CLOSE
       ===================================================== */
    function openBuilder() {
      modal.classList.add(
        'is-open'
      );
      overlay.classList.add(
        'is-open'
      );
      document.body.style.overflow =
        'hidden';
      updateEverything();
      focusActiveScreen();
    }
    function closeBuilder() {
      closeSensorPopup();
      closeProjectHelp();
      modal.classList.remove(
        'is-open'
      );
      overlay.classList.remove(
        'is-open'
      );
      document.body.style.overflow =
        '';
      openButton.focus({ preventScroll: true });
    }
    openButton.addEventListener(
      'click',
      openBuilder
    );
    closeButton.addEventListener(
      'click',
      closeBuilder
    );
    overlay.addEventListener(
      'click',
      closeBuilder
    );
    /* =====================================================
       PROJECT / JOB NAME
       ===================================================== */
    const projectNameInput =
      modal.querySelector(
        '[data-ld-project-name-input]'
      );
    if (
      projectNameInput
    ) {
      projectNameInput.value =
        projectName;
      projectNameInput.addEventListener(
        'input',
        function () {
          projectName =
            String(
              projectNameInput.value ||
              ''
            )
              .slice(
                0,
                80
              );
          sessionStorage.setItem(
            PROJECT_NAME_KEY,
            projectName
          );
          updateProjectNameDisplay();
        }
      );
      projectNameInput.addEventListener(
        'blur',
        function () {
          projectName =
            cleanProjectName(
              projectNameInput.value
            );
          projectNameInput.value =
            projectName;
          saveProjectName();
          updateProjectNameDisplay();
        }
      );
    }
    /* =====================================================
       ZONE COUNT EVENTS
       ===================================================== */
    modal
      .querySelectorAll(
        '.ld-zone-option'
      )
      .forEach(function (
        button
      ) {
        button.addEventListener(
          'click',
          function () {
            applyZoneCountSelection(
              button.dataset.zoneCount
            );
          }
        );
      });
    const zoneNext =
      modal.querySelector(
        '[data-ld-zone-next]'
      );
    if (zoneNext) {
      zoneNext.addEventListener(
        'click',
        function () {
          if (!zoneCount) {
            return;
          }
          loadZone(1);
          updateEverything();
          showScreen(
            screens.style
          );
        }
      );
    }
    /* =====================================================
       START NEXT ZONE EVENTS
       ===================================================== */
    const differentSetupButton =
      modal.querySelector(
        '[data-ld-zone-start-new]'
      );
    if (differentSetupButton) {
      differentSetupButton.addEventListener(
        'click',
        startDifferentSetup
      );
    }
    const zoneStartBack =
      modal.querySelector(
        '[data-ld-zone-start-back]'
      );
    if (zoneStartBack) {
      zoneStartBack.addEventListener(
        'click',
        function () {
          if (
            currentZone <= 1
          ) {
            showScreen(
              screens.style
            );
            updateStyle();
            return;
          }
          loadZone(
            currentZone - 1
          );
          updateEverything();
          showScreen(
            isZoneComplete(
              state
            )
              ? screens.review
              : screenForStep(
                  furthestUnlockedStep(
                    state
                  )
                )
          );
        }
      );
    }
    prepareStyleChooser();
    prepareFinishChooser();
    /* =====================================================
       STYLE EVENTS
       ===================================================== */
    modal
      .querySelectorAll(
        '.ld-style-card'
      )
      .forEach(function (
        card
      ) {
        card.addEventListener(
          'click',
          function () {
            const newStyle =
              card.dataset.style;
            if (
              newStyle !==
              state.style
            ) {
              state.style =
                newStyle;
              state.finish =
                '';
              state.colour =
                '';
              state.stepDone.finish =
                false;
              state.stepDone.colour =
                false;
              state.stepDone.accessories =
                false;
              state.stepDone.review =
                false;
              if (
                state.sensor &&
                !sensorCompatibleFor(
                  state,
                  state.sensor
                )
              ) {
                state.sensor =
                  '';
                state.stepDone.sensor =
                  false;
              }
            }
            state.stepDone.style =
              true;
            state.styleManuallyChanged =
              true;
            if (
              currentZone > 1
            ) {
              state.startMode =
                'new';
            }
            saveProject();
            updateStyle();
            updateFinish();
            updateColour();
            updateSensor();
          }
        );
      });
    const styleBack =
      modal.querySelector(
        '[data-ld-style-back]'
      );
    const styleNext =
      modal.querySelector(
        '[data-ld-style-next]'
      );
    if (styleBack) {
      styleBack.addEventListener(
        'click',
        function () {
          if (
            currentZone === 1
          ) {
            closeBuilder();
          } else if (
            state.completedOnce
          ) {
            showScreen(
              screens.review
            );
          } else {
            renderZoneStart();
            showScreen(
              screens.zoneStart
            );
          }
        }
      );
    }
    if (styleNext) {
      styleNext.addEventListener(
        'click',
        function () {
          if (
            !state.style
          ) {
            return;
          }
          state.stepDone.style =
            true;
          saveProject();
          showScreen(
            screens.finish
          );
          updateFinish();
        }
      );
    }
    /* =====================================================
       FINISH EVENTS
       ===================================================== */
    modal
      .querySelectorAll(
        '.ld-finish-card'
      )
      .forEach(function (
        card
      ) {
        card.addEventListener(
          'click',
          function () {
            const oldColour =
              state.colour;
            state.finish =
              card.dataset.finish;
            state.stepDone.finish =
              true;
            const colourChanged =
              ensureCurrentColourValid();
            if (
              colourChanged ||
              !oldColour
            ) {
              state.stepDone.colour =
                false;
            }
            saveProject();
            updateFinish();
            updateColour();
          }
        );
      });
    const finishBack =
      modal.querySelector(
        '[data-ld-finish-back]'
      );
    const finishNext =
      modal.querySelector(
        '[data-ld-finish-next]'
      );
    if (finishBack) {
      finishBack.addEventListener(
        'click',
        function () {
          showScreen(
            screens.style
          );
        }
      );
    }
    if (finishNext) {
      finishNext.addEventListener(
        'click',
        function () {
          if (
            !state.finish
          ) {
            return;
          }
          state.stepDone.finish =
            true;
          ensureCurrentColourValid();
          saveProject();
          showScreen(
            screens.colour
          );
          updateColour();
        }
      );
    }
    /* =====================================================
       COLOUR EVENTS
       ===================================================== */
    modal
      .querySelectorAll(
        '.ld-colour-card'
      )
      .forEach(function (
        card
      ) {
        card.addEventListener(
          'click',
          function () {
            if (
              card.disabled
            ) {
              return;
            }
            state.colour =
              card.dataset.colour;
            state.stepDone.colour =
              true;
            saveProject();
            updateColour();
          }
        );
      });
    const colourBack =
      modal.querySelector(
        '[data-ld-colour-back]'
      );
    const colourNext =
      modal.querySelector(
        '[data-ld-colour-next]'
      );
    if (colourBack) {
      colourBack.addEventListener(
        'click',
        function () {
          showScreen(
            screens.finish
          );
        }
      );
    }
    if (colourNext) {
      colourNext.addEventListener(
        'click',
        function () {
          ensureCurrentColourValid();
          if (
            !state.colour
          ) {
            return;
          }
          state.stepDone.colour =
            true;
          saveProject();
          showScreen(
            screens.quantity
          );
          updateQuantity();
        }
      );
    }
    /* =====================================================
       QUANTITY EVENTS
       ===================================================== */
    const quantityMinus =
      modal.querySelector(
        '[data-ld-quantity-minus]'
      );
    const quantityPlus =
      modal.querySelector(
        '[data-ld-quantity-plus]'
      );
    const quantityBack =
      modal.querySelector(
        '[data-ld-quantity-back]'
      );
    const quantityNext =
      modal.querySelector(
        '[data-ld-quantity-next]'
      );
    if (quantityMinus) {
      quantityMinus.addEventListener(
        'click',
        function () {
          if (
            state.quantity <= 1
          ) {
            return;
          }
          state.quantity--;
          state.stepDone.review = false;
          state.stepDone.quantity =
            true;
          saveProject();
          updateQuantity();
          updateDriver();
          updateSensor();
          updateReview();
        }
      );
    }
    if (quantityPlus) {
      quantityPlus.addEventListener(
        'click',
        function () {
          if (
            state.quantity >= 36
          ) {
            return;
          }
          state.quantity++;
          state.stepDone.review = false;
          state.stepDone.quantity =
            true;
          saveProject();
          updateQuantity();
          updateDriver();
          updateSensor();
          updateReview();
        }
      );
    }
    if (quantityBack) {
      quantityBack.addEventListener(
        'click',
        function () {
          if (
            currentZone > 1 &&
            state.startMode ===
            'reuse' &&
            !state.completedOnce
          ) {
            renderZoneStart();
            showScreen(
              screens.zoneStart
            );
            return;
          }
          showScreen(
            screens.colour
          );
        }
      );
    }
    if (quantityNext) {
      quantityNext.addEventListener(
        'click',
        function () {
          state.stepDone.quantity =
            true;
          saveProject();
          updateQuantity();
          updateDriver();
          showScreen(
            screens.driver
          );
        }
      );
    }
    /* =====================================================
       DRIVER EVENTS
       ===================================================== */
    const ownDriverCheckbox =
      modal.querySelector(
        '[data-ld-own-driver]'
      );
    if (ownDriverCheckbox) {
      ownDriverCheckbox.addEventListener(
        'change',
        function () {
          state.ownDriver =
            ownDriverCheckbox.checked;
          state.ukPlug =
            false;
          state.stepDone.driver =
            true;
          if (
            state.ownDriver
          ) {
            state.sensor =
              '';
          } else {
            state.stepDone.sensor =
              false;
            state.stepDone.review =
              false;
          }
          closeSensorPopup();
          saveProject();
          updateDriver();
          updateSensor();
          updateReview();
        }
      );
    }
    const ukPlugCheckbox =
      modal.querySelector(
        '[data-ld-uk-plug]'
      );
    if (ukPlugCheckbox) {
      ukPlugCheckbox.addEventListener(
        'change',
        function () {
          state.ukPlug =
            state.ownDriver
              ? false
              : ukPlugCheckbox.checked;
          state.stepDone.driver =
            true;
          saveProject();
          updateDriver();
          updateSensor();
          updateReview();
        }
      );
    }
    const bareMainsOption =
      modal.querySelector(
        '[data-ld-bare-mains-option]'
      );
    if (bareMainsOption) {
      bareMainsOption.addEventListener(
        'click',
        function () {
          if (
            state.ownDriver
          ) {
            return;
          }
          state.ukPlug =
            false;
          state.stepDone.driver =
            true;
          if (ukPlugCheckbox) {
            ukPlugCheckbox.checked = false;
          }
          saveProject();
          updateDriver();
          updateSensor();
          updateReview();
        }
      );
    }
    const driverBack =
      modal.querySelector(
        '[data-ld-driver-back]'
      );
    const driverNext =
      modal.querySelector(
        '[data-ld-driver-next]'
      );
    if (driverBack) {
      driverBack.addEventListener(
        'click',
        function () {
          showScreen(
            screens.quantity
          );
          updateQuantity();
        }
      );
    }
    if (driverNext) {
      driverNext.addEventListener(
        'click',
        function () {
          state.stepDone.driver =
            true;
          saveProject();
          updateDriver();
          updateSensor();
          showScreen(
            screens.sensor
          );
        }
      );
    }
    /* =====================================================
       SENSOR EVENTS
       ===================================================== */
    modal
      .querySelectorAll(
        '.ld-sensor-card'
      )
      .forEach(function (
        card
      ) {
        card.addEventListener(
          'click',
          function () {
            if (
              state.ownDriver ||
              card.disabled
            ) {
              return;
            }
            const sensorKey =
              card.dataset.sensor;
            if (
              !sensorCompatibleFor(
                state,
                sensorKey
              )
            ) {
              return;
            }
            state.sensor =
              sensorKey;
            state.stepDone.sensor =
              true;
            state.stepDone.accessories =
              false;
            state.stepDone.review =
              false;
            saveProject();
            updateSensor();
            updateReview();
          }
        );
      });
    modal
      .querySelectorAll(
        '[data-ld-sensor-learn]'
      )
      .forEach(function (
        link
      ) {
        link.addEventListener(
          'click',
          function (
            event
          ) {
            event.preventDefault();
            event.stopPropagation();
            if (
              state.ownDriver
            ) {
              return;
            }
            openSensorPopup(
              link.dataset.ldSensorLearn
            );
          }
        );
      });
    if (sensorInfoOverlay) {
      sensorInfoOverlay.addEventListener(
        'click',
        closeSensorPopup
      );
    }
    if (sensorInfoClose) {
      sensorInfoClose.addEventListener(
        'click',
        closeSensorPopup
      );
    }
    if (sensorInfoDone) {
      sensorInfoDone.addEventListener(
        'click',
        closeSensorPopup
      );
    }
    const sensorBack =
      modal.querySelector(
        '[data-ld-sensor-back]'
      );
    const sensorNext =
      modal.querySelector(
        '[data-ld-sensor-next]'
      );
    if (sensorBack) {
      sensorBack.addEventListener(
        'click',
        function () {
          closeSensorPopup();
          showScreen(
            screens.driver
          );
          updateDriver();
        }
      );
    }
    if (sensorNext) {
      sensorNext.addEventListener(
        'click',
        function () {
          if (
            !state.ownDriver &&
            !state.sensor
          ) {
            return;
          }
          if (
            !state.ownDriver
          ) {
            state.stepDone.sensor =
              true;
          }
          closeSensorPopup();
          state.stepDone.accessories =
            false;
          state.stepDone.review =
            false;
          saveProject();
          openAccessories();
        }
      );
    }
    /* =====================================================
       ZONE NAME
       ===================================================== */
    const nameInput =
      modal.querySelector(
        '[data-ld-review-zone-name]'
      );
    if (nameInput) {
      nameInput.addEventListener(
        'input',
        function () {
          state.name =
            nameInput.value;
          saveProject();
          const title =
            modal.querySelector(
              '[data-ld-review-zone-title]'
            );
          if (title) {
            title.textContent =
              state.name.trim()
                ? state.name.trim()
                : 'Your Lighting Zone';
          }
          updateZoneShortcuts();
          updateStepNavigation();
        }
      );
    }
    /* =====================================================
       INSTALLATION GUIDE VIEWER
       ===================================================== */
    const installGuideOpenButton =
      modal.querySelector(
        '[data-ld-install-guide-open]'
      );
    const installGuideOverlay =
      modal.querySelector(
        '[data-ld-install-guide-overlay]'
      );
    const installGuideImage =
      modal.querySelector(
        '[data-ld-install-guide-image]'
      );
    const installGuideViewport =
      modal.querySelector(
        '[data-ld-install-guide-viewport]'
      );

    function installGuideIsOpen() {
      return !!(
        installGuideOverlay &&
        !installGuideOverlay.hidden
      );
    }

    function openInstallGuide() {
      if (!installGuideOverlay) {
        return;
      }

      installGuideOverlay.hidden =
        false;
      installGuideOverlay.classList.add(
        'is-open'
      );

      if (installGuideImage) {
        installGuideImage.classList.remove(
          'is-zoomed'
        );
      }
      if (installGuideViewport) {
        installGuideViewport.scrollTop =
          0;
        installGuideViewport.scrollLeft =
          0;
      }

      const closeButton =
        installGuideOverlay.querySelector(
          '.ld-install-guide-close'
        );
      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeInstallGuide() {
      if (!installGuideOverlay) {
        return;
      }

      installGuideOverlay.classList.remove(
        'is-open'
      );
      installGuideOverlay.hidden =
        true;

      if (installGuideImage) {
        installGuideImage.classList.remove(
          'is-zoomed'
        );
      }

      if (installGuideOpenButton) {
        installGuideOpenButton.focus();
      }
    }

    if (installGuideOpenButton) {
      installGuideOpenButton.addEventListener(
        'click',
        openInstallGuide
      );
    }

    if (installGuideOverlay) {
      installGuideOverlay
        .querySelectorAll(
          '[data-ld-install-guide-close]'
        )
        .forEach(function (
          button
        ) {
          button.addEventListener(
            'click',
            closeInstallGuide
          );
        });
    }

    if (installGuideImage) {
      installGuideImage.addEventListener(
        'click',
        function () {
          installGuideImage.classList.toggle(
            'is-zoomed'
          );
        }
      );
    }

    document.addEventListener(
      'keydown',
      function (
        event
      ) {
        if (
          event.key ===
            'Escape' &&
          installGuideIsOpen()
        ) {
          event.preventDefault();
          closeInstallGuide();
        }
      }
    );

    /* =====================================================
       REVIEW EVENTS
       ===================================================== */
    const reviewBack =
      modal.querySelector(
        '[data-ld-review-back]'
      );
    const reviewNext =
      modal.querySelector(
        '[data-ld-review-next]'
      );
    const reviewAddZone =
      modal.querySelector(
        '[data-ld-review-add-zone]'
      );

    function saveCurrentZoneFromReview() {
      if (
        !isStepComplete(
          state,
          'accessories'
        )
      ) {
        return false;
      }

      state.stepDone.review =
        true;
      state.completedOnce =
        true;

      state.accessories =
        deepClone(
          normaliseAccessories(
            accessories
          )
        );

      state.total =
        zoneTotalWithAccessoriesFor(
          state
        );

      saveProject();
      updateZoneShortcuts();
      return true;
    }

    if (reviewBack) {
      reviewBack.addEventListener(
        'click',
        function () {
          updateAccessoriesUI();
          showScreen(
            screens.accessories
          );
        }
      );
    }
    if (reviewNext) {
      reviewNext.addEventListener(
        'click',
        function () {
          if (!saveCurrentZoneFromReview()) {
            return;
          }
          renderProjectReview();
          clearCartStatus();
          resetFinalButton();
          showScreen(
            screens.projectReview
          );
        }
      );
    }
    if (reviewAddZone) {
      reviewAddZone.addEventListener(
        'click',
        function () {
          if (!saveCurrentZoneFromReview()) {
            return;
          }
          if (displayZoneCount() >= 6) {
            renderProjectReview();
            clearCartStatus();
            resetFinalButton();
            showScreen(
              screens.projectReview
            );
            return;
          }
          addNextZoneFromPrompt();
        }
      );
    }
    /* =====================================================
       ADDITIONAL ZONES
       ===================================================== */
    const addAnotherZone =
      modal.querySelector(
        '[data-ld-add-another-zone]'
      );
    if (addAnotherZone) {
      addAnotherZone.addEventListener(
        'click',
        addNextZoneFromPrompt
      );
    }
    const zoneMoreAccessories =
      modal.querySelector(
        '[data-ld-zone-more-accessories]'
      );
    if (zoneMoreAccessories) {
      zoneMoreAccessories.addEventListener(
        'click',
        function () {
          renderProjectReview();
          clearCartStatus();
          resetFinalButton();
          showScreen(
            screens.projectReview
          );
        }
      );
    }
    const zoneMoreBack =
      modal.querySelector(
        '[data-ld-zone-more-back]'
      );
    if (zoneMoreBack) {
      zoneMoreBack.addEventListener(
        'click',
        function () {
          const completed =
            completedZoneNumbers();
          const lastZone =
            completed.length
              ? completed[
                  completed.length - 1
                ]
              : 1;
          loadZone(
            lastZone
          );
          updateEverything();
          showScreen(
            isZoneComplete(
              state
            )
              ? screens.review
              : screenForStep(
                  furthestUnlockedStep(
                    state
                  )
                )
          );
        }
      );
    }
    /* =====================================================
       CABLE ROUTE PLANNER EVENTS
       ===================================================== */
    const cablePlannerRows =
      modal.querySelector(
        '[data-ld-cable-planner-rows]'
      );
    const cablePlannerApply =
      modal.querySelector(
        '[data-ld-cable-planner-apply]'
      );
    const driverLocationInput =
      modal.querySelector(
        '[data-ld-driver-location]'
      );

    if (cablePlannerRows) {
      cablePlannerRows.addEventListener(
        'input',
        function (
          event
        ) {
          const input =
            event.target.closest(
              '[data-ld-route-distance]'
            );

          if (!input) {
            return;
          }

          const index =
            Number(
              input.dataset
                .ldRouteDistance
            );

          if (
            !Number.isFinite(
              index
            )
          ) {
            return;
          }

          const plan =
            cablePlannerValuesForCurrentZone();
          const number =
            Number(
              input.value
            );

          plan[index] =
            (
              Number.isFinite(
                number
              ) &&
              number > 0
            )
              ? Math.round(
                  number * 100
                ) / 100
              : '';

          state.cablePlan =
            plan;

          const badge =
            cablePlannerRows.querySelector(
              '[data-ld-route-recommendation="' +
              index +
              '"]'
            );
          const recommendation =
            cableRecommendationForDistance(
              state,
              plan[index]
            );

          if (badge) {
            badge.textContent =
              recommendation.label;
            badge.classList.remove(
              'is-warning',
              'is-muted',
              'is-ok'
            );
            badge.classList.add(
              recommendation.key ===
                'over'
                ? 'is-warning'
                : recommendation.key ===
                    'unmeasured'
                  ? 'is-muted'
                  : 'is-ok'
            );
          }

          projectZones[
            String(
              currentZone
            )
          ] =
            state;
          sessionStorage.setItem(
            PROJECT_KEY,
            JSON.stringify(
              projectZones
            )
          );

          updateCablePlannerSummary();
        }
      );
    }

    if (driverLocationInput) {
      driverLocationInput.addEventListener(
        'input',
        function () {
          state.driverLocation =
            cleanDriverLocation(
              driverLocationInput.value
            );
          projectZones[
            String(
              currentZone
            )
          ] =
            state;
          sessionStorage.setItem(
            PROJECT_KEY,
            JSON.stringify(
              projectZones
            )
          );
        }
      );
    }

    if (cablePlannerApply) {
      cablePlannerApply.addEventListener(
        'click',
        function () {
          if (
            cablePlannerApply.disabled
          ) {
            return;
          }

          accessories.extension2 =
            Math.max(
              0,
              Number(
                cablePlannerApply.dataset
                  .ldExtension2Count || 0
              )
            );
          accessories.extension5 =
            Math.max(
              0,
              Number(
                cablePlannerApply.dataset
                  .ldExtension5Count || 0
              )
            );

          state.accessories =
            deepClone(
              accessories
            );

          updateAccessoriesUI();

          const result =
            modal.querySelector(
              '[data-ld-cable-planner-result]'
            );
          if (result) {
            result.innerHTML =
              '<strong>Applied to your accessories.</strong> ' +
              'The extension quantities below now match the measured light routes.';
          }
        }
      );
    }

    /* =====================================================
       ACCESSORY COUNTERS
       ===================================================== */
    [
      'extension2',
      'extension5',
      'wago2',
      'wago3'
    ]
      .forEach(function (
        key
      ) {
        const minus =
          modal.querySelector(
            '[data-ld-accessory-minus="' +
            key +
            '"]'
          );
        const plus =
          modal.querySelector(
            '[data-ld-accessory-plus="' +
            key +
            '"]'
          );
        if (minus) {
          minus.addEventListener(
            'click',
            function () {
              accessories[
                key
              ] =
                Math.max(
                  0,
                  Number(
                    accessories[
                      key
                    ] || 0
                  ) - 1
                );
              updateAccessoriesUI();
            }
          );
        }
        if (plus) {
          plus.addEventListener(
            'click',
            function () {
              if (
                key ===
                'extension2' ||
                key ===
                'extension5'
              ) {
                if (
                  accessories.extension2 +
                  accessories.extension5 >=
                  Math.max(
                    1,
                    Number(
                      state.quantity || 1
                    )
                  )
                ) {
                  return;
                }
              }
              accessories[
                key
              ] =
                Math.min(
                  99,
                  Number(
                    accessories[
                      key
                    ] || 0
                  ) + 1
                );
              updateAccessoriesUI();
            }
          );
        }
      });
    /* =====================================================
       ACCESSORIES NAVIGATION
       ===================================================== */
    const accessoriesBack =
      modal.querySelector(
        '[data-ld-accessories-back]'
      );
    if (accessoriesBack) {
      accessoriesBack.addEventListener(
        'click',
        function () {
          showScreen(
            screens.sensor
          );
          updateSensor();
        }
      );
    }
    const accessoriesNext =
      modal.querySelector(
        '[data-ld-accessories-next]'
      );
    if (accessoriesNext) {
      accessoriesNext.addEventListener(
        'click',
        function () {
          updateAccessoriesUI();

          const selectedExtensions =
            Number(
              accessories.extension2 || 0
            ) +
            Number(
              accessories.extension5 || 0
            );
          const allowedExtensions =
            Math.max(
              1,
              Number(
                state.quantity || 1
              )
            );

          if (
            selectedExtensions >
            allowedExtensions
          ) {
            return;
          }

          state.stepDone.accessories =
            true;
          state.stepDone.review =
            false;
          saveProject();

          if (
            displayZoneCount() === 1 &&
            currentZone === 1
          ) {
            if (!saveCurrentZoneFromReview()) {
              return;
            }

            renderProjectReview();
            clearCartStatus();
            resetFinalButton();
            showScreen(
              screens.projectReview
            );
            return;
          }

          updateReview();
          showScreen(
            screens.review
          );
        }
      );
    }
    /* =====================================================
       PROJECT REVIEW NAVIGATION
       ===================================================== */
    const projectReviewBack =
      modal.querySelector(
        '[data-ld-project-review-back]'
      );
    if (projectReviewBack) {
      projectReviewBack.addEventListener(
        'click',
        function () {
          closeProjectHelp();
          const completed =
            completedZoneNumbers();
          const targetZone =
            completed.indexOf(currentZone) !== -1
              ? currentZone
              : (
                  completed.length
                    ? completed[completed.length - 1]
                    : 1
                );
          loadZone(
            targetZone
          );
          updateEverything();

          if (
            completed.length === 1 &&
            displayZoneCount() === 1
          ) {
            updateAccessoriesUI();
            showScreen(
              screens.accessories
            );
            return;
          }

          showScreen(
            screens.review
          );
        }
      );
    }
    const projectReviewAddZone =
      modal.querySelector(
        '[data-ld-project-add-zone]'
      );
    if (projectReviewAddZone) {
      projectReviewAddZone.addEventListener(
        'click',
        function () {
          closeProjectHelp();
          addNextZoneFromPrompt();
        }
      );
    }
    if (finalAddButton) {
      finalAddButton.addEventListener(
        'click',
        addProjectToCart
      );
    }
    /* =====================================================
       QUANTITY HELP MODAL
       ===================================================== */
    const quantityHelpButton =
      modal.querySelector(
        '[data-ld-quantity-help-button]'
      );

    const quantityHelpPanel =
      modal.querySelector(
        '[data-ld-quantity-help-panel]'
      );

    const quantityHelpDialog =
      modal.querySelector(
        '[data-ld-quantity-guide-dialog]'
      );

    const quantityHelpCloseButtons =
      modal.querySelectorAll(
        '[data-ld-quantity-help-close]'
      );

    const runLengthInput =
      modal.querySelector(
        '[data-ld-run-length]'
      );
    const runEstimate =
      modal.querySelector(
        '[data-ld-run-estimate]'
      );

    function updateRunEstimate() {
      if (
        !runLengthInput ||
        !runEstimate
      ) {
        return;
      }

      const runLength =
        Number(
          runLengthInput.value || 0
        );

      if (
        !Number.isFinite(
          runLength
        ) ||
        runLength < 250
      ) {
        runEstimate.textContent =
          'Enter your run length to get a starting estimate.';
        return;
      }

      const lowerEstimate =
        Math.max(
          1,
          Math.ceil(
            runLength / 300
          )
        );
      const upperEstimate =
        Math.max(
          lowerEstimate,
          Math.ceil(
            runLength / 250
          )
        );
      const zoneLimit =
        36;
      const exceedsOneZone =
        lowerEstimate >
          zoneLimit;
      const canExceedOneZone =
        upperEstimate >
          zoneLimit;

      runEstimate.classList.toggle(
        'is-over-zone-limit',
        canExceedOneZone
      );

      if (exceedsOneZone) {
        const minimumZones =
          Math.ceil(
            upperEstimate /
            zoneLimit
          );

        runEstimate.innerHTML =
          '<strong>Estimated starting range: ' +
          lowerEstimate +
          '–' +
          upperEstimate +
          ' lights.</strong> ' +
          'That is more than the 36-light maximum for one independently controlled zone. ' +
          'Plan at least ' +
          minimumZones +
          ' zones if separate control is suitable. ' +
          'If you need the whole run to operate together, contact us before ordering so we can help plan the system.';
        return;
      }

      if (canExceedOneZone) {
        runEstimate.innerHTML =
          '<strong>Start with around ' +
          lowerEstimate +
          '–' +
          upperEstimate +
          ' lights.</strong> ' +
          'The denser end of that range exceeds the 36-light maximum for one zone. ' +
          'Use the layout guide to decide whether one zone is enough, or plan another zone/contact us if you need more than 36 lights.';
        return;
      }

      runEstimate.innerHTML =
        lowerEstimate ===
          upperEstimate
          ? (
              '<strong>Start with around ' +
              lowerEstimate +
              (
                lowerEstimate === 1
                  ? ' light'
                  : ' lights'
              ) +
              '.</strong> Then use the layout guide below to fine-tune the positions.'
            )
          : (
              '<strong>Start with around ' +
              lowerEstimate +
              '–' +
              upperEstimate +
              ' lights.</strong> Use the lower end for a softer effect or the upper end for more continuous task lighting.'
            );
    }

    if (runLengthInput) {
      runLengthInput.addEventListener(
        'input',
        updateRunEstimate
      );
    }

    let quantityHelpReturnFocus =
      null;


    function quantityHelpOpen() {
      return Boolean(
        quantityHelpPanel &&
        !quantityHelpPanel.hidden
      );
    }


    function openQuantityHelp() {

      if (
        !quantityHelpPanel
      ) {
        return;
      }


      quantityHelpReturnFocus =
        document.activeElement;


      quantityHelpPanel.hidden =
        false;


      modal.classList.add(
        'is-quantity-guide-open'
      );


      if (
        quantityHelpDialog
      ) {

        window.requestAnimationFrame(
          function () {
            quantityHelpDialog.focus();
          }
        );

      }

    }


    function closeQuantityHelp() {

      if (
        !quantityHelpPanel
      ) {
        return;
      }


      quantityHelpPanel.hidden =
        true;


      modal.classList.remove(
        'is-quantity-guide-open'
      );


      if (
        quantityHelpReturnFocus &&
        typeof quantityHelpReturnFocus.focus ===
          'function'
      ) {

        quantityHelpReturnFocus.focus();

      }


      quantityHelpReturnFocus =
        null;

    }


    if (
      quantityHelpButton &&
      quantityHelpPanel
    ) {

      quantityHelpButton.addEventListener(
        'click',
        openQuantityHelp
      );


      quantityHelpCloseButtons
        .forEach(function (
          closeButton
        ) {

          closeButton.addEventListener(
            'click',
            closeQuantityHelp
          );

        });

    }


    /* =====================================================
       EXTENSION HELP MODAL
       ===================================================== */
    const extensionHelpButton =
      modal.querySelector(
        '[data-ld-extension-help-button]'
      );

    const extensionHelpPanel =
      modal.querySelector(
        '[data-ld-extension-help-panel]'
      );

    const extensionHelpDialog =
      modal.querySelector(
        '[data-ld-extension-guide-dialog]'
      );

    const extensionHelpCloseButtons =
      modal.querySelectorAll(
        '[data-ld-extension-help-close]'
      );

    let extensionHelpReturnFocus =
      null;


    function extensionHelpOpen() {
      return Boolean(
        extensionHelpPanel &&
        !extensionHelpPanel.hidden
      );
    }


    function openExtensionHelp() {

      if (
        !extensionHelpPanel
      ) {
        return;
      }


      extensionHelpReturnFocus =
        document.activeElement;

      extensionHelpPanel.hidden =
        false;

      renderCableRoutePlanner();

      modal.classList.add(
        'is-extension-guide-open'
      );


      if (
        extensionHelpDialog
      ) {
        window.requestAnimationFrame(
          function () {
            extensionHelpDialog.focus();
          }
        );
      }

    }


    function closeExtensionHelp() {

      if (
        !extensionHelpPanel
      ) {
        return;
      }


      extensionHelpPanel.hidden =
        true;

      modal.classList.remove(
        'is-extension-guide-open'
      );


      if (
        extensionHelpReturnFocus &&
        typeof extensionHelpReturnFocus.focus ===
          'function'
      ) {
        extensionHelpReturnFocus.focus();
      }


      extensionHelpReturnFocus =
        null;

    }


    if (
      extensionHelpButton &&
      extensionHelpPanel
    ) {

      extensionHelpButton.addEventListener(
        'click',
        openExtensionHelp
      );


      extensionHelpCloseButtons
        .forEach(function (
          closeButton
        ) {
          closeButton.addEventListener(
            'click',
            closeExtensionHelp
          );
        });

    }


    /* =====================================================
       COLOUR HELP MODAL
       ===================================================== */
    const colourHelpButton =
      modal.querySelector(
        '[data-ld-colour-help-button]'
      );

    const colourHelpPanel =
      modal.querySelector(
        '[data-ld-colour-help-panel]'
      );

    const colourHelpDialog =
      modal.querySelector(
        '[data-ld-colour-guide-dialog]'
      );

    const colourHelpCloseButtons =
      modal.querySelectorAll(
        '[data-ld-colour-help-close]'
      );

    let colourHelpReturnFocus =
      null;


    function colourHelpOpen() {
      return Boolean(
        colourHelpPanel &&
        !colourHelpPanel.hidden
      );
    }


    function openColourHelp() {

      if (
        !colourHelpPanel
      ) {
        return;
      }


      colourHelpReturnFocus =
        document.activeElement;


      colourHelpPanel.hidden =
        false;


      modal.classList.add(
        'is-colour-guide-open'
      );


      if (
        colourHelpDialog
      ) {

        window.requestAnimationFrame(
          function () {
            colourHelpDialog.focus();
          }
        );

      }

    }


    function closeColourHelp() {

      if (
        !colourHelpPanel
      ) {
        return;
      }


      colourHelpPanel.hidden =
        true;


      modal.classList.remove(
        'is-colour-guide-open'
      );


      if (
        colourHelpReturnFocus &&
        typeof colourHelpReturnFocus.focus ===
          'function'
      ) {

        colourHelpReturnFocus.focus();

      }


      colourHelpReturnFocus =
        null;

    }


    if (
      colourHelpButton &&
      colourHelpPanel
    ) {

      colourHelpButton.addEventListener(
        'click',
        openColourHelp
      );


      colourHelpCloseButtons
        .forEach(function (
          closeButton
        ) {

          closeButton.addEventListener(
            'click',
            closeColourHelp
          );

        });

    }

    /* =====================================================
       ESCAPE
       ===================================================== */
    document.addEventListener(
      'keydown',
      function (
        event
      ) {
        if (
          event.key !==
          'Escape'
        ) {
          return;
        }
        if (
          extensionHelpOpen()
        ) {
          closeExtensionHelp();
          return;
        }
        if (
          colourHelpOpen()
        ) {
          closeColourHelp();
          return;
        }
        if (
          quantityHelpOpen()
        ) {
          closeQuantityHelp();
          return;
        }
        if (
          projectHelpOpen()
        ) {
          closeProjectHelp();
          return;
        }
        if (
          sensorPopupOpen()
        ) {
          closeSensorPopup();
          return;
        }
        if (
          modal.classList.contains(
            'is-open'
          )
        ) {
          closeBuilder();
        }
      }
    );

    function refreshCurrentSummary() {
      const product = selectedLightProduct(state);
      if (!product) {
        modal.querySelectorAll('[data-ld-compact-summary]').forEach(el => { el.hidden = true; });
        return;
      }
      const total = zoneTotalWithAccessoriesFor(state);
      const projectTotal = completedProjectTotal(currentZone) + total;
      modal.querySelectorAll('[data-ld-quantity-project-total], [data-ld-driver-project-total], [data-ld-sensor-project-total], [data-ld-accessories-project-total], [data-ld-review-project-total]').forEach(el => el.textContent = money(projectTotal));
      modal.querySelectorAll('[data-ld-quantity-total-note], [data-ld-driver-total-note], [data-ld-sensor-total-note]').forEach(el => el.textContent = 'Includes matched driver, required blocks and current selections');
      const driverTotal = modal.querySelector('[data-ld-zone-total-price]');
      if (driverTotal) driverTotal.textContent = money(total);
      const noSensor = modal.querySelector('[data-sensor="none"] p');
      if (noSensor) noSensor.textContent = state.ukPlug
        ? 'Switch the whole zone on or off at the socket. No separate sensor is needed. This route is on/off only; the supplied driver must not be connected to a mains dimmer.'
        : 'Use your standard wall light switch for on/off control. An electrician connects the supplied 24V driver to the switched supply. The supplied driver must not be connected to a mains wall dimmer.';
      const active = modal.querySelector('.ld-screen.is-active');

      /* Keep configuration screens free of the legacy compact project-price
         bar. The dedicated totals within each step are clearer. The compact
         summary is reserved for Review only. */
      modal
        .querySelectorAll(
          '[data-ld-compact-summary]'
        )
        .forEach(function (
          compactSummary
        ) {
          compactSummary.hidden =
            true;
        });

      const compactSummaryScreens = [].filter(Boolean);

      if (
        active &&
        compactSummaryScreens.includes(
          active
        )
      ) {

        let summary =
          active.querySelector(
            '[data-ld-compact-summary]'
          );

        if (!summary) {

          summary =
            document.createElement(
              'div'
            );

          summary.className =
            'ld-compact-summary';

          summary.dataset.ldCompactSummary =
            '';

          const stepNavigation =
            active.querySelector(
              '[data-ld-step-navigation]'
            );

          if (stepNavigation) {
            stepNavigation.after(
              summary
            );
          }

        }

        if (summary) {

          summary.hidden =
            false;

          summary.textContent =
            state.quantity +
            ' × ' +
            styleName(
              state.style
            ) +
            ' · ' +
            finishName(
              state.finish
            ) +
            ' · ' +
            colourName(
              state.colour
            ) +
            ' | Zone ' +
            currentZone +
            ': ' +
            money(
              total
            ) +
            ' | Project so far: ' +
            money(
              projectTotal
            ) +
            ' incl. VAT';

        }

      }
    }
    function projectReadyForCart() {
      return Object.keys(projectZones).filter(key => zoneIsActiveInProject(Number(key)))
        .every(key => isZoneComplete(normaliseZone(Number(key))));
    }
    function focusActiveScreen() {
      const screen = modal.querySelector('.ld-screen.is-active');
      const heading = screen && screen.querySelector('h2');
      if (heading && modal.classList.contains('is-open')) {
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      }
    }
    function measureFooter() {
      const footer = modal.querySelector('.ld-screen.is-active > .ld-builder-footer');
      if (footer) modal.style.setProperty('--ld-footer-height', Math.ceil(footer.getBoundingClientRect().height) + 'px');
    }
    if (typeof ResizeObserver !== 'undefined') {
      const footerObserver = new ResizeObserver(measureFooter);
      modal.querySelectorAll('.ld-builder-footer').forEach(footer => footerObserver.observe(footer));
    }
    window.addEventListener('resize', measureFooter);
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Lighting Project Builder');
    modal.addEventListener('keydown', function(event) {
      if (event.key !== 'Tab') return;
      const scope =
        extensionHelpOpen()
          ? extensionHelpDialog
          : colourHelpOpen()
            ? colourHelpDialog
            : quantityHelpOpen()
              ? quantityHelpDialog
              : projectHelpOpen()
                ? modal.querySelector('[data-ld-project-help-modal]')
                : sensorPopupOpen()
                  ? sensorInfoModal
                  : modal;
      if (!scope) return;
      const controls = Array.from(scope.querySelectorAll('button, input, select, textarea, a[href], summary, [tabindex="0"]'))
        .filter(el => !el.disabled && el.getClientRects().length && !el.closest('[hidden]'));
      if (!controls.length) return;
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    // Informational controls inside a choice card must not select the card.
    modal.querySelectorAll('[data-ld-sensor-learn]').forEach(control => {
      control.tabIndex = 0;
      control.setAttribute('role', 'button');
      control.setAttribute('aria-label', 'Learn about ' + sensorName(control.dataset.ldSensorLearn));
      control.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault(); event.stopPropagation(); control.click();
        }
      });
    });

    /* =====================================================
       INITIAL UI
       ===================================================== */
    prepareSensorProductImages();
    saveProject();
    saveAccessories();
    updateDynamicLabels();
    updateZoneCountScreen();
    updateProjectNameDisplay();
    updateProjectIdentityFields();
    updateStyle();
    updateFinish();
    updateColour();
    updateZoneShortcuts();
    updateStepNavigation();
    resetFinalButton();
    /* =====================================================
       AUTO-OPEN WHEN EDITING A BASKET PROJECT
       ===================================================== */
    if (
      editingProjectId
    ) {
      sessionStorage.setItem(
        PROJECT_KEY,
        JSON.stringify(
          projectZones
        )
      );
      sessionStorage.setItem(
        'ldZoneCount',
        zoneCount
      );
      sessionStorage.setItem(
        HIGHEST_ZONE_KEY,
        String(
          highestReached
        )
      );
      saveAccessories();
      saveProjectName();
      updateProjectNameDisplay();
      modal.classList.add(
        'is-open'
      );
      overlay.classList.add(
        'is-open'
      );
      document.body.style.overflow =
        'hidden';
      updateEverything();
      updateAccessoriesUI();
      renderProjectReview();
      resetFinalButton();
      showScreen(
        screens.projectReview
      );
    }
  }
});
